{
  "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
  "bflc": "http://id.loc.gov/ontologies/bflc/",
  "foaf": "http://xmlns.com/foaf/0.1/",
  "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "dbo": "http://dbpedia.org/ontology/",
  "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
  "yago": "http://yago-knowledge.org/resource/",
  "dc": "http://purl.org/dc/elements/1.1/",
  "dbp": "http://dbpedia.org/property/",
  "owl": "http://www.w3.org/2002/07/owl#",
  "skos": "http://www.w3.org/2004/02/skos/core#",
  "gr": "http://purl.org/goodrelations/v1#",
  "geo": "http://www.opengis.net/ont/geosparql#",
  "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "xsd": "http://www.w3.org/2001/XMLSchema#",
  "org": "http://www.w3.org/ns/org#",
  "dcat": "http://www.w3.org/ns/dcat#",
  "ex": "http://example.org/",
  "dct": "http://purl.org/dc/terms/",
  "dcterms": "http://purl.org/dc/terms/",
  "qb": "http://purl.org/linked-data/cube#",
  "prov": "http://www.w3.org/ns/prov#",
  "sioc": "http://rdfs.org/sioc/ns#",
  "xtypes": "http://purl.org/xtypes/",
  "dbpedia": "http://dbpedia.org/resource/",
  "void": "http://rdfs.org/ns/void#",
  "ont": "http://purl.org/net/ns/ontology-annot#",
  "onto": "http://www.ontotext.com/",
  "sio": "http://semanticscience.org/resource/",
  "obo": "http://purl.obolibrary.org/obo/",
  "dcterm": "http://purl.org/dc/terms/",
  "schema": "http://schema.org/",
  "bf": "http://id.loc.gov/ontologies/bibframe/",
  "search": "http://sindice.com/vocab/search#",
  "sd": "http://www.w3.org/ns/sparql-service-description#",
  "urn": "http://fliqz.com/",
  "frbr": "http://purl.org/vocab/frbr/core#",
  "stat": "http://www.w3.org/ns/posix/stat#",
  "vcard": "http://www.w3.org/2006/vcard/ns#",
  "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "commerce": "http://purl.org/commerce#",
  "dbr": "http://dbpedia.org/resource/",
  "bibo": "http://purl.org/ontology/bibo/",
  "ttp": "http://eample.com/test#",
  "pto": "http://www.productontology.org/id/",
  "rss": "http://purl.org/rss/1.0/",
  "oo": "http://purl.org/openorg/",
  "gldp": "http://www.w3.org/ns/people#",
  "vann": "http://purl.org/vocab/vann/",
  "geonames": "http://www.geonames.org/ontology#",
  "content": "http://purl.org/rss/1.0/modules/content/",
  "fb": "http://rdf.freebase.com/ns/",
  "event": "http://purl.org/NET/c4dm/event.owl#",
  "gen": "http://purl.org/gen/0.1#",
  "wd": "http://www.wikidata.org/entity/",
  "dcmit": "http://purl.org/dc/dcmitype/",
  "cc": "http://creativecommons.org/ns#",
  "dbpprop": "http://dbpedia.org/property/",
  "http": "http://www.w3.org/2011/http#",
  "doap": "http://usefulinc.com/ns/doap#",
  "rr": "http://www.w3.org/ns/r2rml#",
  "swrc": "http://swrc.ontoware.org/ontology#",
  "as": "https://www.w3.org/ns/activitystreams#",
  "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
  "leaks": "https://cuzin.com/",
  "sc": "https://schema.org/",
  "md": "http://www.w3.org/ns/md#",
  "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
  "fn": "http://www.w3.org/2005/xpath-functions#",
  "cv": "http://rdfs.org/resume-rdf/",
  "wot": "http://xmlns.com/wot/0.1/",
  "prog": "http://purl.org/prog/",
  "aiiso": "http://purl.org/vocab/aiiso/schema#",
  "ma": "http://www.w3.org/ns/ma-ont#",
  "uniprot": "http://purl.uniprot.org/uniprot/",
  "tl": "http://purl.org/NET/c4dm/timeline.owl#",
  "daia": "http://purl.org/ontology/daia/",
  "swc": "http://data.semanticweb.org/ns/swc/ontology#",
  "akt": "http://www.aktors.org/ontology/portal#",
  "xhtml": "http://www.w3.org/1999/xhtml#",
  "ical": "http://www.w3.org/2002/12/cal/ical#",
  "crm": "http://www.cidoc-crm.org/cidoc-crm/",
  "rel": "http://purl.org/vocab/relationship/",
  "bio": "http://purl.org/vocab/bio/0.1/",
  "earl": "http://www.w3.org/ns/earl#",
  "unit": "http://qudt.org/vocab/unit/",
  "dv": "http://rdf.data-vocabulary.org/#",
  "mo": "http://purl.org/ontology/mo/",
  "ov": "http://open.vocab.org/terms/",
  "marcrel": "http://id.loc.gov/vocabulary/relators/",
  "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "xhv": "http://www.w3.org/1999/xhtml/vocab#",
  "cs": "http://purl.org/vocab/changeset/schema#",
  "afn": "http://jena.apache.org/ARQ/function#",
  "ad": "http://schemas.talis.com/2005/address/schema#",
  "co": "http://purl.org/ontology/co/core#",
  "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "dc11": "http://purl.org/dc/elements/1.1/",
  "og": "http://opengraphprotocol.org/schema/",
  "xs": "http://www.w3.org/2001/XMLSchema#",
  "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
  "mu": "http://mu.semte.ch/vocabularies/core/",
  "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
  "test2": "http://this.invalid/test2#",
  "xfn": "http://gmpg.org/xfn/11#",
  "book": "http://purl.org/NET/book/vocab#",
  "log": "http://www.w3.org/2000/10/swap/log#",
  "musim": "http://purl.org/ontology/similarity/",
  "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
  "media": "http://search.yahoo.com/searchmonkey/media/",
  "dcq": "http://purl.org/dc/qualifiers/1.0/",
  "ome": "http://purl.org/ontomedia/core/expression#",
  "xf": "http://www.w3.org/2002/xforms/",
  "cld": "http://purl.org/cld/terms/",
  "qudt": "http://qudt.org/schema/qudt/",
  "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
  "prop": "http://dbpedia.org/property/",
  "cal": "http://www.w3.org/2002/12/cal/ical#",
  "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "biblio": "http://purl.org/net/biblio#",
  "reco": "http://purl.org/reco#",
  "rev": "http://purl.org/stuff/rev#",
  "sism": "http://purl.oclc.org/NET/sism/0.1/",
  "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
  "days": "http://ontologi.es/days#",
  "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
  "botany": "http://purl.org/NET/biol/botany#",
  "af": "http://purl.org/ontology/af/",
  "rif": "http://www.w3.org/2007/rif#",
  "ctag": "http://commontag.org/ns#",
  "dir": "http://schemas.talis.com/2005/dir/schema#",
  "ok": "http://okkam.org/terms#",
  "tzont": "http://www.w3.org/2006/timezone#",
  "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
  "sr": "http://www.openrdf.org/config/repository/sail#",
  "math": "http://www.w3.org/2000/10/swap/math#",
  "pc": "http://purl.org/procurement/public-contracts#",
  "admin": "http://webns.net/mvcb/",
  "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
  "giving": "http://ontologi.es/giving#",
  "sdmx": "http://purl.org/linked-data/sdmx#",
  "myspace": "http://purl.org/ontology/myspace#",
  "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
  "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
  "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
  "xmp": "http://ns.adobe.com/xap/1.0/",
  "lyou": "http://purl.org/linkingyou/",
  "swanq": "http://purl.org/swan/1.2/qualifiers/",
  "time": "http://www.w3.org/2006/time#",
  "jdbc": "http://d2rq.org/terms/jdbc/",
  "owlim": "http://www.ontotext.com/trree/owlim#",
  "omn": "http://open-multinet.info/ontology/omn#",
  "swande": "http://purl.org/swan/1.2/discourse-elements/",
  "dcam": "http://purl.org/dc/dcam/",
  "gn": "http://www.geonames.org/ontology#",
  "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
  "skosxl": "http://www.w3.org/2008/05/skos-xl#",
  "con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "cyc": "http://sw.opencyc.org/concept/",
  "adms": "http://www.w3.org/ns/adms#",
  "oa": "http://www.w3.org/ns/oa#",
  "cdm": "http://publications.europa.eu/ontology/cdm#",
  "gvp": "http://vocab.getty.edu/ontology#",
  "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
  "ontology": "http://dbpedia.org/ontology/",
  "sh": "http://www.w3.org/ns/shacl#",
  "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "db": "http://dbpedia.org/",
  "type": "http://teste.com/teste/",
  "om": "http://opendata.caceres.es/def/ontomunicipio#",
  "isbd": "http://iflastandards.info/ns/isbd/elements/",
  "eat": "http://www.eat.rl.ac.uk/#",
  "lemon": "http://lemon-model.net/lemon#",
  "photoshop": "http://ns.adobe.com/photoshop/1.0/",
  "aat": "http://vocab.getty.edu/aat/",
  "wfs": "http://schemas.opengis.net/wfs/",
  "room": "http://vocab.deri.ie/rooms#",
  "wdt": "http://www.wikidata.org/prop/direct/",
  "tgn": "http://vocab.getty.edu/tgn/",
  "exif": "http://www.w3.org/2003/12/exif/ns#",
  "fabio": "http://purl.org/spar/fabio/",
  "ulan": "http://vocab.getty.edu/ulan/",
  "ac": "http://umbel.org/umbel/ac/",
  "test": "https://test4.example.com/",
  "ore": "http://www.openarchives.org/ore/terms/",
  "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
  "prism": "http://prismstandard.org/namespaces/basic/2.0/",
  "cert": "http://www.w3.org/ns/auth/cert#",
  "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
  "core": "http://vivoweb.org/ontology/core#",
  "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
  "nsogi": "http://prefix.cc/nsogi:",
  "cnt": "http://www.w3.org/2011/content#",
  "fise": "http://fise.iks-project.eu/ontology/",
  "sf": "http://www.opengis.net/ont/sf#",
  "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
  "lv": "http://purl.org/lobid/lv#",
  "voaf": "http://purl.org/vocommons/voaf#",
  "swrl": "http://www.w3.org/2003/11/swrl#",
  "edm": "http://www.europeana.eu/schemas/edm/",
  "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
  "eg": "http://www.example.org/",
  "gndo": "http://d-nb.info/standards/elementset/gnd#",
  "gtfs": "http://vocab.gtfs.org/terms#",
  "dbc": "http://dbpedia.org/resource/Category:",
  "ro": "http://purl.org/wf4ever/ro#",
  "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
  "ssn": "http://www.w3.org/ns/ssn/",
  "xml": "http://www.w3.org/XML/1998/namespace/",
  "swrlb": "http://www.w3.org/2003/11/swrlb#",
  "music": "http://musicontology.com/",
  "movie": "http://data.linkedmdb.org/resource/movie/",
  "bif": "http://www.openlinksw.com/schemas/bif#",
  "wikidata": "http://www.wikidata.org/entity/",
  "leak": "http://maco.com/",
  "go": "http://purl.obolibrary.org/obo/GO_",
  "wp": "http://vocabularies.wikipathways.org/",
  "dbprop": "http://dbpedia.org/property/",
  "pat": "http://purl.org/hpi/patchr#",
  "ceo": "https://linkeddata.cultureelerfgoed.nl/def/ceo#",
  "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
  "ping": "https://namso-gen.com/",
  "dbkwik": "http://dbkwik.webdatacommons.org/",
  "penn": "http://purl.org/olia/penn.owl#",
  "loc": "http://id.loc.gov/",
  "am": "http://vocab.deri.ie/am#",
  "sp": "http://spinrdf.org/sp#",
  "st": "http://ns.inria.fr/sparql-template/",
  "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
  "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
  "ldp": "http://www.w3.org/ns/ldp#",
  "mods": "http://www.loc.gov/mods/v3#",
  "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
  "sec": "https://w3id.org/security#",
  "bd": "http://www.bigdata.com/rdf#",
  "dce": "http://purl.org/dc/elements/1.1/",
  "chebi": "http://purl.obolibrary.org/obo/CHEBI_",
  "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
  "product": "http://purl.org/commerce/product#",
  "sdo": "https://schema.org/",
  "example": "http://www.example.org/rdf#",
  "imm": "http://schemas.microsoft.com/imm/",
  "siocserv": "http://rdfs.org/sioc/services#",
  "geoes": "http://geo.linkeddata.es/ontology/",
  "sparql": "http://www.w3.org/ns/sparql#",
  "up": "http://purl.uniprot.org/core/",
  "sioct": "http://rdfs.org/sioc/types#",
  "gnd": "http://d-nb.info/gnd/",
  "cerif": "http://spi-fm.uca.es/neologism/cerif#",
  "rec": "http://purl.org/ontology/rec/core#",
  "ptr": "http://www.w3.org/2009/pointers#",
  "list": "http://www.w3.org/2000/10/swap/list#",
  "gd": "http://rdf.data-vocabulary.org/#",
  "coref": "http://www.rkbexplorer.com/ontologies/coref#",
  "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "scovo": "http://purl.org/NET/scovo#",
  "whois": "http://www.kanzaki.com/ns/whois#",
  "api": "http://purl.org/linked-data/api/vocab#",
  "java": "http://www.w3.org/2007/uwa/context/java.owl#",
  "spin": "http://spinrdf.org/spin#",
  "acc": "http://purl.org/NET/acc#",
  "olia": "http://purl.org/olia/olia.owl#",
  "sirext": "http://t.me/sirextt/247:",
  "wiki": "http://en.wikipedia.org/wiki/",
  "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
  "space": "http://www.w3.org/ns/pim/space#",
  "cube": "https://cube.link/",
  "euvoc": "http://publications.europa.eu/ontology/euvoc#",
  "ms": "http://purl.org/obo/owl/MS#",
  "opm": "https://w3id.org/opm#",
  "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
  "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
  "gold": "http://purl.org/linguistics/gold/",
  "geof": "http://www.opengis.net/def/function/geosparql/",
  "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
  "dbnary": "http://kaiko.getalp.org/dbnary#",
  "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
  "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "lgd": "http://linkedgeodata.org/triplify/",
  "rdfsharp": "https://rdfsharp.codeplex.com/",
  "iot": "http://iotschema.org/",
  "pext": "http://www.ontotext.com/proton/protonext#",
  "bing": "http://bing.com/schema/media/",
  "vivo": "http://vivoweb.org/ontology/core#",
  "sim": "http://www.w3id.org/simulation/ontology/",
  "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
  "hg": "http://rdf.histograph.io/",
  "bp": "http://www.biopax.org/release/biopax-level3.owl#",
  "rsa": "http://www.w3.org/ns/auth/rsa#",
  "po": "http://purl.org/ontology/po/",
  "akts": "http://www.aktors.org/ontology/support#",
  "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
  "pim": "http://www.w3.org/ns/pim/space#",
  "georss": "http://www.georss.org/georss/",
  "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
  "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "acl": "http://www.w3.org/ns/auth/acl#",
  "geosparql": "http://www.opengis.net/ont/geosparql#",
  "cgov": "http://reference.data.gov.uk/def/central-government/",
  "resource": "http://dbpedia.org/resource/",
  "cito": "http://purl.org/spar/cito/",
  "video": "http://purl.org/ontology/video#",
  "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "xl": "http://langegger.at/xlwrap/vocab#",
  "name": "http://example.org/name#",
  "seas": "https://w3id.org/seas/",
  "gist": "https://ontologies.semanticarts.com/o/gistCore#",
  "sosa": "http://www.w3.org/ns/sosa/",
  "wikipedia": "https://en.wikipedia.org/wiki/",
  "pr": "http://purl.org/ontology/prv/core#",
  "dbpediaowl": "http://dbpedia.org/owl/",
  "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
  "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
  "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
  "ean": "http://openean.kaufkauf.net/id/",
  "web": "http://www.w3.org/2007/uwa/context/web.owl#",
  "role": "https://w3id.org/role/",
  "pav": "http://purl.org/pav/",
  "stanford": "http://purl.org/olia/stanford.owl#",
  "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
  "acm": "http://www.rkbexplorer.com/ontologies/acm#",
  "httph": "http://www.w3.org/2007/ont/httph#",
  "exterms": "http://www.example.org/terms/",
  "dco": "http://info.deepcarbon.net/schema#",
  "dcm": "http://purl.org/dc/dcmitype/",
  "prv": "http://purl.org/net/provenance/ns#",
  "pgterms": "http://www.gutenberg.org/2009/pgterms/",
  "ps": "https://w3id.org/payswarm#",
  "wn": "http://xmlns.com/wordnet/1.6/",
  "iso": "http://purl.org/iso25964/skos-thes#",
  "purl": "http://purl.org/dc/terms/",
  "overheid": "http://standaarden.overheid.nl/owms/",
  "dcatapit": "http://dati.gov.it/onto/dcatapit#",
  "ero": "http://purl.obolibrary.org/obo/",
  "inno": "http://purl.org/innovation/ns#",
  "saref": "https://saref.etsi.org/core/",
  "wo": "http://purl.org/ontology/wo/",
  "formats": "http://www.w3.org/ns/formats/",
  "greg": "http://www.w3.org/ns/time/gregorian/",
  "lime": "http://www.w3.org/ns/lemon/lime#",
  "service": "http://purl.org/ontology/service#",
  "ass": "http://uptheasset.org/ontology#",
  "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "ocd": "http://dati.camera.it/ocd/",
  "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
  "atom": "http://www.w3.org/2005/Atom/",
  "wdrs": "http://www.w3.org/2007/05/powder-s#",
  "bmo": "http://collection.britishmuseum.org/id/ontology/",
  "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
  "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
  "smf": "http://topbraid.org/sparqlmotionfunctions#",
  "premis": "http://www.loc.gov/premis/rdf/v3/",
  "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
  "zoology": "http://purl.org/NET/biol/zoology#",
  "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
  "iao": "http://purl.obolibrary.org/obo/IAO_",
  "daml": "http://www.daml.org/2001/03/daml+oil#",
  "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
  "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
  "edam": "http://edamontology.org/",
  "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
  "res": "http://dbpedia.org/resource/",
  "won": "https://w3id.org/won/core#",
  "gsp": "http://www.opengis.net/ont/geosparql#",
  "lode": "http://linkedevents.org/ontology/",
  "hydra": "http://www.w3.org/ns/hydra/core#",
  "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
  "myspo": "http://purl.org/ontology/myspace#",
  "swid": "http://semanticweb.org/id/",
  "so": "http://schema.org/",
  "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
  "hp": "http://pictogram.tokyo/vocabulary#",
  "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
  "spl": "http://spinrdf.org/spl#",
  "agg": "http://purl.org/twc/health/vocab/aggregate/",
  "dt": "http://w3id.org/dt#",
  "scot": "http://rdfs.org/scot/ns#",
  "food": "http://purl.org/foodontology#",
  "resist": "http://www.rkbexplorer.com/ontologies/resist#",
  "bfo": "http://purl.obolibrary.org/obo/",
  "label": "http://purl.org/net/vocab/2004/03/label#",
  "omt": "http://purl.org/ontomedia/ext/common/trait#",
  "site": "http://ns.ontowiki.net/SysOnt/Site/",
  "omp": "http://purl.org/ontomedia/ext/common/profession#",
  "sdl": "http://purl.org/vocab/riro/sdl#",
  "faldo": "http://biohackathon.org/resource/faldo#",
  "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
  "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
  "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
  "fed": "http://www.openrdf.org/config/sail/federation#",
  "ignf": "http://data.ign.fr/def/ignf#",
  "bibframe": "http://id.loc.gov/ontologies/bibframe/",
  "sml": "https://w3id.org/sml/def#",
  "rov": "http://www.w3.org/ns/regorg#",
  "ref": "http://purl.org/vocab/relationship/",
  "isothes": "http://purl.org/iso25964/skos-thes#",
  "cpm": "http://catalogus-professorum.org/cpm/2/",
  "oad": "http://lod.xdams.org/reload/oad/",
  "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
  "rdau": "http://rdaregistry.info/Elements/u/",
  "ses": "http://lod.taxonconcept.org/ses/",
  "user": "http://schemas.talis.com/2005/user/schema#",
  "cordis": "http://cordis.europa.eu/projects/",
  "ya": "http://blogs.yandex.ru/schema/foaf/",
  "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
  "airport": "http://www.daml.org/2001/10/html/airport-ont#",
  "act": "http://www.w3.org/2007/rif-builtin-action#",
  "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
  "link": "http://www.w3.org/2007/ont/link#",
  "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
  "prj": "http://purl.org/stuff/project/",
  "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
  "rnews": "http://iptc.org/std/rNews/2011-10-07#",
  "library": "http://purl.org/library/",
  "audio": "http://purl.org/media/audio#",
  "taxon": "http://purl.uniprot.org/taxonomy/",
  "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "city": "http://datos.localidata.com/def/City#",
  "ludo": "http://ns.inria.fr/ludo/v1#",
  "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
  "fresnel": "http://www.w3.org/2004/09/fresnel#",
  "swp": "http://www.w3.org/2004/03/trix/swp-2/",
  "biocore": "http://bio2rdf.org/core#",
  "rs": "http://rightsstatements.org/vocab/",
  "npg": "http://ns.nature.com/terms/",
  "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
  "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "sesame": "http://www.openrdf.org/schema/sesame#",
  "sport": "http://purl.org/ontology/sport/",
  "meteo": "http://purl.org/ns/meteo#",
  "granatum": "http://chem.deri.ie/granatum/",
  "wv": "http://vocab.org/waiver/terms/",
  "linkedmdb": "http://data.linkedmdb.org/",
  "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
  "net": "http://www.w3.org/2007/uwa/context/network.owl#",
  "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
  "asn": "http://purl.org/ASN/schema/core/",
  "os": "http://www.w3.org/2000/10/swap/os#",
  "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
  "bl": "https://w3id.org/biolink/vocab/",
  "conv": "http://purl.org/twc/vocab/conversion/",
  "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
  "vra": "http://purl.org/vra/",
  "bio2rdf": "http://bio2rdf.org/",
  "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
  "arg": "http://spinrdf.org/arg#",
  "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
  "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
  "uco": "http://purl.org/uco/ns#",
  "efo": "http://www.ebi.ac.uk/efo/",
  "mime": "https://www.iana.org/assignments/media-types/",
  "umbelrc": "http://umbel.org/umbel/rc/",
  "acco": "http://purl.org/acco/ns#",
  "rail": "http://ontologi.es/rail/vocab#",
  "vocab": "http://rdf.ontology2.com/vocab#",
  "worldbank": "http://worldbank.270a.info/dataset/",
  "tdb": "http://jena.hpl.hp.com/2008/tdb#",
  "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
  "bne": "http://datos.bne.es/resource/",
  "conversion": "http://purl.org/twc/vocab/conversion/",
  "dctype": "http://purl.org/dc/dcmitype/",
  "rep": "http://www.openrdf.org/config/repository#",
  "doac": "http://ramonantonio.net/doac/0.1/#",
  "pbo": "http://purl.org/ontology/pbo/core#",
  "money": "http://purl.org/net/rdf-money/",
  "cdt": "https://w3id.org/cdt/",
  "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
  "compass": "http://purl.org/net/compass#",
  "lgdo": "http://linkedgeodata.org/ontology/",
  "spc": "http://purl.org/ontomedia/core/space#",
  "ao": "http://purl.org/ontology/ao/core#",
  "umbel": "http://umbel.org/umbel#",
  "dwc": "http://rs.tdwg.org/dwc/terms/",
  "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "protege": "http://protege.stanford.edu/system#",
  "oc": "http://opencoinage.org/rdf/",
  "omb": "http://purl.org/ontomedia/ext/common/being#",
  "crypto": "http://www.w3.org/2000/10/swap/crypto#",
  "lfm": "http://purl.org/ontology/last-fm/",
  "code": "http://telegraphis.net/ontology/measurement/code#",
  "custom": "http://www.openrdf.org/config/sail/custom#",
  "lx": "http://purl.org/NET/lx#",
  "ct": "http://data.linkedct.org/resource/linkedct/",
  "frir": "http://purl.org/twc/ontology/frir.owl#",
  "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
  "powder": "http://www.w3.org/2007/05/powder#",
  "ic": "http://imi.go.jp/ns/core/rdf#",
  "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
  "lang": "http://ontologi.es/lang/core#",
  "sco": "http://purl.org/ontology/sco#",
  "omm": "http://purl.org/ontomedia/core/media#",
  "obj": "http://www.openrdf.org/rdf/2009/object#",
  "atomix": "http://buzzword.org.uk/rdf/atomix#",
  "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
  "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
  "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
  "pay": "http://reference.data.gov.uk/def/payment#",
  "muto": "http://purl.org/muto/core#",
  "pom": "http://maven.apache.org/POM/4.0.0#",
  "bbc": "http://www.bbc.co.uk/ontologies/news/",
  "ddc": "http://purl.org/NET/decimalised#",
  "pro": "http://purl.org/hpi/patchr#",
  "coo": "http://purl.org/coo/ns#",
  "arch": "http://purl.org/archival/vocab/arch#",
  "soc": "http://purl.org/net/hdlipcores/ontology/soc#",
  "isq": "http://purl.org/ontology/is/quality/",
  "person": "http://www.w3.org/ns/person#",
  "mp": "http://jicamaro.info/mp#",
  "gml": "http://www.opengis.net/ont/gml#",
  "yoda": "http://purl.org/NET/yoda#",
  "biol": "http://purl.org/NET/biol/ns#",
  "rei": "http://www.w3.org/2004/06/rei#",
  "vsr": "http://purl.org/twc/vocab/vsr#",
  "mit": "http://purl.org/ontology/mo/mit#",
  "apivc": "http://purl.org/linked-data/api/vocab#",
  "contact": "http://www.w3.org/2000/10/swap/pim/contact#",
  "r2rml": "http://www.w3.org/ns/r2rml#",
  "aos": "http://rdf.muninn-project.org/ontologies/appearances#",
  "rdac": "http://rdaregistry.info/Elements/c/",
  "locn": "http://www.w3.org/ns/locn#",
  "ppo": "http://vocab.deri.ie/ppo#",
  "swh": "http://plugin.org.uk/swh-plugins/",
  "deo": "http://purl.org/spar/deo/",
  "mysql": "http://web-semantics.org/ns/mysql/",
  "xds": "http://www.w3.org/2001/XMLSchema#",
  "interval": "http://reference.data.gov.uk/def/intervals/",
  "eli": "http://data.europa.eu/eli/ontology#",
  "pmlr": "http://inference-web.org/2.0/pml-relation.owl#",
  "gso": "http://www.w3.org/2006/gen/ont#",
  "ngeo": "http://geovocab.org/geometry#",
  "gpt": "http://purl.org/vocab/riro/gpt#",
  "freebase": "http://rdf.freebase.com/ns/",
  "zem": "http://s.zemanta.com/ns#",
  "rv": "https://data.elsevier.com/research/schema/rv/",
  "hard": "http://www.w3.org/2007/uwa/context/hardware.owl#",
  "rlog": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
  "bib": "http://zeitkunst.org/bibtex/0.1/bibtex.owl#",
  "usgov": "http://www.rdfabout.com/rdf/schema/usgovt/",
  "oac": "https://w3id.org/oac#",
  "cpv": "http://purl.org/weso/cpv/",
  "is": "http://purl.org/ontology/is/core#",
  "ui": "http://www.w3.org/ns/ui#",
  "courseware": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "meetup": "http://www.lotico.com/meetup/",
  "xro": "http://purl.org/xro/ns#",
  "vso": "http://purl.org/vso/ns#",
  "nexif": "http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#",
  "bridge": "http://purl.org/vocommons/bridge#",
  "climb": "http://climb.dataincubator.org/vocabs/climb/",
  "states": "http://www.w3.org/2005/07/aaa#",
  "pos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "aifb": "http://www.aifb.kit.edu/id/",
  "payment": "http://reference.data.gov.uk/def/payment#",
  "cycann": "http://sw.cyc.com/CycAnnotations_v1#",
  "doclist": "http://www.junkwork.net/xml/DocumentList#",
  "game": "http://data.totl.net/game/",
  "pdo": "http://ontologies.smile.deri.ie/pdo#",
  "gob": "http://purl.org/ontology/last-fm/",
  "viaf": "http://viaf.org/viaf/",
  "sem": "http://semanticweb.cs.vu.nl/2009/11/sem/",
  "address": "http://schemas.talis.com/2005/address/schema#",
  "cdc": "https://w3id.org/cdc#",
  "article": "http://ogp.me/ns/article#",
  "nuts": "http://dd.eionet.europa.eu/vocabulary/common/nuts/",
  "wnschema": "http://www.cogsci.princeton.edu/~wn/schema/",
  "kwijibo": "http://kwijibo.talis.com/",
  "bsb": "http://opacplus.bsb-muenchen.de/title/",
  "odrl": "http://www.w3.org/ns/odrl/2/",
  "cex": "http://purl.org/weso/ontology/computex#",
  "sdm": "https://w3id.org/okn/o/sdm#",
  "dso": "http://purl.org/ontology/dso#",
  "teach": "http://linkedscience.org/teach/ns#",
  "provone": "http://purl.org/provone#",
  "oboinowl": "http://www.geneontology.org/formats/oboInOwl#",
  "psys": "http://proton.semanticweb.org/protonsys#",
  "xen": "http://buzzword.org.uk/rdf/xen#",
  "omc": "http://purl.org/ontomedia/ext/common/bestiary#",
  "dcmitype": "http://purl.org/dc/dcmitype/",
  "dbpp": "http://dbpedia.org/property/",
  "uri": "http://purl.org/NET/uri#",
  "prot": "http://www.proteinontology.info/po.owl#",
  "xforms": "http://www.w3.org/2002/xforms/",
  "agro": "http://purl.obolibrary.org/obo/agro.owl#",
  "vote": "http://www.rdfabout.com/rdf/schema/vote/",
  "swanco": "http://purl.org/swan/1.2/swan-commons/",
  "wi": "http://purl.org/ontology/wi/core#",
  "soft": "http://www.w3.org/2007/uwa/context/software.owl#",
  "muo": "http://purl.oclc.org/NET/muo/muo#",
  "politico": "http://www.rdfabout.com/rdf/schema/politico/",
  "ebucore": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
  "chord": "http://purl.org/ontology/chord/",
  "conserv": "http://conserv.deri.ie/ontology#",
  "com": "http://purl.org/commerce#",
  "oboe": "http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#",
  "vaem": "http://www.linkedmodel.org/schema/vaem#",
  "oauth": "http://demiblog.org/vocab/oauth#",
  "rda": "http://www.rdaregistry.info/",
  "fea": "http://vocab.data.gov/def/fea#",
  "coin": "http://purl.org/court/def/2009/coin#",
  "ttl": "http://www.w3.org/2008/turtle#",
  "biopax": "http://www.biopax.org/release/biopax-level3.owl#",
  "lp": "http://launchpad.net/rdf/launchpad#",
  "voag": "http://voag.linkedmodel.org/schema/voag#",
  "string": "http://www.w3.org/2000/10/swap/string#",
  "rdapo": "http://rdaregistry.info/Elements/p/object/",
  "bsbm": "http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/",
  "recipe": "http://linkedrecipes.org/schema/",
  "eclap": "http://www.eclap.eu/schema/eclap/",
  "rooms": "http://vocab.deri.ie/rooms#",
  "lfn": "http://www.dotnetrdf.org/leviathan#",
  "vitro": "http://vitro.mannlib.cornell.edu/ns/vitro/public#",
  "dcr": "http://www.isocat.org/ns/dcr.rdf#",
  "swanqs": "http://purl.org/swan/1.2/qualifiers/",
  "card": "http://www.ashutosh.com/test/",
  "lifecycle": "http://purl.org/vocab/lifecycle/schema#",
  "meb": "http://rdf.myexperiment.org/ontologies/base/",
  "sv": "http://schemas.talis.com/2005/service/schema#",
  "fo": "http://www.w3.org/1999/XSL/Format#",
  "ext": "http://mu.semte.ch/vocabularies/ext/",
  "dailymed": "http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/",
  "mygrid": "http://www.mygrid.org.uk/ontology#",
  "oslc": "http://open-services.net/ns/core#",
  "moat": "http://moat-project.org/ns#",
  "html": "http://www.w3.org/1999/xhtml/",
  "wdr": "http://www.w3.org/2007/05/powder#",
  "wgspos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "scv": "http://purl.org/NET/scovo#",
  "countries": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "isi": "http://purl.org/ontology/is/inst/",
  "osn": "http://spatial.ucd.ie/lod/osn/",
  "puc": "http://purl.org/NET/puc#",
  "opo": "http://online-presence.net/opo/ns#",
  "posh": "http://poshrdf.org/ns/posh/",
  "b2bo": "http://purl.org/b2bo#",
  "dnr": "http://www.dotnetrdf.org/configuration#",
  "h5": "http://buzzword.org.uk/rdf/h5#",
  "csvw": "http://www.w3.org/ns/csvw#",
  "pubmed": "http://bio2rdf.org/pubmed_vocabulary:",
  "sail": "http://www.openrdf.org/config/sail#",
  "lvont": "http://lexvo.org/ontology#",
  "push": "http://www.w3.org/2007/uwa/context/push.owl#",
  "lotico": "http://www.lotico.com/resource/",
  "spatial": "http://geovocab.org/spatial#",
  "cogs": "http://vocab.deri.ie/cogs#",
  "lastfm": "http://purl.org/ontology/last-fm/",
  "fno": "https://w3id.org/function/ontology#",
  "fls": "http://lukasblaho.sk/football_league_schema#",
  "rdaa": "http://rdaregistry.info/Elements/a/",
  "br": "http://vocab.deri.ie/br#",
  "wbp": "http://worldbank.270a.info/property/",
  "evset": "http://dsnotify.org/vocab/eventset/0.1/",
  "care": "http://eulersharp.sourceforge.net/2003/03swap/care#",
  "fd": "http://foodable.co/ns/",
  "wlp": "http://weblab-project.org/core/model/property/processing/",
  "dady": "http://purl.org/NET/dady#",
  "enc": "http://www.w3.org/2001/04/xmlenc#",
  "hospital": "http://www.agfa.com/w3c/2009/hospital#",
  "ldap": "http://purl.org/net/ldap/",
  "play": "http://uriplay.org/spec/ontology/#",
  "geospecies": "http://rdf.geospecies.org/ont/geospecies#",
  "exo": "https://w3id.org/example#",
  "toby": "http://tobyinkster.co.uk/#",
  "wai": "http://purl.org/wai#",
  "ncbitaxon": "http://purl.obolibrary.org/obo/NCBITaxon_",
  "marl": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
  "lex": "http://purl.org/lex#",
  "resex": "http://resex.rkbexplorer.com/ontologies/resex#",
  "uni": "http://purl.org/weso/uni/uni.html#",
  "hlisting": "http://sindice.com/hlisting/0.1/",
  "parl": "https://id.parliament.uk/schema/",
  "bte": "http://purl.org/twc/vocab/between-the-edges/",
  "sede": "http://eventography.org/sede/0.1/",
  "tarot": "http://data.totl.net/tarot/card/",
  "swandr": "http://purl.org/swan/1.2/discourse-relationships/",
  "ops": "https://w3id.org/ops#",
  "irrl": "http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#",
  "grddl": "http://www.w3.org/2003/g/data-view#",
  "ec": "http://eulergui.sourceforge.net/contacts.owl.n3#",
  "lingvoj": "http://www.lingvoj.org/ontology#",
  "data": "http://data.odw.tw/",
  "foo": "http://filmontology.org/ontology/1.0/",
  "lark1": "http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#",
  "ist": "http://purl.org/ontology/is/types/",
  "p3p": "http://www.w3.org/2002/01/p3prdfv1#",
  "okkam": "http://models.okkam.org/ENS-core-vocabulary#",
  "cmd": "https://w3id.org/cmd#",
  "hcterms": "http://purl.org/uF/hCard/terms/",
  "archdesc": "http://archdesc.info/archEvent#",
  "shv": "http://ns.aksw.org/spatialHierarchy/",
  "tr": "http://www.thomsonreuters.com/",
  "calli": "http://callimachusproject.org/rdf/2009/framework#",
  "icaltzd": "http://www.w3.org/2002/12/cal/icaltzd#",
  "remus": "http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#",
  "cos": "http://www.inria.fr/acacia/corese#",
  "pobo": "http://purl.obolibrary.org/obo/",
  "xmls": "http://www.w3.org/2001/XMLSchema#",
  "like": "http://ontologi.es/like#",
  "nex": "http://www.nexml.org/2009/",
  "sioca": "http://rdfs.org/sioc/actions#",
  "anca": "http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#",
  "places": "http://purl.org/ontology/places#",
  "profiling": "http://ontologi.es/profiling#",
  "pol": "http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#",
  "psh": "http://ns.inria.fr/probabilistic-shacl/",
  "wsc": "http://www.openk.org/wscaim.owl#",
  "algo": "http://securitytoolbox.appspot.com/securityAlgorithms#",
  "td": "https://www.w3.org/2019/wot/td#",
  "ann": "http://www.w3.org/2000/10/annotation-ns#",
  "gs1": "https://ref.gs1.org/voc/",
  "oat": "http://openlinksw.com/schemas/oat/",
  "identity": "http://purl.org/twc/ontologies/identity.owl#",
  "rdfa": "http://www.w3.org/ns/rdfa#",
  "cb": "http://cbasewrap.ontologycentral.com/vocab#",
  "swivt": "http://semantic-mediawiki.org/swivt/1.0#",
  "wl": "http://www.wsmo.org/ns/wsmo-lite#",
  "geom": "http://data.ign.fr/def/geometrie#",
  "osr": "http://dati.senato.it/osr/",
  "opwn": "http://www.ontologyportal.org/WordNet.owl#",
  "ddl": "http://purl.org/vocab/riro/ddl#",
  "ecc": "https://ns.eccenca.com/",
  "infosys": "http://www.infosys.com/",
  "httpvoc": "http://www.w3.org/2006/http#",
  "sawsdl": "http://www.w3.org/ns/sawsdl#",
  "phss": "http://ns.poundhill.com/phss/1.0/",
  "scsv": "http://purl.org/NET/schema-org-csv#",
  "esd": "http://def.esd.org.uk/",
  "psych": "http://purl.org/vocab/psychometric-profile/",
  "wisski": "http://wiss-ki.eu/",
  "esdir": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#",
  "gridworks": "http://purl.org/net/opmv/types/gridworks#",
  "prissma": "http://ns.inria.fr/prissma/v1#",
  "datafaqs": "http://purl.org/twc/vocab/datafaqs#",
  "tio": "http://purl.org/tio/ns#",
  "drug": "http://www.agfa.com/w3c/2009/drugTherapy#",
  "dnb": "http://d-nb.info/gnd/",
  "imreg": "http://www.w3.org/2004/02/image-regions#",
  "copyright": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "ecos": "http://purl.org/ecos#",
  "dbpedia2": "http://dbpedia.org/property/",
  "fab": "http://purl.org/fab/ns#",
  "san": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
  "prf": "http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#",
  "grel": "http://users.ugent.be/~bjdmeest/function/grel.ttl#",
  "tp": "https://triplydb.com/Triply/tp/def/",
  "geographis": "http://telegraphis.net/ontology/geography/geography#",
  "ple": "http://pleiades.stoa.org/places/",
  "visit": "http://purl.org/net/vocab/2004/07/visit#",
  "nsa": "http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#",
  "wfm": "http://purl.org/net/wf-motifs#",
  "ogp": "http://ogp.me/ns#",
  "ezcontext": "http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#",
  "provenir": "http://knoesis.wright.edu/provenir/provenir.owl#",
  "common": "http://www.w3.org/2007/uwa/context/common.owl#",
  "dita": "http://purl.org/dita/ns#",
  "pmlp": "http://inference-web.org/2.0/pml-provenance.owl#",
  "pccz": "http://purl.org/procurement/public-contracts-czech#",
  "elog": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "dbt": "http://dbpedia.org/resource/Template:",
  "xt": "http://purl.org/twc/vocab/cross-topix#",
  "status": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "admssw": "http://purl.org/adms/sw/",
  "tags": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "units": "http://eulersharp.sourceforge.net/2003/03swap/units#",
  "mesh": "http://id.nlm.nih.gov/mesh/",
  "pml": "http://provenanceweb.org/ns/pml#",
  "hgnc": "http://bio2rdf.org/hgnc:",
  "session": "http://redfoot.net/2005/session#",
  "quantity": "http://qudt.org/schema/quantity#",
  "span": "http://www.ifomis.org/bfo/1.1/span#",
  "pam": "http://prismstandard.org/namespaces/pam/2.0/",
  "rulz": "http://purl.org/NET/rulz#",
  "timeline": "http://purl.org/NET/c4dm/timeline.owl#",
  "vf": "https://w3id.org/valueflows/ont/vf#",
  "sl": "http://www.semanlink.net/2001/00/semanlink-schema#",
  "lr": "http://linkedrecipes.org/schema/",
  "eprints": "http://eprints.org/ontology/",
  "fowl": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
  "agent": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "visko": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "smiley": "http://www.smileyontology.com/ns#",
  "ecb": "http://ecb.270a.info/class/1.0/",
  "wbc": "http://worldbank.270a.info/classification/",
  "sindice": "http://vocab.sindice.net/",
  "osoc": "http://web-semantics.org/ns/opensocial#",
  "cl": "http://advene.org/ns/cinelab/",
  "odp": "http://ontologydesignpatterns.org/",
  "ling": "http://purl.org/voc/ling/",
  "pimo": "http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#",
  "sysont": "http://ns.ontowiki.net/SysOnt/",
  "cao": "http://purl.org/makolab/caont/",
  "np": "http://www.nanopub.org/nschema#",
  "dsp": "http://purl.org/metainfo/terms/dsp#",
  "hxl": "http://hxl.humanitarianresponse.info/ns/#",
  "skip": "http://skipforward.net/skipforward/resource/",
  "json": "https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#",
  "nxp": "http://purl.org/nxp/schema/v1/",
  "xsl": "http://www.w3.org/1999/XSL/Transform#",
  "human": "http://eulersharp.sourceforge.net/2003/03swap/human#",
  "eztag": "http://ontologies.ezweb.morfeo-project.org/eztag/ns#",
  "doco": "http://purl.org/spar/doco/",
  "soap": "http://www.w3.org/2003/05/soap-envelope/",
  "omv": "http://omv.ontoware.org/2005/05/ontology#",
  "un": "http://www.w3.org/2007/ont/unit#",
  "iswc": "http://annotation.semanticweb.org/2004/iswc#",
  "c4n": "http://vocab.deri.ie/c4n#",
  "wordmap": "http://purl.org/net/ns/wordmap#",
  "reve": "http://data.eurecom.fr/ontology/reve#",
  "dis": "http://stanbol.apache.org/ontology/disambiguation/disambiguation#",
  "ecpo": "http://purl.org/ontology/ecpo#",
  "geop": "http://aims.fao.org/aos/geopolitical.owl#",
  "sm": "http://topbraid.org/sparqlmotion#",
  "pns": "http://data.press.net/ontology/stuff/",
  "ipad": "http://www.padinthecity.com/",
  "geofla": "http://data.ign.fr/ontologies/geofla#",
  "ibis": "http://purl.org/ibis#",
  "zbwext": "http://zbw.eu/namespaces/zbw-extensions/",
  "swanci": "http://purl.org/swan/1.2/citations/",
  "prvtypes": "http://purl.org/net/provenance/types#",
  "dossier": "https://data.omgeving.vlaanderen.be/ns/dossier#",
  "carfo": "http://purl.org/carfo#",
  "gazetteer": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
  "orca": "http://geni-orca.renci.org/owl/topology.owl#",
  "rdo": "http://purl.org/rdo/ns#",
  "luc": "http://www.ontotext.com/owlim/lucene#",
  "osgb": "http://data.ordnancesurvey.co.uk/id/",
  "gv": "http://rdf.data-vocabulary.org/#",
  "func": "http://www.w3.org/2007/rif-builtin-function#",
  "out": "http://ontologies.hypios.com/out#",
  "sql": "http://ns.inria.fr/ast/sql#",
  "ncal": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
  "olo": "http://purl.org/ontology/olo/core#",
  "mei": "http://www.music-encoding.org/ns/mei/",
  "nsl": "http://purl.org/ontology/storyline/",
  "spif": "http://spinrdf.org/spif#",
  "lt": "http://diplomski.nelakolundzija.org/LTontology.rdf#",
  "myprefix": "http://myprefix.org/",
  "nytimes": "http://data.nytimes.com/elements/",
  "sw": "http://linkedwidgets.org/statisticalwidget/ontology/",
  "sor": "http://purl.org/net/soron/",
  "dpd": "http://www.kanzaki.com/ns/dpd#",
  "aigp": "http://swat.cse.lehigh.edu/resources/onto/aigp.owl#",
  "set": "http://www.w3.org/2000/10/swap/set#",
  "atomowl": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "trackback": "http://madskills.com/public/xml/rss/module/trackback/",
  "arpfo": "http://vocab.ouls.ox.ac.uk/projectfunding#",
  "gelo": "http://krauthammerlab.med.yale.edu/ontologies/gelo#",
  "enhancer": "http://stanbol.apache.org/ontology/enhancer/enhancer#",
  "swanpav": "http://purl.org/swan/1.2/pav/",
  "dgfoaf": "http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#",
  "fl": "http://eulersharp.sourceforge.net/2003/03swap/fl-rules#",
  "aapi": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "muni": "http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#",
  "gc": "http://www.oegov.org/core/owl/gc#",
  "eye": "http://jena.hpl.hp.com/Eyeball#",
  "fcm": "http://eulersharp.sourceforge.net/2006/02swap/fcm#",
  "dtype": "http://www.linkedmodel.org/schema/dtype#",
  "life": "http://life.deri.ie/schema/",
  "opus": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
  "ls": "http://linkedspending.aksw.org/instance/",
  "ne": "http://umbel.org/umbel/ne/",
  "decl": "http://www.linkedmodel.org/1.0/schema/decl#",
  "cidoccrm": "http://purl.org/NET/cidoc-crm/core#",
  "rlno": "http://rdflivenews.aksw.org/ontology/",
  "pne": "http://data.press.net/ontology/event/",
  "wikibase": "http://wikiba.se/ontology#",
  "evopat": "http://ns.aksw.org/Evolution/",
  "prefix": "http://prefix.cc/",
  "oboro": "http://obofoundry.org/ro/ro.owl#",
  "prolog": "http://eulersharp.sourceforge.net/2003/03swap/prolog#",
  "pmlt": "http://inference-web.org/2.0/pml-trust.owl#",
  "agrelon": "http://d-nb.info/standards/elementset/agrelon#",
  "xhtmlvocab": "http://www.w3.org/1999/xhtml/vocab/",
  "dqv": "http://www.w3.org/ns/dqv#",
  "govtrackus": "http://www.rdfabout.com/rdf/usgov/geo/us/",
  "agents": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "steel": "https://w3id.org/steel/ProcessOntology/",
  "wairole": "http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#",
  "bioskos": "http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#",
  "rdam": "http://rdaregistry.info/Elements/m/",
  "rdagr1": "http://rdvocab.info/Elements/",
  "sdgp": "http://stats.data-gov.ie/property/",
  "comm": "http://vocab.resc.info/communication#",
  "semtweet": "http://semantictweet.com/",
  "rkd": "http://data.rkd.nl/def#",
  "ifc": "http://ifcowl.openbimstandards.org/IFC2X3_Final#",
  "plo": "http://purl.org/net/po#",
  "xbrli": "http://www.xbrl.org/2003/instance#",
  "dummy": "http://hello.com/",
  "wf": "http://www.w3.org/2005/01/wf/flow#",
  "r2r": "http://www4.wiwiss.fu-berlin.de/bizer/r2r/",
  "commons": "http://commons.psi.enakting.org/def/",
  "nid3": "http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#",
  "opl": "http://openlinksw.com/schema/attribution#",
  "linkedct": "http://data.linkedct.org/vocab/",
  "rad": "http://www.w3.org/ns/rad#",
  "abs": "http://abs.270a.info/dataset/",
  "organiz": "http://eulersharp.sourceforge.net/2003/03swap/organization#",
  "owltime": "http://www.w3.org/TR/owl-time#",
  "w3p": "http://prov4j.org/w3p/",
  "sad": "http://vocab.deri.ie/sad#",
  "webtlab": "http://webtlab.it.uc3m.es/",
  "ens": "http://models.okkam.org/ENS-core-vocabulary.owl#",
  "wao": "http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#",
  "rso": "http://www.researchspace.org/ontology/",
  "plink": "http://buzzword.org.uk/rdf/personal-link-types#",
  "pf": "http://jena.hpl.hp.com/ARQ/property#",
  "vcardx": "http://buzzword.org.uk/rdf/vcardx#",
  "derecho": "http://purl.org/derecho#",
  "aneo": "http://akonadi-project.org/ontologies/aneo#",
  "qa": "http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#",
  "httpm": "http://www.w3.org/2011/http-methods#",
  "transit": "http://vocab.org/transit/terms/",
  "ianarel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "req": "http://purl.org/req/",
  "moby": "http://www.mygrid.org.uk/mygrid-moby-service#",
  "rml": "http://w3id.org/rml/",
  "tvc": "http://www.essepuntato.it/2012/04/tvc/",
  "open": "http://open.vocab.org/terms/",
  "tripfs": "http://purl.org/tripfs/2010/02#",
  "xesam": "http://freedesktop.org/standards/xesam/1.0/core#",
  "dgtwc": "http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#",
  "gxa": "http://www.ebi.ac.uk/gxa/",
  "rdaw": "http://rdaregistry.info/Elements/w/",
  "hemogram": "http://www.agfa.com/w3c/2009/hemogram#",
  "va": "http://code-research.eu/ontology/visual-analytics#",
  "nyt": "http://data.nytimes.com/",
  "agetec": "http://www.agetec.org/",
  "fc": "http://www.freeclass.eu/freeclass_v1#",
  "pna": "http://data.press.net/ontology/asset/",
  "qdoslf": "http://foaf.qdos.com/lastfm/schema/",
  "aersv": "http://aers.data2semantics.org/vocab/",
  "oax": "http://www.w3.org/ns/openannotation/extensions/",
  "ospost": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
  "theatre": "http://purl.org/theatre#",
  "lindt": "http://purl.org/NET/lindt#",
  "frbre": "http://purl.org/vocab/frbr/extended#",
  "htir": "http://www.w3.org/2011/http#",
  "frbrcore": "http://purl.org/vocab/frbr/core#",
  "no": "http://km.aifb.kit.edu/projects/numbers/number#",
  "dl": "http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#",
  "wapp": "http://ns.rww.io/wapp#",
  "owls": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "oj": "http://ontojob.at/",
  "dbpo": "http://dbpedia.org/ontology/",
  "tcga": "http://purl.org/tcga/core#",
  "swpo": "http://sw-portal.deri.org/ontologies/swportal#",
  "italy": "http://data.kasabi.com/dataset/italy/schema/",
  "scowt": "http://purl.org/weso/ontologies/scowt#",
  "solid": "http://www.w3.org/ns/solid/terms#",
  "intervals": "http://reference.data.gov.uk/def/intervals/",
  "estrn": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#",
  "xfnv": "http://vocab.sindice.com/xfn#",
  "mmo": "http://purl.org/momayo/mmo/",
  "oecd": "http://oecd.270a.info/dataset/",
  "kw": "http://kwantu.net/kw/",
  "rpubl": "http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#",
  "aims": "http://aims.fao.org/aos/common/",
  "protons": "http://proton.semanticweb.org/2005/04/protons#",
  "metalex": "http://www.metalex.eu/schema/1.0#",
  "sro": "http://salt.semanticauthoring.org/ontologies/sro#",
  "dctypes": "http://purl.org/dc/dcmitype/",
  "wfdesc": "http://purl.org/wf4ever/wfdesc#",
  "swo": "http://www.ebi.ac.uk/swo/",
  "eseduc": "http://www.purl.org/ontologia/eseduc#",
  "shex": "http://www.w3.org/ns/shex#",
  "emotion": "http://ns.inria.fr/emoca#",
  "atlas": "http://rdf.ebi.ac.uk/resource/atlas/",
  "crtv": "http://open-services.net/ns/crtv#",
  "tripfs2": "http://purl.org/tripfs/2010/06#",
  "geodata": "http://sws.geonames.org/",
  "languages": "http://eulersharp.sourceforge.net/2003/03swap/languages#",
  "iron": "http://purl.org/ontology/iron#",
  "quak": "http://dev.w3.org/cvsweb/2000/quacken/vocab#",
  "health": "http://purl.org/twc/health/vocab/",
  "flow": "http://www.w3.org/2005/01/wf/flow#",
  "ogorg": "http://opengraph.org/schema/",
  "oboso": "http://purl.org/obo/owl/SO#",
  "oper": "http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#",
  "npgd": "http://ns.nature.com/datasets/",
  "crmdig": "http://www.ics.forth.gr/isl/CRMdig/",
  "fct": "http://openlinksw.com/services/facets/1.0/",
  "transmed": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
  "ldr": "http://purl.oclc.org/NET/ldr/ns#",
  "ncit": "http://purl.obolibrary.org/obo/NCIT_",
  "bdd": "https://api.bloomberg.com/eap/catalogs/bbg/fields/",
  "opmv": "http://purl.org/net/opmv/ns#",
  "qu": "http://purl.oclc.org/NET/ssnx/qu/qu#",
  "xch": "http://oanda2rdf.appspot.com/xch/",
  "jita": "http://aims.fao.org/aos/jita/",
  "lgv": "http://linkedgeodata.org/ontology/",
  "c4o": "http://purl.org/spar/c4o/",
  "opmw": "http://www.opmw.org/ontology/",
  "gbv": "http://purl.org/ontology/gbv/",
  "swanag": "http://purl.org/swan/1.2/agents/",
  "wm": "http://ns.inria.fr/webmarks#",
  "daq": "http://purl.org/eis/vocab/daq#",
  "rich": "http://rdf.data-vocabulary.org/",
  "hartigprov": "http://purl.org/net/provenance/ns#",
  "cf": "http://mmisw.org/ont/cf/parameter/",
  "ru": "http://purl.org/imbi/ru-meta.owl#",
  "govwild": "http://govwild.org/0.6/GWOntology.rdf/",
  "bm": "http://bio2rdf.org/",
  "rating": "http://www.tvblob.com/ratings/#",
  "re": "http://www.w3.org/2000/10/swap/reason#",
  "openskos": "http://openskos.org/xmlns#",
  "kdo": "http://kdo.render-project.eu/kdo#",
  "gfo": "http://www.onto-med.de/ontologies/gfo.owl#",
  "clineva": "http://www.agfa.com/w3c/2009/clinicalEvaluation#",
  "fingal": "http://vocab.deri.ie/fingal#",
  "environ": "http://eulersharp.sourceforge.net/2003/03swap/environment#",
  "date": "http://contextus.net/ontology/ontomedia/misc/date#",
  "skiresort": "http://www.openlinksw.com/ski_resorts/schema#",
  "humanbody": "http://eulersharp.sourceforge.net/2003/03swap/humanBody#",
  "events": "http://eulersharp.sourceforge.net/2003/03swap/event#",
  "bco": "http://purl.obolibrary.org/obo/bco.owl#",
  "ufmedia": "http://purl.org/microformat/hmedia/",
  "dssn": "http://purl.org/net/dssn/",
  "igeo": "http://rdf.insee.fr/def/geo#",
  "coeus": "http://bioinformatics.ua.pt/coeus/",
  "goef": "http://purl.org/twc/vocab/goef#",
  "ccard": "http://purl.org/commerce/creditcard#",
  "adr": "http://kg.artsdata.ca/resource/",
  "sgv": "http://www.w3.org/TR/SVG/",
  "telix": "http://purl.org/telix#",
  "cdtype": "http://purl.org/cld/cdtype/",
  "mohammad": "http://manesht.ir/",
  "aair": "http://xmlns.notu.be/aair#",
  "nndsr": "http://semanticdiet.com/schema/usda/nndsr/",
  "kontakt": "http://richard.cyganiak.de/",
  "occult": "http://data.totl.net/occult/",
  "osmsemnet": "http://spatial.ucd.ie/2012/08/osmsemnet/",
  "ipo": "http://purl.org/ipo/core#",
  "wro": "http://purl.org/net/wf4ever/ro#",
  "emp": "http://purl.org/ctic/empleo/oferta#",
  "ev": "http://www.w3.org/2001/xml-events/",
  "loticoowl": "http://www.lotico.com/ontology/",
  "rankrage": "https://rankrage.de/",
  "marshall": "http://sites.google.com/site/xgmaitc/",
  "d2r": "http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#",
  "sig": "http://purl.org/signature#",
  "cold": "http://purl.org/configurationontology#",
  "artstor": "http://simile.mit.edu/2003/10/ontologies/artstor#",
  "decision": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
  "property": "http://fr.dbpedia.org/property/",
  "clinic": "http://example.com/clinic#",
  "dayta": "http://dayta.me/resource#",
  "ost": "http://w3id.org/ost/ns#",
  "coun": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
  "tmpl": "http://purl.org/restdesc/http-template#",
  "bookmark": "http://www.w3.org/2002/01/bookmark#",
  "hcard": "http://purl.org/uF/hCard/terms/",
  "daiaserv": "http://purl.org/ontology/daia/Service/",
  "frapo": "http://purl.org/cerif/frapo/",
  "pco": "http://purl.org/procurement/public-contracts#",
  "tao": "http://pubannotation.org/ontology/tao.owl#",
  "npgg": "http://ns.nature.com/graphs/",
  "pso": "http://purl.org/spar/pso/",
  "wscaim": "http://www.openk.org/wscaim.owl#",
  "grs": "http://www.georss.org/georss/",
  "prism21": "http://prismstandard.org/namespaces/basic/2.1/",
  "ccom": "http://purl.org/ontology/cco/mappings#",
  "frad": "http://iflastandards.info/ns/fr/frad/",
  "dannet": "http://www.wordnet.dk/owl/instance/2009/03/instances/",
  "bk": "http://www.provbook.org/ns/#",
  "tei": "http://www.tei-c.org/ns/1.0/",
  "wno": "http://wordnet-rdf.princeton.edu/ontology#",
  "osukdt": "http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#",
  "paia": "http://purl.org/ontology/paia#",
  "arecipe": "http://purl.org/amicroformat/arecipe/",
  "dive": "http://scubadive.networld.to/dive.rdf#",
  "harrisons": "http://harrisons.cc/",
  "s2s": "http://escience.rpi.edu/ontology/sesf/s2s/4/0/",
  "bcncon": "http://datos.bcn.cl/ontologies/bcn-congress#",
  "lso": "http://linkedspending.aksw.org/ontology/",
  "mod": "http://www.isibang.ac.in/ns/mod#",
  "fma": "http://sig.uw.edu/fma#",
  "p20": "http://zbw.eu/beta/p20/vocab/",
  "odo": "http://ocean-data.org/schema/",
  "stac": "http://securitytoolbox.appspot.com/stac#",
  "kupkb": "http://www.e-lico.eu/data/kupkb/",
  "penis": "http://penis.to/#",
  "shacl": "http://www.w3.org/ns/shacl#",
  "protegedc": "http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#",
  "curr": "https://w3id.org/cc#",
  "l4a": "http://labels4all.info/ns/",
  "skos08": "http://www.w3.org/2008/05/skos#",
  "lod2": "http://lod2.eu/schema/",
  "mads": "http://www.loc.gov/mads/rdf/v1#",
  "verb": "https://w3id.org/verb/",
  "genab": "http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#",
  "csm": "http://purl.org/csm/1.0#",
  "pizza": "http://www.co-ode.org/ontologies/pizza/pizza.owl#",
  "wsl": "http://www.wsmo.org/ns/wsmo-lite#",
  "diseasome": "http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/",
  "mte": "http://nl.ijs.si/ME/owl/",
  "kbp": "http://tackbp.org/2013/ontology#",
  "wfprov": "http://purl.org/wf4ever/wfprov#",
  "ends": "http://labs.mondeca.com/vocab/endpointStatus#",
  "hasco": "http://hadatac.org/ont/hasco/",
  "art": "http://w3id.org/art/terms/1.0/",
  "str": "http://nlp2rdf.lod2.eu/schema/string/",
  "sci": "http://data.scientology.org/ns/",
  "gesis": "http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#",
  "tac": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
  "b2rpubchem": "http://bio2rdf.org/ns/ns/ns/pubchem#",
  "scor": "http://purl.org/eis/vocab/scor#",
  "oslo": "http://purl.org/oslo/ns/localgov#",
  "rdacarrier": "http://rdvocab.info/termList/RDACarrierType/",
  "atomrdf": "http://atomowl.org/ontologies/atomrdf#",
  "doas": "http://deductions.github.io/doas.owl.ttl#",
  "vgo": "http://purl.org/net/VideoGameOntology#",
  "of": "http://owlrep.eu01.aws.af.cm/fridge#",
  "sbench": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "opllic": "http://www.openlinksw.com/ontology/licenses#",
  "lio": "http://purl.org/net/lio#",
  "lc": "http://semweb.mmlab.be/ns/linkedconnections#",
  "scms": "http://ns.aksw.org/scms/annotations/",
  "ds": "http://purl.org/ctic/dcat#",
  "dpc": "http://hospee.org/ontologies/dpc/",
  "cpsv": "http://purl.org/vocab/cpsv#",
  "smg": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
  "pod": "https://project-open-data.cio.gov/v1.1/schema/#",
  "poder": "http://poderopedia.com/vocab/",
  "genea": "http://www.owl-ontologies.com/generations.owl#",
  "omnlife": "http://open-multinet.info/ontology/omn-lifecycle#",
  "camelot": "http://vocab.ox.ac.uk/camelot#",
  "biordf": "http://purl.org/net/biordfmicroarray/ns#",
  "nocal": "http://vocab.deri.ie/nocal#",
  "sam": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
  "dpl": "http://dbpedialite.org/things/",
  "bv": "http://purl.org/vocommons/bv#",
  "opencyc": "http://sw.opencyc.org/concept/",
  "jpo": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "faq": "http://www.openlinksw.com/ontology/faq#",
  "shoah": "http://dati.cdec.it/lod/shoah/",
  "latitude": "https://www.w3.org/2006/vcard/ns#",
  "itsmo": "http://ontology.it/itsmo/v1#",
  "insdc": "http://ddbj.nig.ac.jp/ontologies/sequence#",
  "dn": "http://purl.org/datanode/ns/",
  "cart": "http://purl.org/net/cartCoord#",
  "prvr": "http://purl.org/ontology/prv/rules#",
  "guo": "http://purl.org/hpi/guo#",
  "prvt": "http://purl.org/net/provenance/types#",
  "ptop": "http://www.ontotext.com/proton/protontop#",
  "campsite": "http://www.openlinksw.com/campsites/schema#",
  "mmd": "http://musicbrainz.org/ns/mmd-1.0#",
  "ssso": "http://purl.org/ontology/ssso#",
  "clinproc": "http://www.agfa.com/w3c/2009/clinicalProcedure#",
  "sso": "http://nlp2rdf.lod2.eu/schema/sso/",
  "healthcare": "http://www.agfa.com/w3c/2009/healthCare#",
  "mpeg7": "http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#",
  "shw": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
  "osp": "http://data.lirmm.fr/ontologies/osp#",
  "tisc": "http://observedchange.com/tisc/ns#",
  "stream": "http://dbpedia.org/ontology/Stream/",
  "thors": "http://resource.geosciml.org/ontology/timescale/thors#",
  "dash": "http://datashapes.org/dash#",
  "sioctypes": "http://rdfs.org/sioc/types#",
  "ottr": "http://ns.ottr.xyz/templates#",
  "hifm": "http://purl.org/net/hifm/data#",
  "aerols": "http://xmlns.com/aerols/0.1/",
  "ql": "http://www.w3.org/2004/ql#",
  "chembl": "http://rdf.ebi.ac.uk/terms/chembl#",
  "lh": "http://vocab.inf.ed.ac.uk/library/holdings#",
  "security": "http://securitytoolbox.appspot.com/securityMain#",
  "te": "http://www.w3.org/2006/time-entry#",
  "gov": "http://gov.genealogy.net/ontology.owl#",
  "iol": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
  "refe": "http://orion.tw.rpi.edu/~xgmatwc/refe/",
  "category": "http://dbpedia.org/resource/Category:",
  "dbyago": "http://dbpedia.org/class/yago/",
  "sao": "http://salt.semanticauthoring.org/ontologies/sao#",
  "centrifuge": "http://purl.org/twc/vocab/centrifuge#",
  "dpv": "http://www.w3.org/ns/dpv#",
  "vsto": "http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#",
  "alchemy": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "xlime": "http://xlime-project.org/vocab/",
  "rdamt": "http://rdaregistry.info/termList/RDAMediaType/",
  "pronom": "http://reference.data.gov.uk/technical-registry/",
  "trait": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
  "ngeoi": "http://vocab.lenka.no/geo-deling#",
  "qrl": "http://www.aifb.kit.edu/project/ld-retriever/qrl#",
  "twaapi": "http://purl.org/twc/vocab/aapi-schema#",
  "oml": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
  "ebu": "http://semantic.eurobau.com/eurobau-utility.owl#",
  "okg": "http://openknowledgegraph.org/ontology/",
  "ecrm": "http://erlangen-crm.org/current/",
  "onssprel": "http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#",
  "xrd": "http://docs.oasis-open.org/ns/xri/xrd-1.0#",
  "tw": "http://tw.rpi.edu/schema/",
  "yo": "http://yovisto.com/",
  "cpant": "http://purl.org/NET/cpan-uri/terms#",
  "mtecore": "http://purl.org/olia/mte/multext-east.owl#",
  "fao": "http://fao.270a.info/dataset/",
  "odcs": "http://opendata.cz/infrastructure/odcleanstore/",
  "lctr": "http://data.linkedct.org/vocab/resource/",
  "cosmo": "http://purl.org/ontology/cosmo#",
  "oarj": "http://opendepot.org/reference/linked/1.0/",
  "rec54": "http://www.w3.org/2001/02pd/rec54.rdf#",
  "saxon": "http://saxon.sf.net/",
  "malignneo": "http://www.agfa.com/w3c/2009/malignantNeoplasm#",
  "bgdbp": "http://bg.dbpedia.org/property/",
  "w3con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "lsc": "http://linkedscience.org/lsc/ns#",
  "idemo": "http://rdf.insee.fr/def/demo#",
  "germplasm": "http://purl.org/germplasm/terms#",
  "cts2": "http://schema.omg.org/spec/CTS2/1.0/",
  "obsm": "http://rdf.geospecies.org/methods/observationMethod#",
  "who": "http://www.who.int/vocab/ontology#",
  "wlo": "http://purl.org/ontology/wo/",
  "cis": "http://purl.org/NET/cloudisus#",
  "vartrans": "http://www.w3.org/ns/lemon/vartrans#",
  "bcnnorms": "http://datos.bcn.cl/ontologies/bcn-norms#",
  "zoomaterms": "http://rdf.ebi.ac.uk/vocabulary/zooma/",
  "msr": "http://www.telegraphis.net/ontology/measurement/measurement#",
  "osgeom": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
  "rdafr": "http://rdaregistry.info/termList/frequency/",
  "tm": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
  "vin": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
  "antenne": "https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#",
  "strdf": "http://strdf.di.uoa.gr/ontology#",
  "gf": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
  "raul": "http://vocab.deri.ie/raul#",
  "oae": "http://www.ics.forth.gr/isl/oae/core#",
  "brick": "https://brickschema.org/schema/Brick#",
  "pnt": "http://data.press.net/ontology/tag/",
  "li": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
  "pkmn": "http://pokedex.dataincubator.org/pkm/",
  "goog": "http://schema.googleapis.com/",
  "rmo": "http://eatld.et.tu-dresden.de/rmo#",
  "bihap": "http://bihap.kb.gov.tr/ontology/",
  "ekaw": "http://data.semanticweb.org/conference/ekaw/2012/complete/",
  "pv": "https://piveau.eu/ns/voc#",
  "conf": "http://richard.cyganiak.de/2007/pubby/config.rdf#",
  "qud": "http://qudt.org/1.1/schema/qudt#",
  "mico": "http://www.mico-project.eu/ns/platform/1.0/schema#",
  "hints2005": "http://purl.org/twc/cabig/model/HINTS2005-1.owl#",
  "rdafnm": "http://rdaregistry.info/termList/FormNoteMus/",
  "lsmap": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "op": "http://environment.data.gov.au/def/op#",
  "scoro": "http://purl.org/spar/scoro/",
  "ccrel": "http://creativecommons.org/ns#",
  "part": "http://purl.org/vocab/participation/schema#",
  "emtr": "http://purl.org/NET/ssnext/electricmeters#",
  "odrs": "http://schema.theodi.org/odrs#",
  "dr": "http://purl.org/swan/2.0/discourse-relationships/",
  "oplcert": "http://www.openlinksw.com/schemas/cert#",
  "crv": "http://purl.org/twc/vocab/datacarver#",
  "rdasoi": "http://rdaregistry.info/termList/statIdentification/",
  "ep": "http://eprints.org/ontology/",
  "rdarel2": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
  "esco": "http://data.europa.eu/esco/model#",
  "geovocab": "http://geovocab.org/",
  "l4lod": "http://ns.inria.fr/l4lod/v2/",
  "dbcat": "http://dbpedia.org/resource/Category:",
  "crml": "http://semweb.mmlab.be/ns/rml/condition#",
  "mmf": "http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#",
  "stories": "http://purl.org/ontology/stories/",
  "d2d": "http://rdfns.org/d2d/",
  "bgt": "https://bgt.basisregistraties.overheid.nl/bgt/def/",
  "dawgt": "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
  "c4dm": "http://purl.org/NET/c4dm/event.owl#",
  "rdae": "http://rdaregistry.info/Elements/e/",
  "activity": "https://www.w3.org/TR/activitystreams-vocabulary/",
  "semio": "http://www.lingvoj.org/semio#",
  "dcs": "http://ontologi.es/doap-changeset#",
  "lcy": "http://purl.org/vocab/lifecycle/schema#",
  "s4ac": "http://ns.inria.fr/s4ac/v2#",
  "bn": "http://babelnet.org/rdf/",
  "wb": "http://data.worldbank.org/",
  "webbox": "http://webbox.ecs.soton.ac.uk/ns#",
  "namespaces": "https://vg.no/",
  "vsso": "http://automotive.eurecom.fr/vsso#",
  "rssynd": "http://web.resource.org/rss/1.0/modules/syndication/",
  "seokoeln": "http://rankrage.de/",
  "sdmxd": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "kbv": "https://id.kb.se/vocab/",
  "seq": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
  "wikterms": "http://wiktionary.dbpedia.org/terms/",
  "kees": "http://linkeddata.center/kees/v1#",
  "ll": "http://lodlaundromat.org/resource/",
  "cwrc": "http://sparql.cwrc.ca/ontology/cwrc#",
  "lsqv": "http://lsq.aksw.org/vocab#",
  "mv": "http://schema.mobivoc.org/",
  "xapi": "https://w3id.org/xapi/ontology#",
  "bgn": "http://bibliograph.net/schemas/",
  "holding": "http://purl.org/ontology/holding#",
  "cbo": "http://comicmeta.org/cbo/",
  "oan": "http://data.lirmm.fr/ontologies/oan/",
  "quantities": "http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#",
  "puelia": "http://kwijibo.talis.com/vocabs/puelia#",
  "mb": "http://dbtune.org/musicbrainz/resource/instrument/",
  "rdacontent": "http://rdvocab.info/termList/RDAContentType/",
  "allot": "https://w3id.org/akn/ontology/allot#",
  "gastro": "http://www.ebsemantics.net/gastro#",
  "lodac": "http://lod.ac/ns/lodac#",
  "pnc": "http://data.press.net/ontology/classification/",
  "tg": "https://triplydb.com/Triply/tg/def/",
  "prof": "http://www.w3.org/ns/dx/prof/",
  "deps": "http://ontologi.es/doap-deps#",
  "im": "http://imgpedia.dcc.uchile.cl/resource/",
  "pingback": "http://purl.org/net/pingback/",
  "nidm": "http://nidm.nidash.org/",
  "saws": "http://purl.org/saws/ontology#",
  "gl": "http://schema.geolink.org/",
  "my": "http://www.mobile.com/model/",
  "omapi": "http://purl.org/omapi/0.2/#",
  "finlaw": "http://purl.org/finlex/schema/laki/",
  "mged": "http://mged.sourceforge.net/ontologies/MGEDOntology.owl#",
  "eui": "http://institutions.publicdata.eu/#",
  "vsws": "http://verticalsearchworks.com/ontology/synset#",
  "sg": "http://name.scigraph.com/ontologies/core/",
  "mt": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "scip": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
  "rdacct": "http://rdaregistry.info/termList/CollTitle/",
  "spt": "http://spitfire-project.eu/ontology/ns/",
  "ogc": "http://www.opengis.net/def/",
  "disease": "http://www.agfa.com/w3c/2009/humanDisorder#",
  "ccp": "http://cookingbigdata.com/linkeddata/ccpricing#",
  "auto": "http://auto.schema.org/",
  "rdamedia": "http://rdvocab.info/termList/RDAMediaType/",
  "pattern": "http://www.essepuntato.it/2008/12/pattern#",
  "pni": "http://data.press.net/ontology/identifier/",
  "gm": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
  "lsweb": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "xcql": "http://docs.oasis-open.org/ns/search-ws/xcql#",
  "ljkl": "http://teste.com/",
  "rdatc": "http://rdaregistry.info/termList/trackConfig/",
  "dqm": "http://purl.org/dqm-vocabulary/v1/dqm#",
  "onyx": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
  "c9d": "http://purl.org/twc/vocab/conversion/",
  "delta": "http://www.w3.org/2004/delta#",
  "laposte": "http://data.lirmm.fr/ontologies/laposte#",
  "dbpr": "http://dbpedia.org/resource/",
  "fos": "http://futurios.org/fos/spec/",
  "dbrc": "http://dbpedia.org/resource/Category:",
  "rdagd": "http://rdaregistry.info/termList/gender/",
  "quty": "http://www.telegraphis.net/ontology/measurement/quantity#",
  "mrel": "http://id.loc.gov/vocabulary/relators/",
  "doi": "https://doi.org/",
  "cbase": "http://ontologycentral.com/2010/05/cb/vocab#",
  "wkd": "http://schema.wolterskluwer.de/",
  "foam": "https://www.koerperfettwaage-test.de/",
  "tblcard": "http://www.w3.org/People/Berners-Lee/card#",
  "dcndl": "http://ndl.go.jp/dcndl/terms/",
  "bgcat": "http://bg.dbpedia.org/resource/?????????:",
  "fog": "https://w3id.org/fog#",
  "rvdata": "http://data.rvdata.us/",
  "affymetrix": "http://bio2rdf.org/affymetrix_vocabulary:",
  "ox": "http://vocab.ox.ac.uk/projectfunding#",
  "friends": "http://www.openarchives.org/OAI/2.0/friends/",
  "cvbase": "http://purl.org/captsolo/resume-rdf/0.2/base#",
  "app": "http://jmvanel.free.fr/ontology/software_applications.n3#",
  "telmap": "http://purl.org/telmap/",
  "tsioc": "http://rdfs.org/sioc/types#",
  "bot": "https://w3id.org/bot#",
  "lmo": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#",
  "moac": "http://observedchange.com/moac/ns#",
  "oss": "http://opendata.caceres.es/def/ontosemanasanta#",
  "fam": "http://vocab.fusepool.info/fam#",
  "ostop": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
  "lldr": "http://purl.oclc.org/NET/lldr/ns#",
  "snarm": "http://rdf.myexperiment.org/ontologies/snarm/",
  "osspr": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "accom": "http://purl.org/acco/ns#",
  "ftcontent": "http://www.ft.com/ontology/content/",
  "stats": "http://purl.org/rdfstats/stats#",
  "bcnbio": "http://datos.bcn.cl/ontologies/bcn-biographies#",
  "orth": "http://purl.org/net/orth#",
  "fincaselaw": "http://purl.org/finlex/schema/oikeus/",
  "isocat": "http://www.isocat.org/datcat/",
  "pair": "http://virtual-assembly.org/ontologies/pair#",
  "origins": "http://origins.link/",
  "evident": "http://purl.org/net/evident#",
  "spfood": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
  "daisy": "http://www.daisy.org/z3998/2012/vocab/",
  "mml": "http://www.w3.org/1998/Math/MathML/",
  "employee": "http://www.employee.com/data#",
  "od": "http://purl.org/twc/vocab/opendap#",
  "biro": "http://purl.org/spar/biro/",
  "dvia": "http://data.eurecom.fr/ontology/dvia#",
  "eumida": "http://data.kasabi.com/dataset/eumida/terms/",
  "gcis": "http://data.globalchange.gov/gcis.owl#",
  "mvco": "http://purl.oclc.org/NET/mvco.owl#",
  "rdami": "http://rdaregistry.info/termList/modeIssue/",
  "driver": "http://deductions.github.io/drivers.owl.ttl#",
  "dbptmpl": "http://dbpedia.org/resource/Template:",
  "wn31": "http://wordnet-rdf.princeton.edu/wn31/",
  "add": "https://mre.zcu.cz/ontology/stroke.owl#",
  "dao": "http://purl.org/dao#",
  "esaloj": "http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#",
  "viso": "http://purl.org/viso/",
  "nerd": "http://nerd.eurecom.fr/ontology#",
  "salad": "https://w3id.org/cwl/salad#",
  "drm": "http://vocab.data.gov/def/drm#",
  "swperson": "http://data.semanticweb.org/person/",
  "particip": "http://purl.org/vocab/participation/schema#",
  "mtlo": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
  "mil": "http://rdf.muninn-project.org/ontologies/military#",
  "turismo": "http://idi.fundacionctic.org/cruzar/turismo#",
  "gpml": "http://vocabularies.wikipathways.org/gpml#",
  "company": "http://intellimind.io/ns/company#",
  "onc": "http://www.ics.forth.gr/isl/oncm/core#",
  "rdagw": "http://rdaregistry.info/termList/grooveWidth/",
  "merge": "http://jazz.net/ns/lqe/merge/",
  "sct": "http://snomed.info/id/",
  "graffle": "http://purl.org/twc/vocab/vsr/graffle#",
  "radion": "http://www.w3.org/ns/radion#",
  "pkm": "http://www.ontotext.com/proton/protonkm#",
  "call": "http://webofcode.org/wfn/call:",
  "lsd": "http://linkedwidgets.org/statisticaldata/ontology/",
  "cdao": "http://purl.obolibrary.org/obo/",
  "fcs": "http://clarin.eu/fcs/resource#",
  "pvcs": "http://purl.org/twc/vocab/pvcs#",
  "pmd": "https://w3id.org/pmd/co/",
  "ws": "http://www.w3.org/ns/pim/space#",
  "language": "http://id.loc.gov/vocabulary/iso639-1/",
  "aers": "http://aers.data2semantics.org/resource/",
  "gawd": "http://gawd.atlantides.org/terms/",
  "lden": "http://www.linklion.org/lden/",
  "dogont": "http://elite.polito.it/ontologies/dogont.owl#",
  "viskov": "http://trust.utep.edu/visko/ontology/visko-view-v3.owl#",
  "agls": "http://www.agls.gov.au/agls/terms/",
  "ou": "https://opendata.unex.es/def/ontouniversidad#",
  "agr": "http://promsns.org/def/agr#",
  "odpart": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
  "oh": "http://semweb.mmlab.be/ns/oh#",
  "hto": "http://project-haystack.org/hto#",
  "pato": "http://purl.obolibrary.org/obo/",
  "webservice": "http://www.openlinksw.com/ontology/webservices#",
  "rdabm": "http://rdaregistry.info/termList/RDABaseMaterial/",
  "llo": "http://lodlaundromat.org/ontology/",
  "lpeu": "http://purl.org/linkedpolitics/vocabulary/eu/plenary/",
  "rdarel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "voidp": "http://www.enakting.org/provenance/voidp/",
  "w3po": "http://purl.org/provenance/w3p/w3po#",
  "geojson": "https://purl.org/geojson/vocab#",
  "infor": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "ctorg": "http://purl.org/ctic/infraestructuras/organizacion#",
  "icane": "http://www.icane.es/opendata/vocab#",
  "qb4o": "http://purl.org/olap#",
  "ramon": "http://rdfdata.eionet.europa.eu/ramon/ontology/",
  "odapp": "http://vocab.deri.ie/odapp#",
  "esequip": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#",
  "ids": "https://w3id.org/idsa/core/",
  "ontopic": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
  "uc": "http://ucuenca.edu.ec/ontology#",
  "eurostat": "http://dd.eionet.europa.eu/vocabulary/eurostat/",
  "pic": "http://www.ipaw.info/ns/picaso#",
  "lw": "http://linkedwidgets.org/ontologies/",
  "npgx": "http://ns.nature.com/extensions/",
  "samfl": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
  "s4envi": "https://w3id.org/def/saref4envi#",
  "ldt": "https://www.w3.org/ns/ldt#",
  "dot": "https://w3id.org/dot#",
  "sylld": "http://www.semanticweb.org/syllabus/data/",
  "being": "http://purl.org/ontomedia/ext/common/being#",
  "dcoid": "http://dx.deepcarbon.net/",
  "phdd": "http://rdf-vocabulary.ddialliance.org/phdd#",
  "swpm": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
  "lexicon": "http://www.example.org/lexicon#",
  "bioc": "http://deductions.github.io/biological-collections.owl.ttl#",
  "olad": "http://openlad.org/vocab#",
  "step": "http://purl.org/net/step#",
  "s3db": "http://www.s3db.org/core#",
  "imo": "http://imgpedia.dcc.uchile.cl/ontology#",
  "lexcz": "http://purl.org/lex/cz#",
  "wfn": "http://webofcode.org/wfn/",
  "emoca": "http://ns.inria.fr/emoca#",
  "dcx": "http://dublincore.org/dcx/",
  "lmm1": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
  "rdact": "http://rdaregistry.info/termList/RDACarrierType/",
  "lda": "http://purl.org/linked-data/api/vocab#",
  "qvoc": "http://mlode.nlp2rdf.org/quranvocab#",
  "pmc": "http://identifiers.org/pmc/",
  "bwb": "http://doc.metalex.eu/bwb/ontology/",
  "d0": "http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#",
  "roevo": "http://purl.org/wf4ever/roevo#",
  "cmdm": "http://infra.clarin.eu/cmd/",
  "hico": "http://purl.org/emmedi/hico/",
  "year": "http://www.w3.org/year/",
  "geos": "http://www.telegraphis.net/ontology/geography/geography#",
  "fire": "http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#",
  "situ": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "zr": "http://explain.z3950.org/dtd/2.0/",
  "bgdbr": "http://bg.dbpedia.org/resource/",
  "waarde": "https://lod.milieuinfo.be/ns/waarde#",
  "dcite": "http://purl.org/spar/datacite/",
  "rdl": "http://data.posccaesar.org/rdl/",
  "ceterms": "http://purl.org/ctdl/terms/",
  "ppn": "http://parliament.uk/ontologies/person-name/",
  "dbtont": "http://dbtropes.org/ont/",
  "gt": "https://vocab.eccenca.com/geniustex/",
  "ns1": "http://www.w3.org/1999/xhtml/vocab#",
  "lmm2": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
  "agrd": "http://agrinepaldata.com/",
  "dio": "https://w3id.org/dio#",
  "tddo": "http://databugger.aksw.org/ns/core#",
  "wikim": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
  "amalgame": "http://purl.org/vocabularies/amalgame#",
  "gnvc": "http://purl.org/gc/",
  "olac": "http://www.language-archives.org/OLAC/1.0/",
  "bbcprov": "http://www.bbc.co.uk/ontologies/provenance/",
  "puml": "http://plantuml.com/ontology#",
  "si": "https://si-digital-framework.org/SI#",
  "vvo": "http://purl.org/vvo/ns#",
  "msm": "http://iserve.kmi.open.ac.uk/ns/msm#",
  "scufl2": "http://ns.taverna.org.uk/2010/scufl2#",
  "static": "http://vocab-ld.org/vocab/static-ld#",
  "roar": "https://w3id.org/roar#",
  "galaksiya": "http://ontoloji.galaksiya.com/vocab/",
  "omnfed": "http://open-multinet.info/ontology/omn-federation#",
  "jolux": "http://data.legilux.public.lu/resource/ontology/jolux#",
  "gaf": "http://groundedannotationframework.org/",
  "vext": "http://ldf.fi/void-ext#",
  "eunis": "http://eunis.eea.europa.eu/rdf/species-schema.rdf#",
  "wf4ever": "http://purl.org/wf4ever/wf4ever#",
  "elec": "http://purl.org/ctic/sector-publico/elecciones#",
  "gadm": "http://gadm.geovocab.org/ontology#",
  "pois": "http://purl.oclc.org/POIS/vcblr#",
  "kai": "http://kai.uni-kiel.de/",
  "rdafs": "http://rdaregistry.info/termList/fontSize/",
  "viskoo": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "ecglview": "http://schema.geolink.org/view/",
  "ldl": "https://w3id.org/ldpdl/ns#",
  "airs": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
  "dq": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
  "vag": "http://www.essepuntato.it/2013/10/vagueness/",
  "vir": "http://w3id.org/vir#",
  "fred": "http://www.ontologydesignpatterns.org/ont/fred/domain.owl#",
  "lmdb": "http://data.linkedmdb.org/",
  "vmm": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
  "vsw": "http://verticalsearchworks.com/ontology/",
  "jp1": "http://rdf.muninn-project.org/ontologies/jp1/",
  "pcdt": "http://purl.org/procurement/public-contracts-datatypes#",
  "graves": "http://rdf.muninn-project.org/ontologies/graves#",
  "pid": "http://permid.org/ontology/organization/",
  "osadm": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "bnf": "http://www.w3.org/2000/10/swap/grammar/bnf#",
  "locwd": "http://purl.org/locwd/schema#",
  "aws": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
  "biotop": "http://purl.org/biotop/biotop.owl#",
  "rut": "http://rdfunit.aksw.org/ns/core#",
  "coll": "http://purl.org/co/",
  "owl2xml": "http://www.w3.org/2006/12/owl2-xml#",
  "prviv": "http://purl.org/net/provenance/integrity#",
  "omdoc": "http://omdoc.org/ontology/",
  "odbc": "http://www.openlinksw.com/ontology/odbc#",
  "regorg": "http://www.w3.org/ns/regorg#",
  "trig": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "moo": "http://www.movieontology.org/2009/11/09/movieontology.owl#",
  "fuseki": "http://jena.apache.org/fuseki#",
  "rdagrp": "http://rdaregistry.info/termList/groovePitch/",
  "opengov": "http://www.w3.org/opengov#",
  "vapour": "http://vapour.sourceforge.net/vocab.rdf#",
  "npdv": "http://sws.ifi.uio.no/vocab/npd#",
  "poste": "http://data.lirmm.fr/ontologies/poste#",
  "gci": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
  "location": "http://sw.deri.org/2006/07/location/loc#",
  "oplprod": "http://www.openlinksw.com/ontology/products#",
  "uis": "http://uis.270a.info/dataset/",
  "llm": "http://lodlaundromat.org/metrics/ontology/",
  "genre": "http://sparql.cwrc.ca/ontologies/genre#",
  "frb": "http://frb.270a.info/dataset/",
  "rvz": "http://rdfvizler.dyreriket.xyz/vocabulary/core#",
  "rdatr": "http://rdaregistry.info/termList/typeRec/",
  "crime": "http://purl.org/vocab/reloc/",
  "mammal": "http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#",
  "fnabox": "http://www.ontologydesignpatterns.org/ont/framenet/abox/",
  "rlnr": "http://rdflivenews.aksw.org/resource/",
  "led": "http://led.kmi.open.ac.uk/term/",
  "rdai": "http://rdaregistry.info/Elements/i/",
  "aktivesa": "http://sa.aktivespace.org/ontologies/aktivesa#",
  "lcdr": "http://ns.lucid-project.org/revision/",
  "teamwork": "http://topbraid.org/teamwork#",
  "ontosec": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
  "wn20": "http://www.w3.org/2006/03/wn/wn20/",
  "incident": "http://vocab.resc.info/incident#",
  "fcp": "http://www.newmedialab.at/fcp/",
  "bpo": "https://w3id.org/bpo#",
  "proms": "http://promsns.org/def/proms#",
  "geosp": "http://rdf.geospecies.org/ont/geospecies#",
  "rdacc": "http://rdaregistry.info/termList/RDAColourContent/",
  "topo": "http://data.ign.fr/def/topo#",
  "acrt": "http://privatealpha.com/ontology/certification/1#",
  "dsn": "http://purl.org/dsnotify/vocab/eventset/",
  "beth": "http://www.google.com/",
  "pdf": "http://ns.adobe.com/pdf/1.3/",
  "cpack": "http://cliopatria.swi-prolog.org/schema/cpack#",
  "opmo": "http://openprovenance.org/model/opmo#",
  "vrank": "http://purl.org/voc/vrank#",
  "mmoon": "http://mmoon.org/mmoon/",
  "lido": "http://www.lido-schema.org/",
  "eccauth": "https://vocab.eccenca.com/auth/",
  "obeu": "http://data.openbudgets.eu/ontology/",
  "geocontext": "http://www.geocontext.org/publ/2013/vocab#",
  "pwo": "http://purl.org/spar/pwo/",
  "jpost": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "saif": "http://wwwiti.cs.uni-magdeburg.de/~srahman/",
  "oecc": "http://www.oegov.org/core/owl/cc#",
  "pkgsrc": "http://pkgsrc.co/schema#",
  "cd": "http://citydata.wu.ac.at/ns#",
  "ssno": "http://www.w3.org/ns/ssn/",
  "frbrer": "http://iflastandards.info/ns/fr/frbr/frbrer/",
  "reg": "http://purl.org/linked-data/registry#",
  "mocanal": "http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#",
  "bner": "http://datos.bne.es/resource/",
  "ali": "http://www.niso.org/schemas/ali/1.0/",
  "output": "http://volt-name.space/vocab/output#",
  "owlse": "http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#",
  "cwlprov": "https://w3id.org/cwl/prov#",
  "rdf123": "http://rdf123.umbc.edu/ns/",
  "limo": "http://www.purl.org/limo-ontology/limo#",
  "omg": "https://w3id.org/omg#",
  "studiop": "http://purl.org/resource/pilatesstudio/",
  "ldvm": "http://linked.opendata.cz/ontology/ldvm/",
  "text": "http://jena.apache.org/text#",
  "sto": "https://w3id.org/i40/sto#",
  "sx": "http://shex.io/ns/shex#",
  "locah": "http://data.archiveshub.ac.uk/def/",
  "ln": "https://w3id.org/ln#",
  "condition": "http://www.kinjal.com/condition:",
  "reegle": "http://reegle.info/schema#",
  "passim": "http://data.lirmm.fr/ontologies/passim#",
  "hlygt": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "rdafmn": "http://rdaregistry.info/termList/MusNotation/",
  "afr": "http://purl.allotrope.org/ontologies/result#",
  "odv": "http://reference.data.gov.uk/def/organogram/",
  "ecgl": "http://schema.geolink.org/",
  "rofch": "http://rdaregistry.info/termList/rofch/",
  "logies": "https://data.vlaanderen.be/ns/logies#",
  "bcngeo": "http://datos.bcn.cl/ontologies/bcn-geographics#",
  "limoo": "http://purl.org/LiMo/0.1/",
  "glview": "http://schema.geolink.org/dev/view/",
  "pfeepsa": "https://w3id.org/pfeepsa#",
  "kegg": "http://bio2rdf.org/ns/kegg#",
  "edgar": "http://edgarwrap.ontologycentral.com/vocab/edgar#",
  "rdarm": "http://registry.info/termList/recMedium/",
  "r3d": "http://www.re3data.org/schema/3-0#",
  "tis": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#",
  "roterms": "http://purl.org/wf4ever/roterms#",
  "tb": "https://w3id.org/timebank#",
  "orcid": "http://orcid.org/",
  "imf": "http://imf.270a.info/dataset/",
  "rdarole": "http://rdvocab.info/roles/",
  "tui": "http://data.ifs.tuwien.ac.at/study/resource/",
  "webac": "http://fedora.info/definitions/v4/webac#",
  "oils": "http://lemon-model.net/oils#",
  "defns": "http://www.openarchives.org/OAI/2.0/",
  "sru": "http://www.loc.gov/zing/srw/",
  "plg": "http://parliament.uk/ontologies/legislation/",
  "sirene": "https://sireneld.io/vocab/sirene#",
  "frsad": "http://iflastandards.info/ns/fr/frsad/",
  "eem": "http://purl.org/eem#",
  "rdaftn": "http://rdaregistry.info/termList/TacNotation/",
  "laabs": "http://dbpedia.org/resource/",
  "iana": "http://www.iana.org/assignments/relation/",
  "voc": "http://voc.odw.tw/",
  "cocoon": "https://w3id.org/cocoon/v1.0#",
  "babelnet": "http://babelnet.org/2.0/",
  "caplibacl": "http://schemas.capita-libraries.co.uk/2015/acl/schema#",
  "lexvo": "http://lexvo.org/ontology#",
  "muldicat": "http://iflastandards.info/ns/muldicat#",
  "datacite": "http://purl.org/spar/datacite/",
  "nxs": "http://www.neclimateus.org/",
  "rdaterm": "http://rdaregistry.info/termList/RDATerms/",
  "form": "http://deductions-software.com/ontologies/forms.owl.ttl#",
  "csv": "http://vocab.sindice.net/csv/",
  "basic": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
  "ubiq": "http://server.ubiqore.com/ubiq/core#",
  "figigii": "http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/",
  "afm": "http://purl.allotrope.org/ontologies/material/",
  "crowd": "http://purl.org/crowd/",
  "eccrev": "https://vocab.eccenca.com/revision/",
  "lyon": "http://dbpedia.org/resource/Lyon/",
  "spdx": "http://spdx.org/rdf/terms#",
  "jjd": "http://www.joshuajeeson.com/",
  "rdaco": "http://rdaregistry.info/termList/RDAContentType/",
  "citof": "http://www.essepuntato.it/2013/03/cito-functions#",
  "gq": "http://genomequest.com/",
  "shui": "https://vocab.eccenca.com/shui/",
  "ordf": "http://purl.org/NET/ordf/",
  "dicom": "http://purl.org/healthcarevocab/v1#",
  "task": "http://deductions.github.io/task-management.owl.ttl#",
  "agrovoc": "http://aims.fao.org/aos/agrovoc/",
  "pproc": "http://contsem.unizar.es/def/sector-publico/pproc#",
  "eepsa": "https://w3id.org/eepsa#",
  "fntbox": "http://www.ontologydesignpatterns.org/ont/framenet/tbox/",
  "gts": "http://resource.geosciml.org/ontology/timescale/gts#",
  "customer": "http://www.valuelabs.com/",
  "mdi": "http://w3id.org/multidimensional-interface/ontology#",
  "gdc": "https://portal.gdc.cancer.gov/cases/",
  "iati": "http://purl.org/collections/iati/",
  "lingvo": "http://www.lingvoj.org/ontology#",
  "meeting": "http://www.w3.org/2002/07/meeting#",
  "lawd": "http://lawd.info/ontology/",
  "oxi": "http://omerxi.com/ontologies/core.owl.ttl#",
  "bbccms": "http://www.bbc.co.uk/ontologies/cms/",
  "conference": "https://w3id.org/scholarlydata/ontology/conference-ontology.owl#",
  "water": "http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#",
  "yd": "https://yodata.io/",
  "csp": "http://vocab.deri.ie/csp#",
  "lofv": "http://purl.org/legal_form/vocab#",
  "rls": "https://w3id.org/lovcube/ns/relovstats#",
  "oplecrm": "http://www.openlinksw.com/ontology/ecrm#",
  "hva": "http://www.ebusiness-unibw.org/ontologies/hva/ontology#",
  "ruian": "https://data.cssz.cz/ontology/ruian/",
  "lswpm": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
  "open311": "http://ontology.eil.utoronto.ca/open311#",
  "bevon": "http://rdfs.co/bevon/",
  "fhir": "http://hl7.org/fhir/",
  "oplcb": "http://www.openlinksw.com/schemas/crunchbase#",
  "cbim": "http://www.coinsweb.nl/cbim-2.0.rdf#",
  "clirio": "http://clirio.kaerle.com/clirio.owl#",
  "bb": "http://www.snik.eu/ontology/bb/",
  "owsom": "https://onlinesocialmeasures.wordpress.com/",
  "rdalay": "http://rdaregistry.info/termList/layout/",
  "cim": "http://iec.ch/TC57/2013/CIM-schema-cim16#",
  "eurlex": "http://eur-lex.publicdata.eu/ontology/",
  "asgv": "http://aims.fao.org/aos/agrovoc/",
  "contsem": "http://contsem.unizar.es/def/sector-publico/contratacion#",
  "lswmo": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
  "umls": "http://bioportal.bioontology.org/ontologies/umls/",
  "pep": "https://w3id.org/pep/",
  "sdmxcode": "http://purl.org/linked-data/sdmx/2009/code#",
  "infection": "http://www.agfa.com/w3c/2009/infectiousDisorder#",
  "nlon": "http://lod.nl.go.kr/ontology/",
  "tree": "https://w3id.org/tree#",
  "tsn": "http://purl.org/net/tsn#",
  "voidext": "http://rdfs.org/ns/void-ext#",
  "vdpp": "http://data.lirmm.fr/ontologies/vdpp#",
  "roadmap": "http://mappings.roadmap.org/",
  "volt": "http://volt-name.space/ontology/",
  "qms": "http://data.europa.eu/esco/qms#",
  "bdc": "http://dbpedia.org/resource/Category:",
  "bsym": "http://bsym.bloomberg.com/sym/",
  "county": "http://myexample.org/county#",
  "oprovo": "http://openprovenance.org/ontology#",
  "essglobal": "http://purl.org/essglobal/vocab/v1.0/",
  "videogame": "http://purl.org/net/vgo#",
  "sfd": "http://semantic-forms.cc:9112/ldp/",
  "rdarr": "http://rdaregistry.info/termList/RDAReductionRatio/",
  "mls": "http://www.w3.org/ns/mls#",
  "hr": "http://iserve.kmi.open.ac.uk/ns/hrests#",
  "drk": "http://drakon.su/",
  "swpatho": "http://swpatho.ag-nbi.de/context/meta.owl#",
  "ha": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
  "fun": "http://w3id.org/sparql-generate/fn/",
  "ago": "http://awesemantic-geo.link/ontology/",
  "organ": "http://www.univalle.edu.co/ontologies/Organ#",
  "scco": "http://rdf.ebi.ac.uk/terms/surechembl#",
  "dsv": "https://w3id.org/dsv#",
  "fr": "https://w3id.org/fr/def/core#",
  "mexv": "http://mex.aksw.org/mex-algo#",
  "trao": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
  "rofer": "http://rdaregistry.info/termList/rofer/",
  "keys": "http://purl.org/NET/c4dm/keys.owl#",
  "owms": "http://standaarden.overheid.nl/owms/terms/",
  "adf": "http://purl.allotrope.org/ontologies/datapackage#",
  "uom": "http://www.opengis.net/def/uom/OGC/1.0/",
  "cmdi": "http://www.clarin.eu/cmd/",
  "pp": "http://peoplesplaces.de/ontology#",
  "ja": "http://jena.hpl.hp.com/2005/11/Assembler#",
  "wdtn": "http://www.wikidata.org/prop/direct-normalized/",
  "sakthi": "http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/",
  "rdafrbr": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
  "numbers": "http://km.aifb.kit.edu/projects/numbers/",
  "rdag2": "http://rdvocab.info/ElementsGr2/",
  "chear": "http://hadatac.org/ont/chear#",
  "lmx": "http://www.w3.org/XML/1998/namespace/",
  "bds": "http://www.bigdata.com/rdf/search#",
  "mmt": "http://linkedmultimedia.org/sparql-mm/functions/temporal#",
  "composer": "http://dbpedia.org/ontology/composer/",
  "ogbd": "http://www.ogbd.fr/2012/ontologie#",
  "soch": "http://kulturarvsdata.se/ksamsok#",
  "dpn": "http://purl.org/dpn#",
  "cwl": "https://w3id.org/cwl/cwl#",
  "lgdm": "http://linkedgeodata.org/meta/",
  "apf": "http://jena.apache.org/ARQ/property#",
  "diag": "http://www.loc.gov/zing/srw/diagnostic/",
  "opa": "https://w3id.org/laas-iot/adream#",
  "td5": "http://td5.org/#",
  "csdbp": "http://cs.dbpedia.org/",
  "cjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "lslife": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
  "ruto": "http://rdfunit.aksw.org/ns/core#",
  "rofrr": "http://rdaregistry.info/termList/rofrr/",
  "radar": "http://www.radar-projekt.org/display/",
  "demlab": "http://www.demcare.eu/ontologies/demlab.owl#",
  "bblfish": "http://bblfish.net/people/henry/card#",
  "doacc": "http://purl.org/net/bel-epa/doacc#",
  "munc": "http://ns.inria.fr/munc#",
  "kml": "http://www.opengis.net/kml/2.2#",
  "cwork": "http://www.bbc.co.uk/ontologies/creativework/",
  "crsw": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "itm": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
  "one": "https://bioportal.bioontology.org/ontologies/ONE/",
  "az": "https://w3id.org/people/az/",
  "door": "http://kannel.open.ac.uk/ontology#",
  "ndnp": "http://chroniclingamerica.loc.gov/terms#",
  "jerm": "http://jermontology.org/ontology/JERMOntology#",
  "vstoi": "http://hadatac.org/ont/vstoi#",
  "seeds": "http://deductions.github.io/seeds.owl.ttl#",
  "ctrl": "https://w3id.org/ibp/CTRLont#",
  "dk": "http://www.data-knowledge.org/dk/schema/rdf/latest/",
  "rdasco": "http://rdaregistry.info/termList/soundCont/",
  "wimpo": "http://rdfex.org/withImports?uri=",
  "navm": "https://w3id.org/navigation_menu#",
  "rofem": "http://rdaregistry.info/termList/rofem/",
  "whisky": "http://vocab.org/whisky/terms/",
  "rofid": "http://rdaregistry.info/termList/rofid/",
  "dcosample": "http://info.deepcarbon.net/sample/schema#",
  "aprov": "http://purl.org/a-proc#",
  "amt": "http://academic-meta-tool.xyz/vocab#",
  "audit": "http://fedora.info/definitions/v4/audit#",
  "bob": "http://good.dad/meaning/bob#",
  "faostat": "http://reference.eionet.europa.eu/faostat/schema/",
  "olca": "http://www.lingvoj.org/olca#",
  "bld": "http://biglinkeddata.com/",
  "mds": "http://doc.metalex.eu/id/",
  "opllog": "http://www.openlinksw.com/ontology/logging#",
  "markus": "http://www.markus.com/",
  "sdshare": "http://www.sdshare.org/2012/extension/",
  "mexalgo": "http://mex.aksw.org/mex-algo#",
  "hasneto": "http://hadatac.org/ont/hasneto#",
  "rpath": "https://w3id.org/lodsight/rdf-path#",
  "scho": "http://www.scholarlydata.org/ontology/conference-ontology.owl#",
  "bis": "http://bis.270a.info/dataset/",
  "oliasystem": "http://purl.org/olia/system.owl#",
  "mandaat": "http://data.vlaanderen.be/ns/mandaat#",
  "assoc": "https://w3id.org/associations/vocab#",
  "maso": "http://securitytoolbox.appspot.com/MASO#",
  "datex": "http://vocab.datex.org/terms#",
  "ecore": "http://www.eclipse.org/emf/2002/Ecore#",
  "lg": "https://purl.org/lg/",
  "bdo": "http://purl.bdrc.io/ontology/core/",
  "efrbroo": "http://erlangen-crm.org/efrbroo/",
  "svcs": "http://rdfs.org/sioc/services#",
  "osd": "http://a9.com/-/spec/opensearch/1.1/",
  "hello": "https://www.youtube.com/user/SuperTellAFriend/featured/",
  "lheo": "http://www.conjecto.com/ontology/2015/lheo#",
  "oplli": "http://www.openlinksw.com/schemas/linkedin#",
  "frappe": "http://streamreasoning.org/ontologies/frappe#",
  "fnom": "https://w3id.org/function/vocabulary/mapping#",
  "oplmkt": "http://www.openlinksw.com/ontology/market#",
  "conll": "http://ufal.mff.cuni.cz/conll2009-st/task-description.html#",
  "bbccore": "http://www.bbc.co.uk/ontologies/coreconcepts/",
  "timex": "http://data.wu.ac.at/ns/timex#",
  "erce": "http://xxefe.de/",
  "tix": "http://toptix.com/2010/esro/",
  "memento": "http://mementoweb.org/ns#",
  "rofrt": "http://rdaregistry.info/termList/rofrt/",
  "emergelm": "http://purl.org/emergel/modules#",
  "gbol": "http://gbol.life/0.1#",
  "physics": "http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#",
  "bdr": "http://purl.bdrc.io/resource/",
  "rdapmt": "http://rdaregistry.info/termList/prodTactile/",
  "sdt": "http://statisticaldata.linkedwidgets.org/terms/",
  "lovc": "https://w3id.org/lovcube/ns/lovcube#",
  "voidex": "http://www.swi-prolog.org/rdf/library/",
  "planet": "http://dbpedia.org/",
  "eol": "http://purl.org/biodiversity/eol/",
  "vogd": "http://ogd.ifs.tuwien.ac.at/vienna/geo/",
  "spcm": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
  "gnm": "http://www.geonames.org/ontology/mappings/",
  "escom": "http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#",
  "oplres": "http://www.openlinksw.com/ontology/restrictions#",
  "w3cgeo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "ofrd": "http://purl.org/opdm/refrigerator#",
  "llont": "http://www.linklion.org/ontology#",
  "ver": "https://w3id.org/version/ontology#",
  "biml": "http://schemas.varigence.com/biml.xsd#",
  "its": "http://www.w3.org/2005/11/its/rdf#",
  "sgg": "http://www.springernature.com/scigraph/graphs/",
  "yaco": "https://www.irit.fr/recherches/MELODI/ontologies/cinema#",
  "qkdv": "http://qudt.org/vocab/dimensionvector/",
  "rdaemm": "http://rdaregistry.info/termList/emulsionMicro/",
  "rdabf": "http://rdaregistry.info/termList/bookFormat/",
  "mwapi": "https://www.mediawiki.org/ontology#API/",
  "dbms": "http://www.openlinksw.com/ontology/dbms-app-ontology#",
  "edr": "https://w3id.org/laas-iot/edr#",
  "summa": "http://purl.org/voc/summa/",
  "eccpubsub": "https://vocab.eccenca.com/pubsub/",
  "traffic": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
  "rdacarx": "http://rdaregistry.info/termList/RDACarrierEU/",
  "eame": "http://www.semanticweb.org/ontologia_EA#",
  "lemonuby": "http://lemon-model.net/lexica/uby/",
  "swrc2": "https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#",
  "oplwebsrv": "http://www.openlinksw.com/ontology/webservices#",
  "rdaz": "http://rdaregistry.info/Elements/z/",
  "foaffff": "http://gogl.com/",
  "fdbp": "http://fr.dbpedia.org/property/",
  "rdabs": "http://rdaregistry.info/termList/broadcastStand/",
  "geod": "http://vocab.lenka.no/geo-deling#",
  "gont": "https://gont.ch/",
  "ecoll": "http://purl.org/ceu/eco/1.0#",
  "travel": "http://www.co-ode.org/roberts/travel.owl#",
  "otl": "https://w3id.org/opentrafficlights#",
  "oplweb": "http://www.openlinksw.com/schemas/oplweb#",
  "sgfn": "http://w3id.org/sparql-generate/fn/",
  "lmu": "https://w3id.org/laas-iot/lmu#",
  "vidont": "http://vidont.org/",
  "pmo": "http://premon.fbk.eu/ontology/core#",
  "rofin": "http://rdaregistry.info/termList/rofin/",
  "literature": "http://purl.org/net/cnyt-literature#",
  "oplstocks": "http://www.openlinksw.com/ontology/stocks#",
  "ensembl": "http://rdf.ebi.ac.uk/resource/ensembl/",
  "ims": "http://www.imsglobal.org/xsd/imsmd_v1p2/",
  "ntag": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "semiot": "http://w3id.org/semiot/ontologies/semiot#",
  "duv": "http://www.w3.org/ns/duv#",
  "iter": "http://w3id.org/sparql-generate/iter/",
  "frgeo": "http://rdf.insee.fr/geo/",
  "persee": "http://data.persee.fr/ontology/persee_ontology/",
  "eccdi": "https://vocab.eccenca.com/di/",
  "nno": "https://w3id.org/nno/ontology#",
  "s4syst": "https://saref.etsi.org/saref4syst/",
  "besluit": "http://data.vlaanderen.be/ns/besluit#",
  "minim": "http://purl.org/minim/minim#",
  "url": "http://schema.org/",
  "system": "http://www.univalle.edu.co/ontologies/System#",
  "oplacl": "http://www.openlinksw.com/ontology/acl#",
  "mem": "http://mementoweb.org/ns#",
  "spvqa": "https://bmake.th-brandenburg.de/spv#",
  "dbug": "http://ontologi.es/doap-bugs#",
  "aml": "https://w3id.org/i40/aml#",
  "espresup": "http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#",
  "oplbenefit": "http://www.openlinksw.com/ontology/benefits#",
  "ca": "http://complyadvantage.com/",
  "rdapm": "http://rdaregistry.info/termList/RDAproductionMethod/",
  "sorg": "http://schema.org/",
  "km4c": "http://www.disit.org/km4city/schema#",
  "cpov": "http://data.europa.eu/m8g/",
  "ipsv": "http://id.esd.org.uk/list/",
  "cubeont": "http://ontology.cube.global/",
  "lfov": "https://w3id.org/legal_form#",
  "rdaar": "http://rdaregistry.info/termList/AspectRatio/",
  "uta": "http://uptheasset.org/ontology#",
  "dsw": "http://purl.org/dsw/",
  "vehma": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "uby": "http://purl.org/olia/ubyCat.owl#",
  "meshv": "http://id.nlm.nih.gov/mesh/vocab#",
  "newsevents": "http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#",
  "cue": "http://www.clarin.eu/cmdi/cues/display/1.0#",
  "dcap": "http://purl.org/ws-mmi-dc/terms/",
  "pcdm": "http://pcdm.org/models#",
  "odf": "http://docs.oasis-open.org/ns/office/1.2/meta/odf#",
  "r4ta": "http://ns.inria.fr/ratio4ta/v1#",
  "nih": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "religion": "http://rdf.muninn-project.org/ontologies/religion#",
  "oup": "http://purl.org/ontology-use-patterns#",
  "nkos": "http://w3id.org/nkos#",
  "rgml": "http://purl.org/puninj/2001/05/rgml-schema#",
  "gns": "http://sws.geonames.org/",
  "h2o": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
  "vacseen1": "http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/",
  "rdfp": "https://w3id.org/rdfp/",
  "sfn": "http://semweb.datasciencelab.be/ns/sfn#",
  "onisep": "http://rdf.onisep.fr/resource/",
  "uneskos": "http://purl.org/voc/uneskos#",
  "rdag1": "http://rdvocab.info/Elements/",
  "fluidops": "http://www.fluidops.com/",
  "dwciri": "http://rs.tdwg.org/dwc/iri/",
  "ido": "http://purl.obolibrary.org/obo/ido.owl#",
  "irsteaont": "http://ontology.irstea.fr/weather/ontology#",
  "phy": "https://w3id.org/skgo/phy#",
  "pcit": "http://public-contracts.nexacenter.org/id/propertiesRole/",
  "nature": "http://deductions.github.io/nature_observation.owl.ttl#",
  "esapar": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#",
  "mexcore": "http://mex.aksw.org/mex-core#",
  "cpi": "http://www.ebusiness-unibw.org/ontologies/cpi/ns#",
  "bsh": "https://brickschema.org/schema/1.1.0/BrickShape#",
  "tx": "http://swtmp.gitlab.io/vocabulary/templates.owl#",
  "rofit": "http://rdaregistry.info/termList/rofit/",
  "id": "http://identifiers.org/",
  "cff": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
  "provinsi": "http://provinsi.com/",
  "pmhb": "http://pmhb.org/",
  "ioto": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
  "beo": "https://w3id.org/beo#",
  "rdafnv": "http://rdaregistry.info/termList/noteForm/",
  "vcard2006": "http://www.w3.org/2006/vcard/ns#",
  "tgm": "http://id.loc.gov/vocabulary/graphicMaterials/",
  "escjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "beer": "http://beer.com/",
  "swcomp": "https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#",
  "physo": "http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#",
  "esservicio": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#",
  "wsdl": "http://www.w3.org/ns/wsdl-rdf#",
  "dicera": "http://semweb.mmlab.be/ns/dicera#",
  "glycan": "http://purl.jp/bio/12/glyco/glycan#",
  "vplan": "http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#",
  "s4ee": "https://w3id.org/saref4ee#",
  "spv": "http://completeness.inf.unibz.it/sp-vocab#",
  "geovoid": "http://purl.org/geovocamp/ontology/geovoid/",
  "ilap": "http://data.posccaesar.org/ilap/",
  "iiif": "http://iiif.io/api/image/2#",
  "tarql": "http://tarql.github.io/tarql#",
  "aksw": "http://aksw.org/",
  "esadm": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#",
  "itcat": "http://th-brandenburg.de/ns/itcat#",
  "brk": "http://brk.basisregistraties.overheid.nl/def/brk#",
  "lmf": "http://www.lexinfo.net/lmf#",
  "rdacdt": "http://rdaregistry.info/termList/RDACartoDT/",
  "modsci": "https://w3id.org/skgo/modsci#",
  "literal": "http://www.essepuntato.it/2010/06/literalreification/",
  "veo": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
  "mmm": "http://www.mico-project.eu/ns/mmm/2.0/schema#",
  "naval": "http://rdf.muninn-project.org/ontologies/naval#",
  "dbfo": "http://dbpedia.org/facts/ontology#",
  "rdare": "http://rdaregistry.info/termList/RDARegionalEncoding/",
  "odapps": "http://semweb.mmlab.be/ns/odapps#",
  "cog": "http://purl.org/ontology/cco/core#",
  "sdmxm": "http://purl.org/linked-data/sdmx/2009/measure#",
  "ontoneo": "http://purl.obolibrary.org/obo/ontoneo/",
  "devuan": "https://devuan.net.br/",
  "bkb": "https://budayakb.cs.ui.ac.id/ns#",
  "rm": "http://jazz.net/ns/rm#",
  "vocnet": "http://schema.vocnet.org/",
  "gg": "http://www.gemeentegeschiedenis.nl/gg-schema#",
  "alice": "http://example.org/",
  "vam": "http://www.metmuseum.org/",
  "vocals": "http://w3id.org/rsp/vocals#",
  "hdo": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
  "dead": "http://utpl.edu.ec/sbc/data/",
  "rdacpc": "http://rdaregistry.info/termList/configPlayback/",
  "xslopm": "http://purl.org/net/opmv/types/xslt#",
  "rofsm": "http://rdaregistry.info/termList/rofsm/",
  "qbe": "http://citydata.wu.ac.at/qb-equations#",
  "dby": "http://dbpedia.org/class/yago/",
  "nobel": "http://data.nobelprize.org/terms/",
  "da": "https://www.wowman.org/index.php?id=1&type=get#",
  "atlasterms": "http://rdf.ebi.ac.uk/terms/atlas/",
  "fp3": "http://vocab.fusepool.info/fp3#",
  "number": "http://km.aifb.kit.edu/projects/numbers/number#",
  "ncicp": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "ogdl4m": "https://github.com/martynui/OGDL4M/",
  "ifcowl": "http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#",
  "apb": "http://www.analysispartners.org/businessmodel/",
  "oop": "http://w3id.org/oop#",
  "ldq": "http://www.linkeddata.es/ontology/ldq#",
  "semsur": "http://purl.org/SemSur/",
  "wde": "http://www.wikidata.org/entity/",
  "ppr": "http://purl.org/datanode/ppr/ns/",
  "roc": "https://w3id.org/ro/curate#",
  "mobivoc": "http://schema.mobivoc.org/",
  "mydb": "http://mydb.org/",
  "crmeh": "http://purl.org/crmeh#",
  "ldn": "https://www.w3.org/TR/ldn/#",
  "mus": "http://data.doremus.org/ontology#",
  "ul": "http://underlay.mit.edu/ns/",
  "legal": "http://www.w3.org/ns/legal#",
  "input": "http://volt-name.space/vocab/input#",
  "halyard": "http://merck.github.io/Halyard/ns#",
  "imjv": "https://data.imjv.omgeving.vlaanderen.be/ns/imjv#",
  "or": "http://openresearch.org/vocab/",
  "tosh": "http://topbraid.org/tosh#",
  "lgdt": "http://linkedgeodata.org/triplify/",
  "yso": "http://www.yso.fi/onto/yso/",
  "ttla": "https://w3id.org/ttla/",
  "rdaspc": "http://rdaregistry.info/termList/specPlayback/",
  "geor": "http://www.opengis.net/def/rule/geosparql/",
  "edg": "http://edg.topbraid.solutions/model/",
  "mbgd": "http://mbgd.genome.ad.jp/owl/mbgd.owl#",
  "rofrm": "http://rdaregistry.info/termList/rofrm/",
  "swa": "http://topbraid.org/swa#",
  "rofim": "http://rdaregistry.info/termList/rofim/",
  "rdag3": "http://rdvocab.info/ElementsGr3/",
  "sciprov": "http://sweetontology.net/reprSciProvenance/",
  "sgiter": "http://w3id.org/sparql-generate/iter/",
  "gvoith": "http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#",
  "ethc": "http://ethoinformatics.org/ethocore/",
  "decprov": "http://promsns.org/def/decprov#",
  "dataid": "http://dataid.dbpedia.org/ns/core#",
  "huto": "http://ns.inria.fr/huto/",
  "ucum": "http://purl.oclc.org/NET/muo/ucum/",
  "aozora": "http://purl.org/net/aozora/",
  "lgt": "http://linkedgadget.com/wiki/Property:",
  "gobierno": "http://www.gobierno.es/gobierno/",
  "nosql": "http://purl.org/db/nosql#",
  "l2sp": "http://www.linked2safety-project.eu/properties/",
  "tissue": "http://www.univalle.edu.co/ontologies/Tissue#",
  "tadirah": "http://tadirah.dariah.eu/vocab/",
  "rdaft": "http://rdaregistry.info/termList/fileType/",
  "dcodt": "http://info.deepcarbon.net/datatype/schema#",
  "iotlite": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
  "srx": "http://www.w3.org/2005/sparql-results#",
  "it": "http://www.influencetracker.com/ontology#",
  "sdterms": "http://statisticaldata.linkedwidgets.org/terms/",
  "ontop": "https://w3id.org/ontop/",
  "isbdu": "http://iflastandards.info/ns/isbd/unc/elements/",
  "ocds": "http://purl.org/onto-ocds/ocds#",
  "dnbt": "http://d-nb.info/standards/elementset/dnb#",
  "scholl": "http://menemeneml.com/school#",
  "um": "http://intelleo.eu/ontologies/user-model/ns/",
  "cska": "http://pfclitex.com/",
  "alethio": "http://aleth.io/",
  "neotecbib": "http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/",
  "imind": "http://schema.intellimind.ns/symbology#",
  "geo7": "https://www.geo7.ch/",
  "rdax": "http://rdaregistry.info/Elements/x/",
  "nas": "https://data.nasa.gov/ontologies/atmonto/NAS#",
  "loted": "http://loted.eu/ontology#",
  "idot": "http://identifiers.org/idot/",
  "juso": "http://rdfs.co/juso/",
  "rdapf": "http://rdaregistry.info/termList/presFormat/",
  "sdmxc": "http://purl.org/linked-data/sdmx/2009/concept#",
  "occ": "http://w3id.org/occ#",
  "esair": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#",
  "ods": "http://lod.xdams.org/ontologies/ods/",
  "ondc": "http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#",
  "rvl": "http://purl.org/rvl/",
  "elod": "http://linkedeconomy.org/ontology#",
  "pmonb": "http://premon.fbk.eu/ontology/nb#",
  "ldqm": "http://linkeddata.es/resource/ldqm/",
  "crminf": "http://www.cidoc-crm.org/cidoc-crm/CRMinf/",
  "koly": "http://www.ensias.ma/",
  "pbody": "http://reference.data.gov.uk/def/public-body/",
  "geoloc": "http://deductions.github.io/geoloc.owl.ttl#",
  "dto": "http://www.datatourisme.fr/ontology/core/1.0#",
  "iso37120": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
  "piero": "http://reactionontology.org/piero/",
  "alg": "http://drakon.su/ADF#",
  "edgarcik": "http://edgarwrap.ontologycentral.com/cik/",
  "docker": "http://www.w3.org/ns/bde/docker/",
  "sorepsf": "http://sweetontology.net/reprSciFunction/",
  "neotec": "http://neotec.rc.unesp.br/resource/Neotectonics/",
  "smxm": "http://smxm.ga/",
  "edac": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
  "xbrll": "https://w3id.org/vocab/xbrll#",
  "b3kat": "http://lod.b3kat.de/title/",
  "rofhf": "http://rdaregistry.info/termList/rofhf/",
  "undata": "http://citydata.wu.ac.at/Linked-UNData/data/",
  "lsq": "http://lsq.aksw.org/vocab#",
  "datacron": "http://www.datacron-project.eu/datAcron#",
  "ns2": "http://ogp.me/ns#video:",
  "rfd": "http://com.intrinsec//ontology#",
  "eproc": "http://10.0.3.120/download/eproc_FORN_v02.owl#",
  "uri4uri": "http://uri4uri.net/vocab#",
  "amsl": "http://vocab.ub.uni-leipzig.de/amsl/",
  "loci": "http://linked.data.gov.au/def/loci#",
  "wail": "http://www.eyrie.org/~zednenem/2002/wail/",
  "tsnchange": "http://purl.org/net/tsnchange#",
  "sohukd": "http://sweetontology.net/humanKnowledgeDomain/",
  "wab": "http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#",
  "globalcube": "http://kalmar32.fzi.de/triples/global-cube.ttl#",
  "efd": "http://data.foodanddrinkeurope.eu/ontology#",
  "pand": "http://bag.basisregistraties.overheid.nl/bag/id/pand/",
  "pop": "http://wiki.dbpedia.org/",
  "seo": "http://sda.tech/SEOontology/SEO/",
  "maeco": "http://edg.topbraid.solutions/maeco/",
  "geofabric": "http://linked.data.gov.au/def/geofabric#",
  "remetca": "http://www.purl.org/net/remetca#",
  "connard": "https://mail.google.com/mail/u/1/#",
  "ii": "http://sparql.cwrc.ca/ontologies/ii#",
  "rico": "https://www.ica.org/standards/RiC/ontology#",
  "kmgeo": "http://km.aifb.kit.edu/services/geo/ontology#",
  "dcodata": "http://info.deepcarbon.net/data/schema#",
  "imas": "https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#",
  "metadata": "http://purl.oreilly.com/ns/meta/",
  "pmofn": "http://premon.fbk.eu/ontology/fn#",
  "ncbigene": "http://identifiers.org/ncbigene/",
  "m3lite": "http://purl.org/iot/vocab/m3-lite#",
  "soproptg": "http://sweetontology.net/propTemperatureGradient/",
  "eustd": "http://eurostat.linked-statistics.org/data#",
  "dm2e": "http://onto.dm2e.eu/schemas/dm2e/",
  "sophatmow": "http://sweetontology.net/phenAtmoWind/",
  "pmovn": "http://premon.fbk.eu/ontology/vn#",
  "d3s": "http://vocbench.solidaridad.cloud/taxonomies#",
  "iab": "https://www.iab.com/guidelines/taxonomy/",
  "scra": "http://purl.org/net/schemarama#",
  "tikag": "https://www.tikag.com/",
  "gdprov": "https://w3id.org/GDPRov#",
  "soma": "http://sweetontology.net/matr/",
  "sopropsdis": "http://sweetontology.net/propSpaceDistance/",
  "s4bldg": "https://w3id.org/def/saref4bldg#",
  "olac11": "http://www.language-archives.org/OLAC/1.1/",
  "brt": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
  "soprocsc": "http://sweetontology.net/procStateChange/",
  "m3": "http://sensormeasurement.appspot.com/m3#",
  "llr": "http://lodlaundromat.org/resource/",
  "isidore": "http://www.rechercheisidore.fr/class/",
  "vsearch": "http://vocab.sti2.at/vsearch#",
  "sophatmowm": "https://sweetontology.net/phenAtmoWindMesoscale/",
  "esproc": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#",
  "sorepmo": "http://sweetontology.net/reprMathOperation/",
  "rdfdata": "http://rdf.data-vocabulary.org/rdf.xml#",
  "marcrole": "http://id.loc.gov/vocabulary/relators/",
  "s3n": "http://w3id.org/s3n/",
  "biolink": "https://w3id.org/biolink/vocab/",
  "rofsf": "http://rdaregistry.info/termList/rofsf/",
  "sorepsrs": "http://sweetontology.net/reprSpaceReferenceSystem/",
  "soproptf": "http://sweetontology.net/propTimeFrequency/",
  "valueflows": "https://w3id.org/valueflows/",
  "sopropp": "http://sweetontology.net/propPressure/",
  "manto": "http://com.vortic3.MANTO/",
  "hosp": "http://health.data.gov/def/hospital/",
  "gdpr": "https://vocab.eccenca.com/gdpr/",
  "bci": "https://w3id.org/BCI-ontology#",
  "unspsc": "http://ontoview.org/schema/unspsc/1#",
  "rdavf": "http://rdaregistry.info/termList/videoFormat/",
  "fnml": "http://semweb.mmlab.be/ns/fnml#",
  "ispra": "http://dati.isprambiente.it/ontology/core#",
  "gdprtext": "https://w3id.org/GDPRtEXT#",
  "clapit": "http://dati.gov.it/onto/clapit/",
  "pm": "http://premon.fbk.eu/resource/",
  "estatwrap": "http://ontologycentral.com/2009/01/eurostat/ns#",
  "rdaill": "http://rdaregistry.info/termList/IllusContent/",
  "bioentity": "http://bioentity.io/vocab/",
  "dgfr": "http://colin.maudry.com/ontologies/dgfr#",
  "master1": "http://idl.u-grenoble3.fr/",
  "asawoo": "http://liris.cnrs.fr/asawoo/",
  "llalg": "http://www.linklion.org/algorithm/",
  "rimmf": "http://rimmf.com/vocab/",
  "bibrm": "http://vocab.ub.uni-leipzig.de/bibrm/",
  "vss": "http://automotive.eurecom.fr/vsso#",
  "rami": "http://iais.fraunhofer.de/vocabs/rami#",
  "irstea": "http://ontology.irstea.fr/",
  "sopropsl": "http://sweetontology.net/propSpaceLocation/",
  "qk": "http://qudt.org/vocab/quantitykind/",
  "ctxdesc": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
  "smartapi": "http://smart-api.io/ontology/1.0/smartapi#",
  "osys": "http://purl.org/olia/system.owl#",
  "emergel": "http://purl.org/emergel/core#",
  "cbb": "https://data.cbb.omgeving.vlaanderen.be/ns/cbb#",
  "chemsci": "https://w3id.org/skgo/chemsci#",
  "wn30": "http://purl.org/vocabularies/princeton/wn30/",
  "psv": "http://www.wikidata.org/prop/statement/value/",
  "pq": "http://www.wikidata.org/prop/qualifier/",
  "rdagen": "http://rdaregistry.info/termList/RDAGeneration/",
  "sostc": "http://sweetontology.net/stateChemical/",
  "dsfv": "http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#",
  "refexo": "http://purl.jp/bio/01/refexo#",
  "tavprov": "http://ns.taverna.org.uk/2012/tavernaprov/",
  "ksam": "http://kulturarvsdata.se/ksamsok#",
  "changeset": "http://purl.org/vocab/changeset/schema#",
  "linkrel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "eqp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
  "rsctx": "http://softeng.polito.it/rsctx#",
  "fel": "http://w3id.org/vcb/fel#",
  "dpla": "http://dp.la/info/developers/map/",
  "sohuecons": "http://sweetontology.net/humanEnvirConservation/",
  "sopropcat": "http://sweetontology.net/propCategorical/",
  "oplangel": "http://www.openlinksw.com/schemas/angel#",
  "maet": "http://edg.topbraid.solutions/taxonomy/macroeconomics/",
  "gnaf": "http://linked.data.gov.au/def/gnaf#",
  "goaf": "http://goaf.fr/goaf#",
  "pplan": "http://purl.org/net/p-plan#",
  "pham": "https://w3id.org/skgo/pham#",
  "oplp": "http://www.openlinksw.com/ontology/purchases#",
  "stencila": "http://schema.stenci.la/",
  "noise": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#",
  "isoadr": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
  "prohow": "https://w3id.org/prohow#",
  "omnlc": "http://open-multinet.info/ontology/omn-lifecycle#",
  "ermrk": "http://www.essepuntato.it/2008/12/earmark#",
  "sopropsh": "http://sweetontology.net/propSpaceHeight/",
  "rdaad": "http://rdaregistry.info/Elements/a/datatype/",
  "wild": "http://purl.org/wild/vocab#",
  "sorepmso": "http://sweetontology.net/reprMathSolution/",
  "terms": "http://purl.org/dc/terms/",
  "soproc": "http://sweetontology.net/proc/",
  "gcon": "https://w3id.org/GConsent#",
  "bitl": "http://lib.bit.edu.cn/ontology/1.0/",
  "mdont": "http://ont.matchdeck.com/",
  "ordo": "http://www.orpha.net/ORDO/",
  "capes": "http://vocab.capes.gov.br/def/vcav#",
  "losp": "http://sparql.sstu.ru:3030/speciality/",
  "somaoc": "http://sweetontology.net/matrOrganicCompound/",
  "skosthes": "http://purl.org/iso25964/skos-thes#",
  "dm": "http://datamusee.givingsense.eu/onto/",
  "dmp": "http://www.sysresearch.org/rda-common-dmp#",
  "aseonto": "http://requirement.ase.ru/requirements_ontology#",
  "snac": "http://socialarchive.iath.virginia.edu/",
  "sorepsu": "http://sweetontology.net/reprSciUnits/",
  "cwlgit": "https://w3id.org/cwl/view/git/",
  "soprocp": "http://sweetontology.net/procPhysical/",
  "sostv": "http://sweetontology.net/stateVisibility/",
  "country": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "provoc": "http://ns.inria.fr/provoc/",
  "extech": "https://w3id.org/executionTechnique/ontology/",
  "sorepmfo": "http://sweetontology.net/reprMathFunctionOrthogonal/",
  "sopropsp": "http://sweetontology.net/propSpeed/",
  "sophatmofo": "http://sweetontology.net/phenAtmoFog/",
  "pmopb": "http://premon.fbk.eu/ontology/pb#",
  "lesa": "http://hadatac.org/ont/lesa#",
  "sorepsc": "http://sweetontology.net/reprSciComponent/",
  "eproc2": "http://10.0.3.120/download/eproc_FORN_v04.owl#",
  "jsonschema": "https://www.w3.org/2019/wot/json-schema#",
  "sosttf": "http://sweetontology.net/stateTimeFrequency/",
  "sorepscd": "http://sweetontology.net/reprSpaceCoordinate/",
  "sorepdf": "http://sweetontology.net/reprDataFormat/",
  "sorepdsa": "http://sweetontology.net/reprDataServiceAnalysis/",
  "sophec": "http://sweetontology.net/phenEcology/",
  "soreaofl": "http://sweetontology.net/realmOceanFloor/",
  "daap": "http://daap.dsi.universite-paris-saclay.fr/wiki/",
  "sopropsdir": "http://sweetontology.net/propSpaceDirection/",
  "powla": "http://purl.org/powla/powla.owl#",
  "sohut": "http://sweetontology.net/humanTransportation/",
  "sorepmst": "http://sweetontology.net/reprMathStatistics/",
  "lcsh": "http://id.loc.gov/authorities/subjects/",
  "rofet": "http://rdaregistry.info/termList/rofet/",
  "wdv": "http://www.wikidata.org/value/",
  "sophoc": "http://sweetontology.net/phenOceanCoastal/",
  "theme": "http://voc.odw.tw/theme/",
  "sopropef": "http://sweetontology.net/propEnergyFlux/",
  "dqc": "http://semwebquality.org/ontologies/dq-constraints#",
  "earth": "http://linked.earth/ontology#",
  "dentsci": "https://w3id.org/skgo/dentsci#",
  "sorelm": "http://sweetontology.net/relaMath/",
  "atts": "https://data.nasa.gov/ontologies/atmonto/general#",
  "cwmo": "http://purl.org/cwmo/#",
  "epplan": "https://w3id.org/ep-plan#",
  "sophatmopc": "http://sweetontology.net/phenAtmoPrecipitation/",
  "esagen": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "obws": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
  "r4r": "http://guava.iis.sinica.edu.tw/r4r/",
  "dcatnl": "http://standaarden.overheid.nl/dcatnl/terms/",
  "sopropti": "http://sweetontology.net/propTime/",
  "hctl": "https://www.w3.org/2019/wot/hypermedia#",
  "constant": "http://qudt.org/vocab/constant/",
  "sorepsme": "http://sweetontology.net/reprSciMethodology/",
  "soprops": "http://sweetontology.net/propSpace/",
  "bs": "https://w3id.org/bs#",
  "soreaa": "http://sweetontology.net/realmAtmo/",
  "esgs": "https://w3id.org/edwin/ontology/",
  "sorept": "http://sweetontology.net/reprTime/",
  "sophso": "http://sweetontology.net/phenSolid/",
  "wikimedia": "http://upload.wikimedia.org/wikipedia/commons/f/f6/",
  "sophsy": "http://sweetontology.net/phenSystem/",
  "sopropcha": "http://sweetontology.net/propCharge/",
  "orgesv2": "http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#",
  "sweet": "http://sweetontology.net/",
  "iospress": "http://ld.iospress.nl/rdf/ontology/",
  "sorepmf": "http://sweetontology.net/reprMathFunction/",
  "sopropmf": "http://sweetontology.net/propMassFlux/",
  "gmo": "http://purl.jp/bio/10/gmo/",
  "sorepdp": "http://sweetontology.net/reprDataProduct/",
  "sorepdsv": "http://sweetontology.net/reprDataServiceValidation/",
  "medred": "http://w3id.org/medred/medred#",
  "sopropsm": "http://sweetontology.net/propSpaceMultidimensional/",
  "sostb": "http://sweetontology.net/stateBiological/",
  "sorepdsr": "http://sweetontology.net/reprDataServiceReduction/",
  "sorelpr": "http://sweetontology.net/relaProvenance/",
  "sorepsl": "http://sweetontology.net/reprSciLaw/",
  "sopropdifu": "http://sweetontology.net/propDiffusivity/",
  "nrv": "http://ns.inria.fr/nrv#",
  "eppl": "https://w3id.org/ep-plan#",
  "shema": "http://schema.org/",
  "sopropcap": "http://sweetontology.net/propCapacity/",
  "isaterms": "http://purl.org/isaterms/",
  "inchikey": "https://identifiers.org/inchikey:",
  "stx": "http://purl.org/cyber/stix#",
  "fssp": "http://linkeddata.fssprus.ru/resource/",
  "voidwh": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#",
  "sostri": "http://sweetontology.net/stateRoleImpact/",
  "jup": "http://w3id.org/charta77/jup/",
  "sopropq": "http://sweetontology.net/propQuantity/",
  "sopropcou": "http://sweetontology.net/propCount/",
  "sopropb": "http://sweetontology.net/propBinary/",
  "sorepsp": "http://sweetontology.net/reprSciProvenance/",
  "sostrr": "http://sweetontology.net/stateRoleRepresentative/",
  "dprov": "http://promsns.org/def/do#",
  "sorealc": "http://sweetontology.net/realmLandCoastal/",
  "vehman": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "gvoi": "http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#",
  "soreahb": "http://sweetontology.net/realmHydroBody/",
  "lblodlg": "http://data.lblod.info/vocabularies/leidinggevenden/",
  "estatgph": "http://estatwrap.ontologycentral.com/id/nama_aux_gph#",
  "somanr": "http://sweetontology.net/matrNaturalResource/",
  "odw": "http://odw.tw/",
  "sorepts": "http://sweetontology.net/reprTimeSeason/",
  "iaph": "http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28",
  "ldc": "https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#",
  "sophatmoc": "http://sweetontology.net/phenAtmoCloud/",
  "pineapple": "http://hexananas.com/pineapple#",
  "ingredient": "http://www.owl-ontologies.com/test.owl/ingredient/",
  "estrf": "http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#",
  "skoslex": "https://bp4mc2.org/def/skos-lex#",
  "sophfd": "http://sweetontology.net/phenFluidDynamics/",
  "mexperf": "http://mex.aksw.org/mex-perf#",
  "sopropdr": "http://sweetontology.net/propDimensionlessRatio/",
  "wotsec": "https://www.w3.org/2019/wot/security#",
  "sorelcl": "http://sweetontology.net/relaClimate/",
  "w3id": "https://w3id.org/",
  "somamin": "http://sweetontology.net/matrMineral/",
  "sostth": "http://sweetontology.net/stateThermodynamic/",
  "soreps": "http://sweetontology.net/reprSpace/",
  "sorep": "http://sweetontology.net/repr/",
  "sorelh": "http://sweetontology.net/relaHuman/",
  "sopropm": "http://sweetontology.net/propMass/",
  "ideotalex": "http://www.ideotalex.eu/datos/recurso/",
  "sopropcon": "http://sweetontology.net/propConductivity/",
  "sorepmg": "http://sweetontology.net/reprMathGraph/",
  "soprope": "http://sweetontology.net/propEnergy/",
  "sopropo": "http://sweetontology.net/propOrdinal/",
  "soreao": "http://sweetontology.net/realmOcean/",
  "sosto": "http://sweetontology.net/stateOrdinal/",
  "soreaas": "http://sweetontology.net/realmAstroStar/",
  "soreacz": "http://sweetontology.net/realmClimateZone/",
  "esdbpr": "http://es.dbpedia.org/resource/",
  "vort": "http://rockets.topbraid.solutions/vort/",
  "sfl": "http://data.finlex.fi/schema/sfl/",
  "sophatmofr": "http://sweetontology.net/phenAtmoFront/",
  "yandex": "http://yandex.ru/",
  "sopropche": "http://sweetontology.net/propChemical/",
  "sosttg": "http://sweetontology.net/stateTimeGeologic/",
  "dave": "http://theme-e.adaptcentre.ie/dave#",
  "foio": "https://w3id.org/seas/FeatureOfInterestOntology/",
  "sophpc": "http://sweetontology.net/phenPlanetClimate/",
  "sopropi": "http://sweetontology.net/propIndex/",
  "sohutr": "http://sweetontology.net/humanTechReadiness/",
  "sopropfr": "http://sweetontology.net/propFraction/",
  "sopropr": "http://sweetontology.net/propRotation/",
  "sorealo": "http://sweetontology.net/realmLandOrographic/",
  "sophatmops": "http://sweetontology.net/phenAtmoPressure/",
  "cci": "http://cookingbigdata.com/linkeddata/ccinstances#",
  "lprov": "http://id.learning-provider.data.ac.uk/terms#",
  "proton": "http://www.ontotext.com/proton/",
  "sorepm": "http://sweetontology.net/reprMath/",
  "sophatmos": "http://sweetontology.net/phenAtmoSky/",
  "sophst": "http://sweetontology.net/phenStar/",
  "sorepsd": "http://sweetontology.net/reprSpaceDirection/",
  "sophatmol": "http://sweetontology.net/phenAtmoLightning/",
  "frbroo": "http://iflastandards.info/ns/fr/frbr/frbroo/",
  "loupe": "http://ont-loupe.linkeddata.es/def/core/",
  "somains": "http://sweetontology.net/matrInstrument/",
  "trek": "https://w3id.org/trek/",
  "somac": "http://sweetontology.net/matrCompound/",
  "sohuj": "http://sweetontology.net/humanJurisdiction/",
  "sohues": "http://sweetontology.net/humanEnvirStandards/",
  "cfrl": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
  "ddb": "http://www.deutsche-digitale-bibliothek.de/edm/",
  "somaae": "http://sweetontology.net/matrAerosol/",
  "sophcr": "http://sweetontology.net/phenCryo/",
  "sophwn": "http://sweetontology.net/phenWaveNoise/",
  "d2s": "https://w3id.org/d2s/",
  "sorelsc": "http://sweetontology.net/relaSci/",
  "sostrg": "http://sweetontology.net/stateRoleGeographic/",
  "sopropdife": "http://sweetontology.net/propDifference/",
  "sopropfu": "http://sweetontology.net/propFunction/",
  "sorear": "http://sweetontology.net/realmRegion/",
  "somapl": "http://sweetontology.net/matrPlant/",
  "esagm": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "ecowlim": "http://ecowlim.tfri.gov.tw/lode/resource/",
  "sorelph": "http://sweetontology.net/relaPhysical/",
  "sophatmo": "http://sweetontology.net/phenAtmo/",
  "eccf": "http://data.europa.eu/54i/",
  "somaf": "http://sweetontology.net/matrFacility/",
  "sostso": "http://sweetontology.net/stateSolid/",
  "taxref": "http://taxref.mnhn.fr/lod/taxon/",
  "osmm": "https://www.openstreetmap.org/meta/",
  "sostrt": "http://sweetontology.net/stateRoleTrust/",
  "sohur": "http://sweetontology.net/humanResearch/",
  "soreas": "http://sweetontology.net/realmSoil/",
  "sorepsg3": "http://sweetontology.net/reprSpaceGeometry3D/",
  "sost": "http://sweetontology.net/state/",
  "gx": "https://w3id.org/gaia-x/development#",
  "sophm": "http://sweetontology.net/phenMixing/",
  "sorealp": "http://sweetontology.net/realmLandProtected/",
  "soprocw": "http://sweetontology.net/procWave/",
  "sorepdm": "http://sweetontology.net/reprDataModel/",
  "somab": "http://sweetontology.net/matrBiomass/",
  "sophcm": "http://sweetontology.net/phenCycleMaterial/",
  "hdgi": "https://w3id.org/hdgi#",
  "sohu": "http://sweetontology.net/human/",
  "sostrc": "http://sweetontology.net/stateRoleChemical/",
  "pcdmuse": "http://pcdm.org/use#",
  "sosttc": "http://sweetontology.net/stateTimeCycle/",
  "sorepdsg": "http://sweetontology.net/reprDataServiceGeospatial/",
  "sorelt": "http://sweetontology.net/relaTime/",
  "bldont": "http://ont.biglinkeddata.com/",
  "soreaer": "http://sweetontology.net/realmEarthReference/",
  "soreaaw": "http://sweetontology.net/realmAtmoWeather/",
  "biogrid": "http://thebiogrid.org/",
  "somaem": "http://sweetontology.net/matrElementalMolecule/",
  "mbkeys": "https://pastebin.com/ThBfphb8#",
  "donto": "http://reference.data.gov.au/def/ont/dataset#",
  "sophel": "http://sweetontology.net/phenElecMag/",
  "phto": "http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#",
  "somaen": "http://sweetontology.net/matrEnergy/",
  "ggbn": "http://data.ggbn.org/schemas/ggbn/terms/",
  "asgs": "http://linked.data.gov.au/def/asgs#",
  "somarock": "http://sweetontology.net/matrRock/",
  "soreaabl": "http://sweetontology.net/realmAtmoBoundaryLayer/",
  "sophr": "http://sweetontology.net/phenReaction/",
  "misp": "http://purl.org/cyber/misp#",
  "sorel": "http://sweetontology.net/rela/",
  "pnv": "https://w3id.org/pnv#",
  "somarocki": "http://sweetontology.net/matrRockIgneous/",
  "somaind": "http://sweetontology.net/matrIndustrial/",
  "sophft": "http://sweetontology.net/phenFluidTransport/",
  "sostdp": "http://sweetontology.net/stateDataProcessing/",
  "sopropst": "http://sweetontology.net/propSpaceThickness/",
  "probont": "http://www.probonto.org/ontology#",
  "sophcy": "http://sweetontology.net/phenCycle/",
  "sostsy": "http://sweetontology.net/stateSystem/",
  "sostsp": "http://sweetontology.net/stateSpace/",
  "soreac": "http://sweetontology.net/realmCryo/",
  "dbm": "http://purl.org/net/dbm/ontology#",
  "soreaah": "http://sweetontology.net/realmAstroHelio/",
  "sophatmot": "http://sweetontology.net/phenAtmoTransport/",
  "osmt": "https://wiki.openstreetmap.org/wiki/Key:",
  "soreal": "http://sweetontology.net/realmLandform/",
  "mmms": "http://ldf.fi/schema/mmm/",
  "somais": "http://sweetontology.net/matrIsotope/",
  "soph": "http://sweetontology.net/phen/",
  "soall": "http://sweetontology.net/sweetAll/",
  "sohuc": "http://sweetontology.net/humanCommerce/",
  "soreptd": "http://sweetontology.net/reprTimeDay/",
  "lv2": "http://lv2plug.in/ns/lv2core/",
  "sopropt": "http://sweetontology.net/propTemperature/",
  "soreaofe": "http://sweetontology.net/realmOceanFeature/",
  "sorelch": "http://sweetontology.net/relaChemical/",
  "trak": "https://purl.org/trak/metamodel/vocab#",
  "omop": "http://api.ohdsi.org/WebAPI/vocabulary/concept/",
  "she": "http://shacleditor.org/",
  "sophsyc": "http://sweetontology.net/phenSystemComplexity/",
  "sorepsmo": "http://sweetontology.net/reprSciModel/",
  "soprocc": "http://sweetontology.net/procChemical/",
  "mccv": "http://purl.jp/bio/10/mccv#",
  "sorepds": "http://sweetontology.net/reprDataService/",
  "cto": "https://w3id.org/cto#",
  "somas": "http://sweetontology.net/matrSediment/",
  "sorelsp": "http://sweetontology.net/relaSpace/",
  "compub": "https://sireneld.io/vocab/compub#",
  "sophb": "http://sweetontology.net/phenBiol/",
  "sophei": "http://sweetontology.net/phenEnvirImpact/",
  "idsc": "https://w3id.org/idsa/code/",
  "twitter": "http://stocktwits.com/",
  "snomedct": "http://purl.bioontology.org/ontology/SNOMEDCT/",
  "sophod": "http://sweetontology.net/phenOceanDynamics/",
  "sostrb": "http://sweetontology.net/stateRoleBiological/",
  "soprop": "http://sweetontology.net/prop/",
  "somaw": "http://sweetontology.net/matrWater/",
  "sostsb": "http://sweetontology.net/stateSpectralBand/",
  "sophhy": "http://sweetontology.net/phenHydro/",
  "somaeq": "http://sweetontology.net/matrEquipment/",
  "say": "https://say.data.gift/ns/",
  "sohueccont": "http://sweetontology.net/humanEnvirControl/",
  "s4city": "https://saref.etsi.org/saref4city/",
  "wds": "http://www.wikidata.org/entity/statement/",
  "somaio": "http://sweetontology.net/matrIon/",
  "soreabb": "http://sweetontology.net/realmBiolBiome/",
  "sohuea": "http://sweetontology.net/humanEnvirAssessment/",
  "sostro": "http://sweetontology.net/stateRole/",
  "rank": "http://www.ontotext.com/owlim/RDFRank#",
  "ccomid": "http://www.ontologyrepository.com/CommonCoreOntologies/Mid/",
  "oco": "https://w3id.org/oc/ontology/",
  "sophgt": "http://sweetontology.net/phenGeolTectonic/",
  "sophen": "http://sweetontology.net/phenEnergy/",
  "sorealt": "http://sweetontology.net/realmLandTectonic/",
  "s4agri": "https://saref.etsi.org/saref4agri/",
  "omim": "http://purl.bioontology.org/ontology/OMIM/",
  "esbici": "http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#",
  "sostef": "http://sweetontology.net/stateEnergyFlux/",
  "schoi": "https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#",
  "oplsoft": "http://www.openlinksw.com/ontology/software#",
  "edupro": "http://ns.inria.fr/semed/eduprogression#",
  "ldes": "https://w3id.org/ldes#",
  "ocsw": "http://data.diekb.org/def/ocsw#",
  "sophw": "http://sweetontology.net/phenWave/",
  "osmrel": "https://www.openstreetmap.org/relation/",
  "sophgs": "http://sweetontology.net/phenGeolSeismicity/",
  "brot": "https://w3id.org/brot#",
  "cbs": "http://betalinkeddata.cbs.nl/def/cbs#",
  "sostp": "http://sweetontology.net/statePhysical/",
  "taxrefprop": "http://taxref.mnhn.fr/lod/property/",
  "dfc": "http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
  "sostf": "http://sweetontology.net/stateFluid/",
  "atd": "https://data.nasa.gov/ontologies/atmonto/data#",
  "sorealf": "http://sweetontology.net/realmLandFluvial/",
  "sorealg": "http://sweetontology.net/realmLandGlacial/",
  "gleio": "http://lei.info/gleio/",
  "asio": "http://purl.org/hercules/asio/core#",
  "gas": "http://www.bigdata.com/rdf/gas#",
  "ciao": "http://ciao.it/",
  "sostti": "http://sweetontology.net/stateTime/",
  "somael": "http://sweetontology.net/matrElement/",
  "place": "http://purl.org/ontology/places/",
  "birthdate": "http://schema.org/birthDate/",
  "sophgg": "http://sweetontology.net/phenGeolGeomorphology/",
  "soman": "http://sweetontology.net/matrAnimal/",
  "eupont": "http://elite.polito.it/ontologies/eupont.owl#",
  "sostre": "http://sweetontology.net/stateRealm/",
  "sophfi": "http://sweetontology.net/phenFluidInstability/",
  "atm": "https://data.nasa.gov/ontologies/atmonto/ATM#",
  "soreala": "http://sweetontology.net/realmLandAeolian/",
  "dd": "http://example.org/dummydata/",
  "matvoc": "http://stream-ontology.com/matvoc/",
  "wasa": "http://vocab.sti2.at/wasa/",
  "persoon": "http://data.vlaanderen.be/ns/persoon#",
  "sohud": "http://sweetontology.net/humanDecision/",
  "sostsc": "http://sweetontology.net/stateSpaceConfiguration/",
  "sostss": "http://sweetontology.net/stateSpaceScale/",
  "sophhe": "http://sweetontology.net/phenHelio/",
  "io": "https://iaco.me/",
  "istex": "https://data.istex.fr/ontology/istex#",
  "somamic": "http://sweetontology.net/matrMicrobiota/",
  "malaka": "http://george.gr/",
  "soreaab": "http://sweetontology.net/realmAstroBody/",
  "ci": "https://privatealpha.com/ontology/content-inventory/1#",
  "fibo": "https://spec.edmcouncil.org/fibo/ontology/master/latest/",
  "mobiliteit": "https://data.vlaanderen.be/ns/mobiliteit#",
  "docam": "https://www.docam.ca/glossaurus/",
  "somapa": "http://sweetontology.net/matrParticle/",
  "sopho": "http://sweetontology.net/phenOcean/",
  "iaco": "https://iaco.me/",
  "osmnode": "https://www.openstreetmap.org/node/",
  "ogura": "https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#",
  "sostsl": "http://sweetontology.net/stateSpectralLine/",
  "ccr": "http://cookingbigdata.com/linkeddata/ccregions#",
  "waa": "http://purl.oclc.org/NET/WebApiAuthentication#",
  "sophgv": "http://sweetontology.net/phenGeolVolcano/",
  "ccsla": "http://cookingbigdata.com/linkeddata/ccsla#",
  "rl": "http://rl.com/resources/",
  "sophg": "http://sweetontology.net/phenGeol/",
  "sostst": "http://sweetontology.net/stateStorm/",
  "toaru": "https://metadata.moe/toaru-sparql/elements/",
  "s4ener": "https://saref.etsi.org/saref4ener/",
  "dbonto": "http://dbepedia.org/ontology/",
  "sohua": "http://sweetontology.net/humanAgriculture/",
  "oplfeat": "http://www.openlinksw.com/ontology/features#",
  "eppo": "https://gd.eppo.int/taxon/",
  "dfcb": "http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
  "knows": "http://semantic.komc/usu/2020/knows#",
  "sophgf": "http://sweetontology.net/phenGeolFault/",
  "sorealv": "http://sweetontology.net/realmLandVolcanic/",
  "osmway": "https://www.openstreetmap.org/way/",
  "kko": "http://kbpedia.org/kko/rc/",
  "fx": "http://sparql.xyz/facade-x/ns/",
  "arp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
  "fernanda": "http://fernanda.nl/",
  "uimo": "http://vocab.sti2.at/uimo/",
  "lexicog": "http://www.w3.org/ns/lemon/lexicog#",
  "jur": "http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#",
  "bperson": "http://data.vlaanderen.be/ns/persoon#",
  "rdasource": "http://rdaregistry.info/termList/RDARecordingSources/",
  "vlueprint": "https://vlueprint.org/schema/",
  "cts": "http://rdf.cdisc.org/ct/schema#",
  "mr": "http://marineregions.org/ns/ontology#",
  "wotc": "http://purl.org/wot-catalogue#",
  "karstlink": "https://ontology.uis-speleo.org/ontology/#",
  "movieo": "http://movie.com/ontology/",
  "ei2a": "http://opendata.aragon.es/def/ei2a#",
  "prismdb": "https://prismdb.takanakahiko.me/prism-schema.ttl#",
  "ebg": "http://data.businessgraph.io/ontology#",
  "sorea": "http://sweetontology.net/realm/",
  "rdapol": "http://rdaregistry.info/termList/RDAPolarity/",
  "bao": "http://www.bioassayontology.org/bao#",
  "epcis": "https://ns.gs1.org/epcis/",
  "saref4envi": "https://saref.etsi.org/saref4envi/",
  "mgv": "http://mangaview.fr/mgv#",
  "ld": "http://linkeddata.ru/",
  "ams": "http://data.amadeus.com/",
  "ble": "http://vocab.rapidthings.eu/ns/ble.ttl#",
  "gco": "http://purl.jp/bio/12/glyco/conjugate#",
  "srv": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "textgrid": "https://textgridrep.org/",
  "gom": "https://w3id.org/gom#",
  "i18n": "https://www.w3.org/ns/i18n#",
  "xyz": "http://sparql.xyz/facade-x/data/",
  "freq": "http://purl.org/cld/freq/",
  "ibeacon": "http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#",
  "contry": "http://dbpedia.org/resource/Lyon#",
  "hpont": "https://w3id.org/hpont#",
  "mpg123": "https://devuan.net.br/wiki/mpg123/",
  "marcgt": "https://id.loc.gov/vocabulary/marcgt/",
  "bop": "https://w3id.org/bop#",
  "tso": "https://w3id.org/tso#",
  "bcom": "https://w3id.org/bcom#",
  "mag": "https://makg.org/property/",
  "rdat": "http://rdaregistry.info/Elements/t/",
  "srr": "https://w3id.org/srr#",
  "quran": "http://khalidaloufi.sa/quran#",
  "motogp": "http://www.motogp.com/",
  "cso": "http://cso.kmi.open.ac.uk/schema/cso/",
  "estraf": "http://vocab.ciudadesabiertas.es/def/transporte/trafico#",
  "accid": "http://pid.accurids.com/",
  "rofchrda": "http://rdaregistry.info/termList/rofchrda/",
  "oeso": "http://www.opensilex.org/vocabularies/oeso#",
  "maroc": "http://fr.dbpedia.org/page/Maroc/",
  "univ": "http://univ.io/",
  "hops": "https://rdf.ag/o/hops#",
  "vr": "https://www.w3.org/2018/credentials/v1/",
  "mltd": "https://mltd.pikopikopla.net/mltd-schema#",
  "w3geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "la": "https://linked.art/ns/terms/",
  "cbv": "https://ns.gs1.org/cbv/",
  "rdaut": "http://rdaregistry.info/termList/RDAUnitOfTime/",
  "pgxo": "http://ns.inria.fr/pgxo/",
  "seasd": "https://w3id.org/seas/",
  "hola": "https://moodle.insa-lyon.fr/course/view.php?id=",
  "contax": "https://w3id.org/con-tax#",
  "vph": "http://purl.org/ozo/vph.owl#",
  "bleadapter": "http://vocab.rapidthings.eu/ns/ble/adapter.ttl#",
  "bdg": "http://data.bigdatagrapes.eu/resource/ontology/",
  "smithy": "https://awslabs.github.io/smithy/rdf-1.0#",
  "samian": "http://lod.archaeology.link/data/samian/",
  "dom": "https://html.spec.whatwg.org/#",
  "esconv": "http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#",
  "rdaep": "http://rdaregistry.info/termList/RDAExtensionPlan/",
  "aspect": "http://purl.org/aspect/",
  "mdcs": "https://mdcs.monumentenkennis.nl/damageatlas/ontology#",
  "mesh2021": "http://id.nlm.nih.gov/mesh/2021/",
  "ssnx": "http://purl.oclc.org/NET/ssnx/ssn#",
  "check": "http://pornhub.com/",
  "kpd": "http://purl.org/kpd/",
  "rdano": "http://rdaregistry.info/Elements/n/object/",
  "stax": "https://w3id.org/stax/ontology#",
  "geodcat": "http://data.europa.eu/930/",
  "rpg": "http://rpg.data.is4.site/",
  "nsg": "https://neuroshapes.org/",
  "rdaio": "http://rdaregistry.info/Elements/i/object/",
  "sty": "http://purl.bioontology.org/ontology/STY/",
  "slm": "http://urn.fi/URN:NBN:fi:au:slm:",
  "faas": "http://semantic-faas.com/ontology#",
  "rdamd": "http://rdaregistry.info/Elements/m/datatype/",
  "rdaxd": "http://rdaregistry.info/Elements/x/datatype/",
  "mnx": "https://rdf.metanetx.org/schema/",
  "rdaao": "http://rdaregistry.info/Elements/a/object/",
  "melding": "http://lblod.data.gift/vocabularies/automatische-melding/",
  "esautob": "http://vocab.ciudadesabiertas.es/def/transporte/autobus#",
  "rdato": "http://rdaregistry.info/Elements/t/object/",
  "roffgrda": "http://rdaregistry.info/termList/roffgrda/",
  "lado": "http://archaeology.link/ontology#",
  "rdaid": "http://rdaregistry.info/Elements/i/datatype/",
  "rdatb": "http://rdaregistry.info/termList/RDATypeOfBinding/",
  "spec": "http://www.w3.org/ns/spec#",
  "citedcat": "https://w3id.org/citedcat-ap/",
  "idpo": "https://w3id.org/idpo#",
  "signify": "http://purl.org/signify/ns#",
  "datagc": "https://data.grottocenter.org/ldp/",
  "folio": "http://IBCNServices.github.io/Folio-Ontology/Folio.owl#",
  "comp": "http://semweb.mmlab.be/ns/rml-compression#",
  "oidc": "http://www.w3.org/ns/solid/oidc#",
  "rdatask": "http://rdaregistry.info/termList/RDATasks/",
  "ch": "https://ld.admin.ch/",
  "sou": "http://qudt.org/vocab/sou/",
  "cinema": "http://www.semanticweb.org/julien/morgann/cinema#",
  "itops": "https://vocab.eccenca.com/itops/",
  "cerealstoo": "http://rdf.ag/o/cerealstoo#",
  "mrk": "http://www.mydomain.org/Mrk-ns#",
  "ofn": "http://www.ontotext.com/sparql/functions/",
  "rdan": "http://rdaregistry.info/Elements/n/",
  "rofitrda": "http://rdaregistry.info/termList/rofitrda/",
  "rdamo": "http://rdaregistry.info/Elements/m/object/",
  "oeo": "https://openenergyplatform.org/ontology/oeo/",
  "rdaed": "http://rdaregistry.info/Elements/e/datatype/",
  "arena": "https://solid.ti.rw.fau.de/public/ns/arena#",
  "hqdmontol": "http://www.semanticweb.org/magma-core/ontologies/hqdm#",
  "esempleo": "http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#",
  "react": "https://w3id.org/react#",
  "magmauser": "http://www.semanticweb.org/magma-core/user#",
  "rdatd": "http://rdaregistry.info/Elements/t/datatype/",
  "rdapd": "http://rdaregistry.info/Elements/p/datatype/",
  "oghamonto": "http://ontology.ogham.link/",
  "tci": "https://w3id.org/lbs/tci#",
  "nanopub": "http://www.nanopub.org/nschema#",
  "mrt": "http://marineregions.org/ns/placetypes#",
  "memorix": "http://memorix.io/ontology#",
  "matrycs": "http://matrycs.com/",
  "luigiusai": "https://www.luigiusai.it/wp#",
  "rofsfrda": "http://rdaregistry.info/termList/rofsfrda/",
  "rdawo": "http://rdaregistry.info/Elements/w/object/",
  "rdamat": "http://rdaregistry.info/termList/RDAMaterial/",
  "cpc": "https://data.epo.org/linked-data/def/cpc/",
  "rdaim": "http://rdaregistry.info/termList/RDAInteractivityMode/",
  "xmlns": "http://www.w3.org/2021/XMLSchema#",
  "m8g": "http://data.europa.eu/m8g/",
  "rdaxo": "http://rdaregistry.info/Elements/x/object/",
  "feed": "https://www.feedipedia.org/",
  "encargado": "http://semRAT.edu/",
  "ogham": "http://lod.ogham.link/data/",
  "rdasca": "http://rdaregistry.info/termList/scale/",
  "eep": "https://w3id.org/eep#",
  "nbo": "http://data.bioontology.org/ontologies/NBO/",
  "m4i": "http://w3id.org/nfdi4ing/metadata4ing#",
  "paf": "https://paf.link/",
  "rdand": "http://rdaregistry.info/Elements/n/datatype/",
  "edu": "https://schema.edu.ee/",
  "bcfowl": "http://lbd.arch.rwth-aachen.de/bcfOWL#",
  "poke": "https://pokemonkg.org/ontology#",
  "rdap": "http://rdaregistry.info/Elements/p/",
  "interop": "http://www.w3.org/ns/solid/interop#",
  "cpg": "http://modellingdh.github.io/ont/odp/pgc/",
  "eurio": "http://data.europa.eu/s66#",
  "s223": "http://data.ashrae.org/standard223#",
  "aff": "https://w3id.org/affectedBy#",
  "caso": "http://www.w3id.org/def/caso#",
  "ewg": "http://ethoinformatics.org/",
  "biocrm": "http://ldf.fi/schema/bioc/",
  "uberon": "http://purl.obolibrary.org/obo/UBERON_",
  "cgo": "https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#",
  "nsd": "https://w3id.org/nsd#",
  "djo": "http://purl.org/datajourneys/",
  "rc": "https://w3id.org/rc#",
  "srmo": "https://w3id.org/srmo#",
  "rdapath": "http://rdaregistry.info/termList/RDARecordingMethods/",
  "lds": "https://solid.ti.rw.fau.de/public/ns/linked-data-structures#",
  "srt": "http://w3id.org/srt#",
  "tro": "https://w3id.org/TRO/",
  "dsd": "https://w3id.org/dsd#",
  "sds": "https://w3id.org/sds#",
  "esc": "https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#",
  "rdawd": "http://rdaregistry.info/Elements/w/datatype/",
  "meat": "http://example.com/",
  "olias": "http://purl.org/olia/system.owl#",
  "bau": "https://terminology.fraunhofer.de/voc/bau#",
  "eb": "https://w3id.org/eb#",
  "gax": "http://w3id.org/gaia-x/core#",
  "godaddy": "https://sso.godaddy.com/",
  "bdsubj": "https://purl.org/fidbaudigital/subjects#",
  "asf": "https://www.stm-assoc.org/asf/",
  "quid": "https://w3id.org/quid/",
  "ghga": "http://w3id.org/ghga/",
  "srtun": "https://www.inf.bi.rub.de/srtun#",
  "kdsf": "https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#",
  "chameo": "https://w3id.org/emmo/domain/characterisation-methodology/chameo#",
  "ldpsc": "https://solid.ti.rw.fau.de/public/ns/stream-containers#",
  "lbds": "https://w3id.org/lbdserver#",
  "ea": "http://eaontology.protect.linkeddata.es/def/",
  "rsx": "http://rdf4j.org/shacl-extensions#",
  "walmart": "https://www.amazon.de/",
  "tern": "https://w3id.org/tern/ontologies/tern/",
  "wfont": "https://w3id.org/wfont#",
  "ofo": "https://w3id.org/ofo#",
  "lbdserver": "https://w3id.org/lbdserver#",
  "archivo": "https://archivo.dbpedia.org/onto#",
  "rto": "https://w3id.org/rail/topo#",
  "conllu": "https://universaldependencies.org/format.html#",
  "ontobras": "http://www.semanticweb.org/fefar/ontologies/ontobras#",
  "magmardl": "http://www.semanticweb.org/magma-core/rdl#",
  "generiek": "https://data.vlaanderen.be/ns/generiek#",
  "osdu": "https://w3id.org/OSDU#",
  "stix": "http://purl.org/cyber/stix#",
  "stirdata": "https://w3id.org/stirdata/vocabulary/",
  "wdno": "http://www.wikidata.org/prop/novalue/",
  "ppeer": "http://parliament.uk/ontologies/peerage/",
  "experts": "http://emmo.info/emmo/application/maeo/experts#",
  "hqdm": "http://www.semanticweb.org/hqdm#",
  "bag2": "http://bag.basisregistraties.overheid.nl/def/bag#",
  "opltw": "http://www.openlinksw.com/schemas/twitter#",
  "dmo": "https://w3id.org/dmo#",
  "linkml": "https://w3id.org/linkml/",
  "fso": "https://w3id.org/fso#",
  "crmsci": "http://www.cidoc-crm.org/extensions/crmsci/",
  "nprl": "http://data.nobelprize.org/resource/laureate/",
  "fpr": "http://www.filmstandards.org/schemas/filmportal_relations#",
  "setl": "http://purl.org/twc/vocab/setl/",
  "rmlt": "http://semweb.mmlab.be/ns/rml-target#",
  "diso": "https://purls.helmholtz-metadaten.de/diso#",
  "express": "https://w3id.org/express#",
  "nomo": "https://nomenclature.info/nom/ontology/",
  "marc": "http://www.loc.gov/MARC21/slim/",
  "rsp": "http://www.researchspace.org/resource/",
  "paam": "https://lod.mediathek-tanz-theater.de/schema/paam/",
  "covido": "https://w3id.org/CovidO#",
  "itcrdf": "http://www.w3.org/2005/11/its/rdf#",
  "rdaeo": "http://rdaregistry.info/Elements/e/object/",
  "lsqr": "http://lsq.aksw.org/",
  "rro": "http://semanticweb.org/patricia/ontologies/rro#",
  "jsonld": "http://www.w3.org/ns/json-ld#",
  "roh": "http://w3id.org/roh#",
  "hni": "https://collectiedata.hetnieuweinstituut.nl/",
  "weki": "https://en.wikipedia.org/wiki/",
  "raum": "https://terminology.fraunhofer.de/voc/raum#",
  "rnce": "https://data.cultureelerfgoed.nl/id/rnce#",
  "ultragaz": "https://ultragaz24horas.com/",
  "pgo": "http://ii.uwb.edu.pl/pgo#",
  "kgi": "http://ns.inria.fr/kg/index#",
  "value": "http://gfgfd.vs/",
  "chemrof": "https://w3id.org/chemrof/",
  "rism": "http://rism.online/",
  "lrcommon": "http://landregistry.data.gov.uk/def/common/",
  "linkedart": "https://linked.art/ns/terms/",
  "tempo": "http://purl.org/tempo/",
  "besluitvor": "https://data.vlaanderen.be/ns/besluitvorming#",
  "iddo": "https://w3id.org/iddo#",
  "respond": "https://w3id.org/respond#",
  "chess": "http://purl.org/NET/rdfchess/ontology/",
  "vl": "https://version.link/",
  "consolid": "https://w3id.org/consolid#",
  "cido": "http://purl.obolibrary.org/obo/cido.owl/",
  "gufo": "http://purl.org/nemo/gufo#",
  "dsi": "https://data.dsi.omgeving.vlaanderen.be/ns/dsi#",
  "nom": "https://nomenclature.info/nom/",
  "osmo": "https://purl.org/vimmp/osmo#",
  "film": "http://semantics.id/ns/example/film/",
  "icon": "https://w3id.org/icon/ontology/",
  "vntourism": "http://www.semanticweb.org/minhn/ontologies/2021/0/vntourism#",
  "bp3": "http://www.biopax.org/release/biopax-level3.owl#",
  "rtedurp": "http://purl.org/eduo/rtedurp/",
  "grscicoll": "https://www.gbif.org/grscicoll/collection/",
  "gql": "http://www.openlinksw.com/schemas/graphql#",
  "peco": "https://w3id.org/peco#",
  "rcgs": "https://collection.rcgs.jp/terms/",
  "ttrpg": "https://w3id.org/TTRpg#",
  "mondo": "http://purl.obolibrary.org/obo/MONDO_",
  "robotarm": "https://solid.ti.rw.fau.de/public/ns/robotArm#",
  "relation": "http://www.iana.org/assignments/relation/",
  "cvb": "http://rdfs.org/resume-rdf/base.rdfs#",
  "veelana": "http://onlyfans.com/veelana/",
  "spatialf": "http://jena.apache.org/function/spatial#",
  "pubchem": "https://pubchem.ncbi.nlm.nih.gov/",
  "aec3po": "https://w3id.org/lbd/aec3po/",
  "perscido": "https://perscido.univ-grenoble-alpes.fr/",
  "apods": "http://activitypods.org/ns/core#",
  "dbd": "http://dbpedia.org/datatype/",
  "nen2660": "https://w3id.org/nen2660/def#",
  "raad": "https://raadzaam.nl/schema/",
  "kokot": "http://www.koko.t/",
  "fdp": "https://w3id.org/fdp/fdp-o#",
  "dqvno": "https://data.norge.no/vocabulary/dqvno#",
  "vhbieo": "https://w3id.org/vhbieo#",
  "yanice": "http://yanice-boady.webflow.io/",
  "version": "https://version.link/",
  "era": "http://data.europa.eu/949/",
  "iottta": "https://w3id.org/iot-tta#",
  "nalt": "https://lod.nal.usda.gov/nalt/",
  "bmp": "http://w3id.org/bmp#",
  "dcb": "http://dbpedia.org/resource/Category:",
  "lis": "http://rds.posccaesar.org/ontology/lis14/rdl/",
  "skosm": "http://www.w3.org/2004/02/skos/mapping#",
  "ufo": "http://ufo.com/#",
  "coy": "https://schema.coypu.org/global#",
  "lol": "https://sbalot.github.io/lol/",
  "docbook": "http://docbook.org/ns/docbook/",
  "epo": "http://data.europa.eu/a4g/ontology#",
  "bto": "http://w3id.org/emmo-bto/bto#",
  "plant": "http://example.org/plant/",
  "fdof": "https://w3id.org/fdof/ontology#",
  "bcgo": "http://purl.obolibrary.org/obo/ZP_",
  "emmo": "https://w3id.org/emmo#",
  "dcatno": "https://data.norge.no/vocabulary/dcatno#",
  "thub": "http://vocabularis.crai.ub.edu/thub/",
  "hmas": "https://purl.org/hmas/",
  "mi": "http://www.marineinfo.org/ns/ontology#",
  "dcatap": "http://data.europa.eu/r5r/",
  "ecfo": "https://w3id.org/ecfo#",
  "fs": "https://www.compliancequest.com/training-management-software-system-solutions/",
  "nutscode": "http://data.europa.eu/nuts/code/",
  "dbpg": "http://dbpedia.org/page/",
  "vcs": "https://data.vlaanderen.be/ns/chemische_stof#",
  "dick": "http://pornhub.com/",
  "ontouml": "https://w3id.org/ontouml#",
  "wrroc": "https://w3id.org/ro/terms/workflow-run#",
  "asb": "https://w3id.org/asbingowl/core#",
  "to": "http://purl.obolibrary.org/obo/TO_",
  "ags": "https://id.agschemas.org/",
  "ammo": "http://ldf.fi/schema/ammo/",
  "hyr": "https://w3id.org/simulation/data/",
  "threat": "https://cve.mitre.org/",
  "coreo": "http://purl.org/coreo#",
  "goavoc": "http://bio2rdf.org/goa_vocabulary:",
  "atcc": "https://www.atcc.org/products/",
  "acp": "http://www.w3.org/ns/solid/acp#",
  "cur": "http://qudt.org/2.1/vocab/currency/",
  "ntp": "https://schema.finto.fi/ntp#",
  "risk": "https://www.w3id.org/risk#",
  "pico": "https://personsincontext.org/model#",
  "iop": "https://w3id.org/iadopt/ont/",
  "matmine": "http://materialsmine.org/ns/",
  "coos": "http://id.unece.org/def/coos#",
  "baf": "https://w3id.org/baf#",
  "lcnaf": "http://id.loc.gov/authorities/names/",
  "imbor": "https://data.crow.nl/imbor/def/",
  "egdo": "http://example.org/",
  "databus": "https://dataid.dbpedia.org/databus#",
  "mibc": "http://marineinfo.org/ns/library/bibcodes#",
  "bacnet": "http://data.ashrae.org/bacnet/2020#",
  "tsso": "https://scch.org/technical_standards#",
  "sense": "https://w3id.org/sense#",
  "p2po": "https://purl.org/p2p-o#",
  "ksamsok": "http://kulturarvsdata.se/ksamsok#",
  "ind": "https://w3id.org/inesdata#",
  "ceox": "https://linkeddata.cultureelerfgoed.nl/def/ceox#",
  "hu": "https://mail.google.com/",
  "uio": "https://www.mitre.org/mparmelee/ontologies/2023/6/UserIntentOntology/",
  "mindat": "https://www.mindat.org/",
  "keyon": "http://keyelements.ltd/ontologies/keyon/#",
  "rb": "https://w3id.org/riverbench/schema/metadata#",
  "quest": "https://rb.gy/ntg7l/",
  "coda": "http://art.uniroma2.it/coda/contracts/",
  "ogcf": "http://www.opengis.net/def/function/geosparql/",
  "fisa": "https://ifitkau.github.io/fisa/",
  "mibt": "https://marineinfo.org/ns/library/bibtypes#",
  "ocmv": "https://w3id.org/ontouml-models/vocabulary#",
  "pit": "http://data.elsevier.com/vocabulary/ElsevierPubItemTypes/",
  "bsdd": "http://bsdd.buildingsmart.org/def#",
  "exekg": "https://raw.githubusercontent.com/nsai-uio/ExeKGOntology/main/ds_exeKGOntology.ttl#",
  "into": "https://app.korfin.de/ontology/into/",
  "bioschemas": "https://bioschemas.org/",
  "koko": "https://seznam.cz/",
  "cpsvno": "http://data.norge.no/vocabulary/cpsvno#",
  "rbdoc": "https://w3id.org/riverbench/schema/documentation#",
  "sssom": "https://w3id.org/sssom/",
  "coswot": "https://w3id.org/coswot/",
  "notify": "http://www.w3.org/ns/solid/notifications#",
  "doce": "http://purl.org/nemo/doce#",
  "cercabib": "https://cercabib.ub.edu/",
  "hy": "https://api.hyprdia.com/",
  "mifesto": "https://w3id.org/mifesto#",
  "semapv": "https://w3id.org/semapv/vocab/",
  "lpwcc": "https://linkedpaperswithcode.com/class/",
  "ncbi": "https://www.ncbi.nlm.nih.gov/",
  "pbac": "https://w3id.org/pbac#",
  "cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties/",
  "mpio": "http://purl.obolibrary.org/obo/ZP_",
  "plasma": "https://w3id.org/plasma#",
  "w3": "http://www.w3.org/",
  "doam": "http://emmo.info/doam#",
  "dde": "https://www.ddeworld.org/",
  "quit": "http://quit.aksw.org/vocab/",
  "ontologia": "http://ub.edu/dades/ontologia/Cinema#Cinemes#",
  "ontohgis": "https://onto.kul.pl/ontohgis/",
  "ioc": "http://w3id.org/ioc#",
  "pdumdv": "http://purl.obolibrary.org/obo/PdumDv_",
  "battery": "https://w3id.org/emmo/domain/battery/battery#",
  "skosno": "http://data.norge.no/skosno#",
  "hsapdv": "http://purl.obolibrary.org/obo/HsapDv_",
  "top": "http://w3id.org/topologicpy#",
  "mfo": "http://purl.obolibrary.org/obo/ZP_",
  "nmr": "https://www.ebi.ac.uk/ols4/ontologies/nmrcv/terms?short_form=NMR:",
  "sri": "https://w3id.org/sri#",
  "oplben": "http://www.openlinksw.com/ontology/benefits#",
  "pcp": "https://pcp-on-web.de/ontology/0.2/index-en.html#",
  "isoprops": "https://w3id.org/isoprops#",
  "ohd": "http://purl.obolibrary.org/obo/ZP_",
  "sure": "http://ns.inria.fr/sure#",
  "interpro": "https://www.ebi.ac.uk/interpro/entry/InterPro/",
  "batmanont": "http://emmo.info/emmo/application/bmo#",
  "loggerhead": "http://purl.obolibrary.org/obo/LOGGERHEAD_",
  "mir": "http://marineinfo.org/ns/person/roles#",
  "chpaf": "https://ch.paf.link/",
  "ies": "http://ies.data.gov.uk/ontology/ies4#",
  "oav": "http://lod.openaire.eu/vocab/",
  "ies4": "http://ies.data.gov.uk/ontology/ies4#",
  "lpwc": "https://linkedpaperswithcode.com/property/",
  "ornaseq": "http://purl.obolibrary.org/obo/ORNASEQ_",
  "gramene": "http://www.gramene.org/db/ontology/search?id=GRO:",
  "htn": "http://purl.obolibrary.org/obo/ZP_",
  "hom": "http://purl.obolibrary.org/obo/HOM_",
  "eurovoc": "http://eurovoc.europa.eu/",
  "upheno": "http://purl.obolibrary.org/obo/UPHENO_",
  "maeo": "http://w3id.org/emmo-maeo/maeo#",
  "sbo": "https://paul.ti.rw.fau.de/~jo00defe/ble/sbo#",
  "clyh": "http://purl.obolibrary.org/obo/ZP_",
  "fro": "https://foundry.ai.mil/ontology/nas/fro/",
  "ddpheno": "http://purl.obolibrary.org/obo/DDPHENO_",
  "apollosv": "http://purl.obolibrary.org/obo/APOLLO_SV_",
  "proco": "http://purl.obolibrary.org/obo/PROCO_",
  "przecieki": "http://onlyfans.com/emiliaszymanska/",
  "cred": "https://www.w3.org/2018/credentials#",
  "sep": "http://purl.obolibrary.org/obo/ZP_",
  "openwemi": "https://ns.dublincore.org/openwemi/",
  "sopharm": "http://purl.obolibrary.org/obo/SOPHARM_",
  "fovt": "http://purl.obolibrary.org/obo/FOVT_",
  "tdm": "http://www.w3.org/ns/tdmrep#",
  "cergy": "https://dbpedia.org/page/Cergy/",
  "kbmarc": "https://id.kb.se/marc/",
  "imdb": "http://m.imdb.com/",
  "olis": "http://olis.dev/",
  "iig": "https://w3id.org/iicongraph/data/",
  "msl": "https://w3id.org/msl#",
  "nyon": "https://w3id.org/def/nyon#",
  "wbls": "http://purl.obolibrary.org/obo/WBls_",
  "soa": "https://semopenalex.org/ontology/",
  "vt": "http://purl.obolibrary.org/obo/VT_",
  "cob": "http://purl.obolibrary.org/obo/COB_",
  "jps": "https://jpsearch.go.jp/term/property#",
  "htv": "http://www.w3.org/2011/http#",
  "gallont": "http://purl.obolibrary.org/obo/GALLONT_",
  "iptc4xmpc": "http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/",
  "mro": "http://purl.obolibrary.org/obo/MRO_",
  "capdata": "https://ontologie.capdataculture.fr/v1/owl/#",
  "lpto": "http://w3id.org/lpto#",
  "mao": "https://domestic-beethoven.eu/ontology/1.0/music-annotation-ontology.ttl#",
  "mee": "http://www.w3.org/ns/pim/meeting#",
  "taxrank": "http://purl.obolibrary.org/obo/TAXRANK_",
  "credit": "https://credit.niso.org/",
  "oplmarket": "http://www.openlinksw.com/ontology/market#",
  "iceo": "http://purl.obolibrary.org/obo/ICEO_",
  "loinc": "https://loinc.org/",
  "osh": "https://w3id.org/oseg/ont/osh#",
  "shsh": "http://www.w3.org/ns/shacl-shacl#",
  "doid": "http://purl.obolibrary.org/obo/DOID_",
  "occupation": "http://nikunj.org/ontology/occupatioin#",
  "deonta": "https://deonta.linkedmodel.org/deonta/",
  "dgaterms": "https://w3id.org/dgaterms#",
  "dcid": "https://datacommons.org/browser/",
  "gecko": "http://purl.obolibrary.org/obo/ZP_",
  "planp": "http://purl.obolibrary.org/obo/PLANP_",
  "echem": "https://w3id.org/emmo/domain/electrochemistry#",
  "aao": "http://purl.obolibrary.org/obo/AAO_",
  "emap": "http://purl.obolibrary.org/obo/EMAP_",
  "vhog": "http://purl.obolibrary.org/obo/VHOG_",
  "hao": "http://purl.obolibrary.org/obo/HAO_",
  "mop": "http://purl.obolibrary.org/obo/MOP_",
  "geolink": "http://schema.geolink.org/1.0/base/main#",
  "chems": "https://w3id.org/emmo/domain/chemical-substance#",
  "obi": "http://purl.obolibrary.org/obo/OBI_",
  "lrm": "https://iflastandards.info/ns/lrm/lrmoo/",
  "okh": "https://w3id.org/oseg/ont/okh#",
  "propreo": "http://purl.obolibrary.org/obo/PROPREO_",
  "fbdv": "http://purl.obolibrary.org/obo/FBdv_",
  "fbcv": "http://purl.obolibrary.org/obo/FBcv_",
  "clao": "http://purl.obolibrary.org/obo/CLAO_",
  "mco": "http://purl.obolibrary.org/obo/MCO_",
  "spd": "http://purl.obolibrary.org/obo/SPD_",
  "fbbt": "http://purl.obolibrary.org/obo/FBbt_",
  "apmwg": "http://apmwg.ovh/",
  "liph": "https://gallosiciliani.unict.it/ns/lpont#",
  "cmf": "http://purl.obolibrary.org/obo/CMF_",
  "sibo": "http://purl.obolibrary.org/obo/ZP_",
  "omo": "http://purl.obolibrary.org/obo/OMO_",
  "firebim": "http://w3id.org/firebim#",
  "maid": "https://mutual-aid.app/ns/core#",
  "foaa": "https://kibanshoe.com/",
  "hpo": "http://w3id.org/emmo-hpo/hpo#",
  "oio": "http://www.geneontology.org/formats/oboInOwl#",
  "mbl": "https://w3id.org/mbl#",
  "qualityze": "https://www.qualityze.com/document-management/",
  "crmgeo": "http://www.ics.forth.gr/isl/CRMgeo/",
  "spo": "https://w3id.org/steel/ProcessOntology/",
  "schemas": "https://schema.org/",
  "idomal": "http://purl.obolibrary.org/obo/IDOMAL_",
  "tops": "http://www.topbraid.org/tops#",
  "sepio": "http://purl.obolibrary.org/obo/SEPIO_",
  "ons": "http://purl.obolibrary.org/obo/ONS_",
  "meas": "https://graph.interoptx.org/meas/",
  "tsdcreq": "https://w3id.org/oseg/ont/tsdc/req#",
  "uo": "http://purl.obolibrary.org/obo/UO_",
  "foodon": "http://purl.obolibrary.org/obo/FOODON_",
  "ecocore": "http://purl.obolibrary.org/obo/ECOCORE_",
  "cvdo": "http://purl.obolibrary.org/obo/CVDO_",
  "ogsf": "http://purl.obolibrary.org/obo/OGSF_",
  "pao": "http://purl.obolibrary.org/obo/PAO_",
  "aimaix": "https://w3id.org/aimaix#",
  "dpo": "http://purl.obolibrary.org/obo/FBcv_",
  "ontoavida": "http://purl.obolibrary.org/obo/ONTOAVIDA_",
  "fiaf": "https://ontology.fiafcore.org/",
  "ecp": "http://www.ebu.ch/metadata/ontologies/ebucoreplus#",
  "imr": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IMR&id=",
  "ovae": "http://purl.obolibrary.org/obo/OVAE_",
  "tto": "http://purl.obolibrary.org/obo/TTO_",
  "clo": "http://purl.obolibrary.org/obo/ZP_",
  "uiot": "http://www.w3id.org/urban-iot/core#",
  "rxno": "http://purl.obolibrary.org/obo/ZP_",
  "mfoem": "http://purl.obolibrary.org/obo/MFOEM_",
  "cwo": "http://kcoyle.net/cwo/",
  "gtm": "https://www.goudatijdmachine.nl/def#",
  "miprog": "https://marineinfo.org/ns/progress#",
  "dictionary": "https://standards.buildingsmart.org/DataDictionary/",
  "duo": "http://purl.obolibrary.org/obo/DUO_",
  "edtf": "http://id.loc.gov/datatypes/EDTFScheme/",
  "bcnres": "http://datos.bcn.cl/ontologies/bcn-resources#",
  "multionto": "http://purl.org/net/multionto/",
  "mat": "http://purl.obolibrary.org/obo/MAT_",
  "stroke": "https://mre.zcu.cz/ontology/stroke.owl#",
  "pgdso": "http://purl.obolibrary.org/obo/PGDSO_",
  "cacax": "http://cacax.fun/",
  "guez": "http://guez.fr/",
  "crcr": "https://credit.niso.org/contributor-roles/",
  "obom": "https://w3id.org/open-bom/ont/open-bom#",
  "xco": "http://purl.obolibrary.org/obo/XCO_",
  "hht": "https://w3id.org/HHT#",
  "bootstrep": "http://purl.obolibrary.org/obo/BOOTSTREP_",
  "libeas": "https://w3id.org/libeas#",
  "bspo": "http://purl.obolibrary.org/obo/BSPO_",
  "ncro": "http://purl.obolibrary.org/obo/NCRO_",
  "vair": "https://w3id.org/vair#",
  "pwkso": "http://ns.inria.fr/pwkso/",
  "geogeo": "http://purl.obolibrary.org/obo/GEO_",
  "ohpi": "http://purl.obolibrary.org/obo/OHPI_",
  "symp": "http://purl.obolibrary.org/obo/SYMP_",
  "mpath": "http://purl.obolibrary.org/obo/MPATH_",
  "xao": "http://purl.obolibrary.org/obo/XAO_",
  "tsdc": "https://w3id.org/oseg/ont/tsdc/core#",
  "emobon": "http://www.embrc.eu/emobon/EmoBonOntology#",
  "tgma": "http://purl.obolibrary.org/obo/TGMA_",
  "after": "http://rds.posccaesar.org/ontology/plm/ds/",
  "mfomd": "http://purl.obolibrary.org/obo/MFOMD_",
  "qcy": "https://qaecy.com/dev/ont#",
  "oba": "http://purl.obolibrary.org/obo/OBA_",
  "mmusdv": "http://purl.obolibrary.org/obo/MmusDv_",
  "eupath": "http://purl.obolibrary.org/obo/EUPATH_",
  "amv": "https://w3id.org/amv/",
  "joe": "http://example.org/joe/",
  "duodrl": "https://w3id.org/duodrl#",
  "labo": "http://purl.obolibrary.org/obo/LABO_",
  "nihss": "https://mre.zcu.cz/ontology/nihss.owl#",
  "otrl": "https://w3id.org/oseg/ont/otrl#",
  "cams": "https://graph.interoptx.org/cams/schema/",
  "ypc": "http://www.semanticweb.org/sunsr/ontologies/2024/ypc#",
  "pa": "http://vtw.elsevier.com/data/ns/properties/PromotionalAccess-1/",
  "ehdaa": "http://purl.obolibrary.org/obo/EHDAA_",
  "gsso": "http://purl.obolibrary.org/obo/GSSO_",
  "zea": "http://purl.obolibrary.org/obo/ZEA_",
  "apo": "http://purl.obolibrary.org/obo/APO_",
  "moont": "https://w3id.org/moont/",
  "termdat": "https://register.ld.admin.ch/termdat/",
  "edo": "http://semanticweb.org/edo#",
  "chmo": "http://purl.obolibrary.org/obo/CHMO_",
  "lipro": "http://purl.obolibrary.org/obo/LIPRO_",
  "opmi": "http://purl.obolibrary.org/obo/OPMI_",
  "ckg": "http://example.org/ckg#",
  "luffy": "http://google.com/",
  "hancestro": "http://purl.obolibrary.org/obo/HANCESTRO_",
  "txpo": "http://purl.obolibrary.org/obo/ZP_",
  "cteno": "http://purl.obolibrary.org/obo/CTENO_",
  "dprod": "https://ekgf.github.io/dprod/",
  "pdro": "http://purl.obolibrary.org/obo/PDRO_",
  "ogms": "http://purl.obolibrary.org/obo/OGMS_",
  "ico": "http://purl.obolibrary.org/obo/ICO_",
  "chiro": "http://purl.obolibrary.org/obo/CHIRO_",
  "amphx": "http://purl.obolibrary.org/obo/AMPHX_",
  "ceph": "http://purl.obolibrary.org/obo/CEPH_",
  "flopo": "http://purl.obolibrary.org/obo/FLOPO_",
  "pcl": "http://purl.obolibrary.org/obo/PCL_",
  "dideo": "http://purl.obolibrary.org/obo/DIDEO_",
  "biomodels": "http://purl.obolibrary.org/obo/KISAO_",
  "adw": "https://animaldiversity.org/accounts/",
  "spa": "https://paul.ti.rw.fau.de/~jo00defe/voc/spa#",
  "disdriv": "http://purl.obolibrary.org/obo/DISDRIV_",
  "vario": "http://purl.obolibrary.org/obo/VariO_",
  "ogg": "http://purl.obolibrary.org/obo/OGG_",
  "pw": "http://purl.obolibrary.org/obo/PW_",
  "vbo": "http://purl.obolibrary.org/obo/VBO_",
  "dop": "https://w3id.org/dob/voc/prop#",
  "flu": "http://purl.obolibrary.org/obo/FLU_",
  "cr": "http://mlcommons.org/croissant/",
  "oplmark": "http://www.openlinksw.com/ontology/market#",
  "pes": "https://semanticweb.inesctec.pt/ontologies/pes/",
  "did": "https://w3id.org/dob/id/",
  "norse": "https://w3id.org/aksw/norse#",
  "oplgit": "http://www.openlinksw.com/schemas/github#",
  "bila": "http://4dx.embl.de/4DXpress/reg/all/cview/gene.do?geneID=",
  "oarcs": "http://purl.obolibrary.org/obo/OARCS_",
  "lepao": "http://purl.obolibrary.org/obo/LEPAO_",
  "psdo": "http://purl.obolibrary.org/obo/PSDO_",
  "aio": "https://paul.ti.rw.fau.de/~jo00defe/SemWoT/aio#",
  "oostt": "http://purl.obolibrary.org/obo/OOSTT_",
  "rdfl": "https://w3id.org/rdf-lens/ontology#",
  "whyis": "http://vocab.rpi.edu/whyis/",
  "fix": "http://purl.obolibrary.org/obo/FIX_",
  "ehdaa2": "http://purl.obolibrary.org/obo/EHDAA2_",
  "nomen": "http://purl.obolibrary.org/obo/NOMEN_",
  "fbbi": "http://purl.obolibrary.org/obo/FBbi_",
  "crdt": "https://vocab.noeldemartin.com/crdt/",
  "omrse": "http://purl.obolibrary.org/obo/OMRSE_",
  "omit": "http://purl.obolibrary.org/obo/OMIT_",
  "tahe": "http://purl.obolibrary.org/obo/TAHE_",
  "slso": "http://purl.obolibrary.org/obo/SLSO_",
  "psn": "https://purl.org/psn/vocab#",
  "nyanneko": "https://nyanneko.com/",
  "occo": "http://purl.obolibrary.org/obo/OCCO_",
  "ypo": "http://purl.obolibrary.org/obo/YPO_",
  "tahh": "http://purl.obolibrary.org/obo/TAHH_",
  "loin": "http://w3id.org/loin#",
  "cmso": "http://purls.helmholtz-metadaten.de/cmso/",
  "aix": "https://w3id.org/aix#",
  "makeup": "http://example.org/makeup#",
  "ado": "http://purl.obolibrary.org/obo/ADO_",
  "oplog": "http://www.openlinksw.com/schemas/opengraph#",
  "mcro": "https://www.ebi.ac.uk/ols4/ontologies/mcro/classes?obo_id=MCRO:",
  "envo": "http://purl.obolibrary.org/obo/ENVO_",
  "tads": "http://purl.obolibrary.org/obo/TADS_",
  "lrmer": "http://iflastandards.info/ns/lrm/lrmer/",
  "cdno": "http://purl.obolibrary.org/obo/CDNO_",
  "dob": "https://w3id.org/dob/voc#",
  "airo": "https://w3id.org/airo#",
  "musi": "http://i-na-reg.musikinstrumentenbau.eu/ns/musi/",
  "ceosp": "https://linkeddata.cultureelerfgoed.nl/def/ceosp/",
  "rmle": "https://w3id.org/imec/rml/ns/extensions#",
  "zfa": "http://purl.obolibrary.org/obo/ZFA_",
  "ohmi": "http://purl.obolibrary.org/obo/OHMI_",
  "wbbt": "http://purl.obolibrary.org/obo/WBbt_",
  "vsao": "http://purl.obolibrary.org/obo/VSAO_",
  "eo": "http://purl.obolibrary.org/obo/EO_",
  "geno": "http://purl.obolibrary.org/obo/GENO_",
  "ogi": "http://purl.obolibrary.org/obo/OGI_",
  "ror": "https://ror.org/",
  "zeco": "http://purl.obolibrary.org/obo/ZECO_",
  "dinto": "http://purl.obolibrary.org/obo/ZP_",
  "ehda": "http://purl.obolibrary.org/obo/EHDA_",
  "upa": "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=",
  "plana": "http://purl.obolibrary.org/obo/PLANA_",
  "olatdv": "http://purl.obolibrary.org/obo/OlatDv_",
  "t4fs": "http://purl.obolibrary.org/obo/T4FS_",
  "npc": "https://purl.org/npc#",
  "afpo": "http://purl.obolibrary.org/obo/AfPO_",
  "vto": "http://purl.obolibrary.org/obo/VTO_",
  "fbsp": "http://purl.obolibrary.org/obo/FBSP_",
  "scdo": "http://purl.obolibrary.org/obo/SCDO_",
  "reloc": "https://w3id.org/reloc#",
  "epio": "http://purl.obolibrary.org/obo/EPIO_",
  "dblpdocu": "https://dblp.org/rdf/docu/#",
  "graphql": "https://graphql.org/",
  "fobi": "http://purl.obolibrary.org/obo/FOBI_",
  "vo": "http://purl.obolibrary.org/obo/VO_",
  "omiabis": "http://purl.obolibrary.org/obo/OMIABIS_",
  "miron": "https://stgermain.ebsi.umontreal.ca/miron/",
  "colao": "http://purl.obolibrary.org/obo/COLAO_",
  "oplic": "http://www.openlinksw.com/ontology/licenses#",
  "cfg": "http://server.topbraidlive.org/web/2009/config#",
  "cio": "http://purl.obolibrary.org/obo/CIO_",
  "hso": "http://purl.obolibrary.org/obo/HSO_",
  "psm": "https://paul.ti.rw.fau.de/~jo00defe/ont/psm#",
  "genepio": "http://purl.obolibrary.org/obo/GENEPIO_",
  "vwlid": "https://vwgroup.leanix.net/Volkswagen/external/leanixId/",
  "ato": "http://purl.obolibrary.org/obo/ATO_",
  "obcs": "http://purl.obolibrary.org/obo/OBCS_",
  "mfmo": "http://purl.obolibrary.org/obo/MFMO_",
  "womo": "https://w3id.org/womo#",
  "fypo": "http://purl.obolibrary.org/obo/FYPO_",
  "zp": "http://purl.obolibrary.org/obo/ZP_",
  "ssv": "https://w3id.org/ssv/",
  "miapa": "http://purl.obolibrary.org/obo/MIAPA_",
  "dtkt": "https://data.wikitrek.org/prop/direct/",
  "gno": "http://purl.obolibrary.org/obo/GNO_",
  "geosrs": "https://w3id.org/geosrs#",
  "jabel54303": "https://softwarehorsepower.com/product/brand24/",
  "oip": "http://www.exemple.org/ontologia/",
  "volipi": "http://data.sparna.fr/ontologies/volipi#",
  "zfs": "http://purl.obolibrary.org/obo/ZFS_",
  "gaz": "http://purl.obolibrary.org/obo/GAZ_",
  "maxo": "http://purl.obolibrary.org/obo/MAXO_",
  "freespins": "https://bohoaff.com/a34fd6fba/",
  "mpbv": "http://meta-pfarrerbuch.evangelische-archive.de/vocabulary#",
  "resid": "https://proteininformationresource.org/cgi-bin/resid?id=",
  "rex": "http://purl.obolibrary.org/obo/REX_",
  "kvasir": "https://kvasir.discover.ilabt.imec.be/vocab#",
  "xpo": "http://purl.obolibrary.org/obo/XPO_",
  "trans": "http://purl.obolibrary.org/obo/TRANS_",
  "iev": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IEV&id=",
  "oplgp": "http://www.openlinksw.com/schemas/googleplus#",
  "micro": "http://purl.obolibrary.org/obo/MICRO_",
  "dron": "http://purl.obolibrary.org/obo/DRON_",
  "aism": "http://purl.obolibrary.org/obo/AISM_",
  "hhtchange": "https://w3id.org/HHT/Change#",
  "aschema": "https://schema.ld.admin.ch/",
  "aero": "http://purl.obolibrary.org/obo/AERO_",
  "tsdcr": "http://w3id.org/oseg/ont/tsdc/requirements#",
  "ftr": "https://w3id.org/ftr#",
  "fair4ml": "https://w3id.org/fair4ml#",
  "jav": "https://www.niso.org/schemas/jav/1.0/",
  "poro": "http://purl.obolibrary.org/obo/PORO_",
  "emapa": "http://purl.obolibrary.org/obo/EMAPA_",
  "ino": "http://purl.obolibrary.org/obo/INO_",
  "cdi": "http://ddialliance.org/Specification/DDI-CDI/1.0/RDF/",
  "oix": "http://www.exemple.org/ontologia/",
  "codemeta": "https://codemeta.github.io/terms/",
  "zo": "https://linkeddata.cultureelerfgoed.nl/def/zo/",
  "ddanat": "http://purl.obolibrary.org/obo/DDANAT_",
  "ecao": "http://purl.obolibrary.org/obo/ECAO_",
  "stato": "http://purl.obolibrary.org/obo/STATO_",
  "miro": "http://purl.obolibrary.org/obo/MIRO_",
  "myv": "http://www.example.com/myvData/",
  "checks": "https://data.digichecks.eu/def/",
  "xlmod": "http://purl.obolibrary.org/obo/XLMOD_",
  "fideo": "http://purl.obolibrary.org/obo/FIDEO_",
  "phipo": "http://purl.obolibrary.org/obo/PHIPO_",
  "creon": "http://purl.org/creon/",
  "obib": "http://purl.obolibrary.org/obo/OBIB_",
  "rnao": "http://purl.obolibrary.org/obo/RNAO_",
  "caro": "http://purl.obolibrary.org/obo/CARO_",
  "gsn": "https://w3id.org/OntoGSN/ontology#",
  "aicat": "http://w3id.org/aicat#",
  "ngbo": "http://purl.obolibrary.org/obo/NGBO_",
  "dtk": "https://data.wikitrek.org/entity/",
  "sn": "https://purl.org/supply-network/onto#",
  "ce": "https://purl.org/cityexplorer#",
  "ceon": "http://w3id.org/CEON/",
  "aiup": "http://w3id.org/aiup#",
  "onlyfans": "https://cutt.ly/3ry8LMcK/",
  "frac": "http://www.w3.org/ns/lemon/frac#",
  "ecto": "http://purl.obolibrary.org/obo/ECTO_",
  "mirnao": "http://purl.obolibrary.org/obo/MIRNAO_",
  "nace2": "http://data.europa.eu/ux2/nace2/",
  "bng": "https://w3id.org/dob/voc/epsg-27700#",
  "podio": "http://w3id.org/podio#",
  "northwind": "http://demo.openlinksw.com/schemas/Northwind/",
  "vwlpr": "https://vwgroup.leanix.net/Volkswagen/factsheet/Process/",
  "aro": "http://purl.obolibrary.org/obo/ARO_",
  "azo": "https://linkeddata.cultureelerfgoed.nl/def/azo/",
  "fugas": "https://onlyfans.com/sammuwuu/",
  "encom": "https://semanticweb.inesctec.pt/ontologies/encom/",
  "aeo": "http://purl.obolibrary.org/obo/AEO_",
  "passport": "https://nepalpassport.gov.np/",
  "nsprov": "http://www.w3.org/ns/prov#",
  "fti": "http://franz.com/ns/allegrograph/2.2/textindex/",
  "tgc": "http://www.hds.utc.fr/tg#",
  "vrti": "https://www.w3id.org/virtual-treasury/ontology#",
  "pur": "http://prismstandard.org/namespaces/prismusagerights/2.1/",
  "regcomp": "https://regulacomp.unige.ch/ns/regcomp#",
  "bam": "http://vtw.elsevier.com/data/voc/ns/bam-vtw-1/",
  "vwlap": "https://vwgroup.leanix.net/Volkswagen/factsheet/Application/",
  "spot": "https://w3id.org/spot#",
  "unesco": "http://vocabularies.unesco.org/thesaurus/",
  "ishi": "https://w3id.org/ishikawa-diagram-ontology#",
  "drammar": "http://www.purl.org/drammar#",
  "bambara": "http://example.org/bambara#",
  "tgfm": "http://purl.org/terminology-guide-for-move/testvocab/",
  "arco": "https://w3id.org/arco/ontology/arco/",
  "jats": "http://jats.nlm.nih.gov/",
  "och": "http://w3id.org/def/och/",
  "scdt": "http://w3id.org/awslabs/neptune/SPARQL-CDTs/",
  "lindas": "https://ld.admin.ch/",
  "npo": "https://w3id.org/NPO/ontology/",
  "oqs": "http://purl.org/nsoluti/oqs#",
  "fwo": "https://w3id.org/foodwaste/ontology#",
  "itandrec": "http://www.semanticweb.org/pedri/ontologies/2025/3/IntelligentTourismAndRecommendations#",
  "picom": "https://personsincontext.org/model#",
  "ncl": "https://w3id.org/NCL/ontology/",
  "libro": "https://www.librorum.fr/ontology/",
  "turism": "http://turism.com/",
  "debias": "http://data.europa.eu/c4p/data/",
  "ppm": "https://mestergruppen.no/ontologies/projectproductionmanagement/",
  "know": "https://know.dev/",
  "dsio": "https://ptb.de/si#",
  "icd": "http://purl.bioontology.org/ontology/ICD9CM/",
  "ris": "http://research-info-systems.com/schema/ris/",
  "vwgw": "https://group-wiki.wob.vw.vwg/wikis/pages/viewpage.action?pageId=",
  "sis": "https://ptb.de/sis/",
  "dbpde": "http://de.dbpedia.org/property/",
  "sip": "https://purl.semanticip.org/linked-data/",
  "elsst": "https://elsst.cessda.eu/id/",
  "datmm": "http://id.nlm.nih.gov/datmm/",
  "rbo": "http://purl.obolibrary.org/obo/RBO_",
  "iirds": "http://iirds.tekom.de/iirds#",
  "eliasempre": "https://eliasempresas.com/",
  "riskman": "https://w3id.org/riskman/ontology#",
  "reno": "https://w3id.org/reno#",
  "sulo": "https://w3id.org/sulo/",
  "rdb": "http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#",
  "vm": "http://visual-meaning.com/rdf/",
  "vwdms": "https://vwdmsweb.wob.vw.vwg/groupdms/?docbase=vwdms&locateId=",
  "muno": "https://purl.org/muno/onto/",
  "whu": "http://bdi.whu.edu.cn/",
  "bu": "http://borhan-onto.ir/ontology/upper#",
  "golem": "https://w3id.org/golem/ontology#",
  "genex": "http://purl.org/genex#",
  "semts": "https://w3id.org/semts/ontology#",
  "dqa": "https://w3id.org/DQA#",
  "coso": "http://w3id.org/coso/v1/contaminoso#",
  "ubbont": "http://data.ub.uib.no/ontology/",
  "pmw": "http://ponymusic.wiki/ns#",
  "gro": "http://www.bootstrep.eu/ontology/GRO#",
  "akco": "https://purl.archive.org/akco#",
  "tribont": "https://w3id.org/tribont/core#",
  "piveau": "https://piveau.eu/ns/voc#",
  "coar": "http://purl.org/coar/resource_type/",
  "evorao": "http://w3id.org/evorao/",
  "exmo": "http://purl.obolibrary.org/obo/EXMO_",
  "csro": "https://w3id.org/csro/ontology#",
  "elm": "http://data.europa.eu/snb/model/elm/",
  "rdfc": "https://w3id.org/rdf-connect#",
  "csr": "http://purl.org/org/iode/po/voc/cruise-summary-reports#",
  "dtool": "https://devtoolkit.space/ontology#",
  "dcatde": "http://dcat-ap.de/def/dcatde/",
  "a11y": "http://idpf.org/epub/vocab/package/a11y/#",
  "sz": "https://github.com/senzing-garage/sz-semantics/wiki/ns#",
  "bmont": "http://purl.obolibrary.org/obo/BMONT_",
  "bodi": "http://w3id.org/bodi#",
  "afy": "https://w3id.org/afy#",
  "sdn": "https://ontology.seadatanet.org/#",
  "pghdprovo": "https://w3id.org/pghdprovo#",
  "homoit": "https://homosaurus.org/v4/",
  "lib": "http://purl.org/library/",
  "bno": "https://data.banenor.no/ontology/",
  "modsrdf": "http://www.loc.gov/mods/rdf/v1#",
  "mdcat": "https://w3id.org/mobilitydcat-ap#",
  "tbs": "http://topbraid.org/tbs#",
  "tfn": "https://w3id.org/time-fn#",
  "bnd": "https://data.banenor.no/data/",
  "tensor": "https://w3id.org/rdf-tensor/vocab#",
  "rtm": "http://ontology.railml.org/railtopomodel#",
  "railml3": "http://ontology.railml.org/railml3#",
  "ard": "https://www.stratcom.mil/ontologies/electromagnetic-spectrum/adversary-radar-detection-ontology/",
  "dccs": "https://ptb.de/dccs/",
  "omekas": "http://omeka.org/s/vocabs/o#",
  "lubm": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "rdm": "https://terms.codata.org/rdmt/",
  "geodcatap": "http://data.europa.eu/930/",
  "dpp": "https://ns.verisav.fr/dpp#",
  "aaao": "https://ontology.swissartresearch.net/aaao/",
  "let": "http://uispin.org/let#",
  "submit": "https://ns.verisav.fr/dpp#",
  "dpvpd": "https://w3id.org/dpv/pd#",
  "vlaanderen": "https://data.vlaanderen.be/ns/",
  "iut": "https://cours.iut-orsay.fr/",
  "osmkey": "https://www.openstreetmap.org/wiki/Key:",
  "idtype": "https://data.elsevier.com/e/identifier/",
  "whg": "https://w3id.org/whg/id/",
  "mdo": "http://w3id.org/mdo/",
  "med": "http://data.esante.gouv.fr/ansm/medicament/",
  "plato": "https://w3id.org/plato#",
  "tf": "https://takumifujimoto.com/schema/",
  "mdr": "https://w3id.org/mdr#",
  "mlca": "https://w3id.org/mlca/",
  "coord": "http://qudt.org/vocab/coordinate/",
  "animl": "http://www.w3id.org/animl/ontology/",
  "dbn": "https://www.darrinbaines.org/ns/identity#",
  "gid": "https://inspirewrap.ontologycentral.com/adv/gid/7.1#",
  "i40fd": "http://w3id.org/iaam/i40fd#",
  "riepr": "https://data.riepr.omgeving.vlaanderen.be/ns/riepr#",
  "lth": "https://vocab.lifetidy.com/",
  "puv": "http://data.elsevier.com/publishing/schema/puv/",
  "lack": "https://purl.net/climatesense/lack/ns#",
  "gwn": "https://globalwordnet.github.io/schemas/wn#",
  "mqto": "https://w3id.org/mqto#",
  "statdcatap": "http://data.europa.eu/s1n/",
  "norma": "https://w3id.org/def/norma-o#",
  "aic": "https://w3id.org/aic#",
  "bcore": "https://w3id.org/bcore/",
  "spectra": "https://w3id.org/spectra#",
  "tal": "http://xml.zope.org/namespaces/tal/",
  "lbco": "https://w3id.org/batcat#",
  "multi": "https://semanticweb.tools/ont/multi#",
  "vwag": "https://devstack.vwgroup.com/",
  "ontodic": "http://tecnolettra.uji.es/ontodic#",
  "tfo": "http://opendata.inrae.fr/PO2/Ontology/TransformON/",
  "vwcds": "https://devstack.vwgroup.com/confluence/rest/api/content/",
  "odic": "http://tecnolettra.uji.es/ontodic#",
  "bedo": "https://w3id.org/bedo/",
  "faptica": "https://faptica.com/",
  "aeovis": "https://prismdiscovery.ai/ontology/aeo#",
  "haishutsu": "https://wik.jp/haishutsu/",
  "kasen": "https://wik.jp/kasen/",
  "bedro": "https://w3id.org/bedro/",
  "copi": "https://www.inf.ufrgs.br/ontologies/copi/",
  "fract": "https://w3id.org/refract#",
  "laosez": "https://laos.world/ns/khetsetthakit/",
  "eau": "https://w3id.org/eautonome/",
  "idsa": "https://w3id.org/idsa/core/",
  "sstim": "https://w3id.org/sstim#",
  "uogto": "https://w3id.org/uogto/core#",
  "dengen": "https://wik.jp/dengen/",
  "fairo": "https://w3id.org/fair-o#",
  "wjl": "https://wik.jp/law/ns#",
  "kobutsu": "https://wik.jp/kobutsu/",
  "bousai": "https://wik.jp/bousai/",
  "hon": "https://honoria.co.uk/id/honours#",
  "denchi": "https://wik.jp/denchi/",
  "uogtox": "https://w3id.org/uogto/extensions#",
  "gakkou": "https://wik.jp/gakkou/",
  "smart": "https://w3id.org/standards/smart/ontologies/core/",
  "laokhoueng": "https://laos.world/ns/khoueng/",
  "mnf": "https://w3id.org/imo/manufacturing#",
  "sdc": "https://w3id.org/statbarnsdc#",
  "mim": "http://modellen.mim-standaard.nl/def/mim#",
  "laomuang": "https://laos.world/ns/muang/",
  "tokutei": "https://wik.jp/tokutei/",
  "gijutsu": "https://wik.jp/gijutsu/",
  "laopasa": "https://laos.world/ns/pasa/",
  "campop": "https://w3id.org/campop/",
  "hojin": "https://wik.jp/hojin/",
  "shokugyo": "https://wik.jp/shokugyo/",
  "houki": "https://wik.jp/houki/",
  "laoboun": "https://laos.world/ns/boun/",
  "laosonphao": "https://laos.world/ns/sonphao/",
  "kunishitei": "https://wik.jp/kunishitei/",
  "bsdo": "https://w3id.org/bsdo#",
  "todofuken": "https://wik.jp/todofuken/",
  "jgs": "https://wik.jp/jgs/",
  "hinmoku": "https://wik.jp/hinmoku/",
  "laomoladok": "https://laos.world/ns/moladok/",
  "cbam": "https://wik.jp/cbam/",
  "koyomi": "https://wik.jp/koyomi/",
  "hinshi": "https://wik.jp/hinshi/",
  "kikaku": "https://wik.jp/kikaku/",
  "sangyo": "https://wik.jp/sangyo/",
  "sb": "https://purl.org/supplybench#",
  "rcl": "https://realcharacterlanguage.world/",
  "kagaku": "https://wik.jp/kagaku/",
  "tani": "https://wik.jp/tani/",
  "gsoc": "https://w3id.org/gso/1.0/common/",
  "gsel": "https://w3id.org/gso/1.0/element/",
  "gsmin": "https://w3id.org/gso/1.0/mineral/",
  "smartsh": "https://w3id.org/standards/smart/schema/data/",
  "gscn": "https://w3id.org/gso/1.0/geologiccontact/",
  "pd": "https://w3id.org/dpv/pd#",
  "rewt": "https://w3id.org/rewt/",
  "gsev": "https://w3id.org/gso/1.0/geologicevent/",
  "gsrm": "https://w3id.org/gso/1.0/rockmaterial/",
  "gsfa": "https://w3id.org/gso/1.0/geologicfault/",
  "hanami": "https://hanami.app/ontology#",
  "xwkont": "https://w3id.org/xwkont/core#"
}
